(() => {
  const e = "plekify-command-center-theme",
    t = "overview",
    n = [
      /\bdestination\b/i,
      /\bproperty\b/i,
      /\baccommodation\b/i,
      /\bactivity\b/i,
      /\brestaurant\b/i,
      /\bday\s*tour\b/i,
    ],
    r = [
      /\bcontact\b/i,
      /\bgreeting\b/i,
      /\bmeet(?:\s|-)?and(?:\s|-)?greet\b/i,
      /\bgreeter\b/i,
      /\bguest\s*liaison\b/i,
      /\barrival\s*assist(?:ance)?\b/i,
    ],
    i = [
      /\bairport\b/i,
      /\bairstrip\b/i,
      /\bterminal\b/i,
      /\btransfer\s*hub\b/i,
      /\barrival\s*hall\b/i,
      /\bdeparture\s*hall\b/i,
      /\bgreeting\b/i,
      /\bmeet(?:\s|-)?and(?:\s|-)?greet\b/i,
      /\bimmigration\b/i,
      /\bcustoms\b/i,
    ],
    a = [
      /\bgreeting\b/i,
      /\bmeet(?:\s|-)?and(?:\s|-)?greet\b/i,
      /\bairport\b/i,
      /\bterminal\b/i,
      /\bcheck(?:\s|-)?in\b/i,
      /\barrival\b/i,
      /\bdeparture\b/i,
      /\bporter\b/i,
      /\bassist(?:ance)?\b/i,
    ],
    o = [
      /\bitinerary\b/i,
      /\bcommand(?:\s|-)?center\b/i,
      /\bwetu-itinerary\b/i,
    ],
    c = "wetu-command-center-panel",
    s = {
      accommodation: [
        "accommodation",
        "hotel",
        "lodge",
        "camp",
        "property",
        "check-in",
        "check-out",
      ],
      destination: ["destination", "city", "region", "country", "area"],
      activity: ["activity", "experience", "excursion"],
      "day-tour": ["day tour", "tour", "excursion", "activity"],
      route: ["route", "transfer", "flight", "self-drive", "drive"],
      inline: ["inline", "narrative", "pin"],
    },
    l = {
      "wetu.pin_id": 6,
      "wetu.content_entity_id": 5,
      "wetu_linked_activity.parent_pin_id": 4,
      "wetu_linked_restaurant.parent_pin_id": 4,
      "wetu_linked_spa.parent_pin_id": 4,
      "wetu_collection.parent_pin_id": 3,
      manifest: 2,
      "pin-map": 1,
    },
    d = [
      /\bpulse\s*d\d{1,2}\b/i,
      /\bstreet intel\b/i,
      /\brun sheet\b/i,
      /\bcloseout\s*d\d{1,2}\b/i,
      /\bsnoop cue\b/i,
      /\boperational note\b/i,
      /\bconsultant intelligence\b/i,
      /\bperformance layer\b/i,
      /\bfallback lodges?\b/i,
      /\bplan b activities?\b/i,
      /\bcode\s*d\d{1,2}-[a-z]\b/i,
      /\blane\s*d\d{1,2}-\d+\b/i,
      /^\s*day\s*\d+\s*--/i,
      /\bduplicate operations layer\b/i,
      /\bmirrored source(?:\s+day)?\b/i,
      /\bmirrored handoff(?:\s+day)?\b/i,
      /\bsource contract\b/i,
      /\bsource-only day\b/i,
      /\boperationally complete in the source contract\b/i,
    ],
    m = /\[\[(PLEKIFY_LEG_TITLE|PLEKIFY_DAY_TITLES):([\s\S]*?)\]\]/g,
    u = new Map(),
    p = new Map(),
    g = new Map(),
    y = new Map(),
    v2InspectorMapCache = new WeakMap(),
    f = new WeakMap(),
    h = new WeakSet(),
    S = {
      overlay: null,
      scroller: null,
      track: null,
      previousFocus: null,
      restoreScrollWrapper: null,
      restoreScrollWrapperTop: 0,
      restoreWindowY: 0,
      restoreHtmlOverflow: "",
      restoreBodyOverflow: "",
      openRoot: null,
    },
    b = (e) =>
      String(e || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;"),
    v = (e) => /<\/?[a-z][\s\S]*>/i.test(String(e || "")),
    _ = (e, t) => {
      if (!e || "object" != typeof e) return null;
      const n = e[t];
      return n &&
        "object" == typeof n &&
        Object.prototype.hasOwnProperty.call(n, "value")
        ? n.value
        : (n ?? null);
    },
    T = (e, t) => {
      for (const n of t) {
        const t = _(e, n);
        if (
          !(Array.isArray(t) || (t && "object" == typeof t)) &&
          null != t &&
          "" !== String(t).trim()
        )
          return t;
      }
      return null;
    },
    w = (e, t = 0) => {
      const n = Number.parseInt(String(e ?? ""), 10);
      return Number.isNaN(n) ? t : n;
    },
    k = (e) =>
      String(e || "")
        .replace(/\s+/g, " ")
        .trim(),
    $ = (e) =>
      k(e)
        .replace(/^day\s*\d+\s*[-–—:]+\s*/i, "")
        .replace(/\s*\[[^\]]+\]\s*$/g, "")
        .trim(),
    C = (e) => {
      let t = [];
      if (Array.isArray(e)) t = e;
      else if ("string" == typeof e) {
        const n = e.trim();
        if (n.startsWith("[") && n.endsWith("]"))
          try {
            const e = JSON.parse(n);
            Array.isArray(e) && (t = e);
          } catch {
            t = [n];
          }
        else n.includes("|") ? (t = n.split("|")) : n && (t = [n]);
      }
      return t.map((e) => k(e)).filter(Boolean);
    },
    L = (e) => {
      if (!e) return "";
      try {
        return decodeURIComponent(e);
      } catch (t) {
        return String(e);
      }
    },
    I = (...e) => {
      const t = { legTitle: "", dayTitles: [] };
      for (const n of e) {
        const e = String(n || "");
        if (e)
          for (const n of e.matchAll(new RegExp(m))) {
            const e = n?.[1],
              r = n?.[2] || "";
            if ("PLEKIFY_LEG_TITLE" !== e) {
              if ("PLEKIFY_DAY_TITLES" === e && 0 === t.dayTitles.length) {
                const e = L(r);
                try {
                  const n = JSON.parse(e);
                  t.dayTitles = C(n);
                } catch (n) {
                  t.dayTitles = C(e);
                }
              }
            } else t.legTitle || (t.legTitle = k(L(r)));
          }
      }
      return t;
    },
    N = (e, t, n) => {
      const r = Math.max(1, w(n, 1));
      let i = C(_(e, "day_short_titles") ?? _(e, "dayShortTitles"));
      if (0 === i.length) {
        const t = k(
          T(e, [
            "day_short_title",
            "dayShortTitle",
            "day_shortlabel",
            "dayShortLabel",
          ]) || "",
        );
        t && (i = [t]);
      }
      if (
        (0 === i.length && (i = C(_(e, "day_titles") ?? _(e, "dayTitles"))),
        0 === i.length)
      ) {
        const t = k(T(e, ["day_title", "dayTitle"]) || "");
        t && (i = [t]);
      }
      if ((0 === i.length && (i = C(t)), 0 === i.length)) return [];
      if (i.length >= r) return i.slice(0, r);
      const a = [...i],
        o = i[0];
      for (let e = a.length; e < r; e += 1) a.push(`${o} ${e + 1}`);
      return a;
    },
    P = (e) => {
      const t = String(e || "").trim();
      return t && "None" !== t && "NotProvided" !== t ? t : "";
    },
    x = (e) => {
      if ("boolean" == typeof e) return e;
      const t = String(e || "")
        .trim()
        .toLowerCase();
      return !!t && ["1", "true", "yes", "y", "on"].includes(t);
    },
    A = (e) => {
      let t = e;
      if (t && "object" == typeof t) {
        if (Object.prototype.hasOwnProperty.call(t, "value")) t = t.value;
        else if (Object.prototype.hasOwnProperty.call(t, "pin")) t = t.pin;
        else if (Object.prototype.hasOwnProperty.call(t, "id")) t = t.id;
      }
      const n = String(t ?? "").trim();
      if (!n || /^\[object\s+object\]$/i.test(n)) return "";
      return /^\d+$/.test(n) ? String(Number.parseInt(n, 10)) : n.toLowerCase();
    },
    q = () => ({
      linkedPinsByContext: new Map(),
      introLinkedPins: new Set(),
      introConsumedPins: new Set(),
    }),
    E = (e) => {
      if (!e || "object" != typeof e) return "global";
      const t = String(e.contextKey || "").trim();
      if (t) return t.toLowerCase();
      const n = String(e.legKey || "").trim();
      if (n) return `leg:${n.toLowerCase()}`;
      const r = String(e.scope || "").trim();
      return r ? r.toLowerCase() : "global";
    },
    H = (e = {}) => ({
      scope:
        String(e.scope || "")
          .trim()
          .toLowerCase() || "global",
      legKey: String(e.legKey || "")
        .trim()
        .toLowerCase(),
      contextKey: E(e),
      registry: e.registry && "object" == typeof e.registry ? e.registry : null,
    }),
    D = (...e) => {
      const t = Ce(e);
      return !!t && i.some((e) => e.test(t));
    },
    M = (e) => {
      const t = String(e || "").trim();
      if (!t) return "";
      try {
        const e = new URL(t, window.location.origin).pathname.match(
          /^\/products\/([^/?#]+)/i,
        );
        return e ? decodeURIComponent(e[1]) : "";
      } catch (e) {
        return "";
      }
    },
    j = (e, t = {}) => {
      const n = String(e || "").trim();
      if (!n || !v(n)) return n;
      const r = A(t.pin),
        i = String(t.handle || "")
          .trim()
          .toLowerCase();
      if (!r && !i) return n;
      const a = new DOMParser().parseFromString(`<div>${n}</div>`, "text/html"),
        o = a.body.firstElementChild;
      if (!o) return n;
      const c = Array.from(o.querySelectorAll("a"));
      for (const e of c) {
        const t = A(e.getAttribute("data-command-center-inline-pin") || ""),
          n = String(
            e.getAttribute("data-command-center-inline-product-handle") ||
              M(e.getAttribute("href") || "") ||
              "",
          )
            .trim()
            .toLowerCase();
        if (!((r && t && t === r) || (i && n && n === i))) continue;
        const o = a.createTextNode(e.textContent || "");
        e.replaceWith(o);
      }
      return o.innerHTML;
    },
    R = (e, t = {}) => {
      const n = ((e) =>
        String(e || "")
          .replace(/\{\{PIN:\d+\|([^}]+)\}\}/g, "$1")
          .trim())(Y(e));
      if (!n) return "";
      const r = j(n, t);
      if (!r) return "";
      if (!v(r)) return r.replace(/\s+/g, " ").trim();
      const i = new DOMParser().parseFromString(`<div>${r}</div>`, "text/html");
      return String(i.body.textContent || "")
        .replace(/\s+/g, " ")
        .trim();
    },
    B = (e) => {
      const t = U(e);
      for (const e of t) {
        if (!e || "object" != typeof e) continue;
        const t = T(e, ["url", "src", "href", "image_url", "imageUrl"]);
        if (t) return String(t).trim();
        const n =
          e.image && "object" == typeof e.image
            ? T(e.image, ["url", "src", "href"])
            : "";
        if (n) return String(n).trim();
      }
      return "";
    },
    O = (e, t, n = "Any time") => {
      const r = P(e),
        i = P(t);
      return r && i
        ? `${r} - ${i}`
        : r || i || String(n || "").trim() || "Any time";
    },
    U = (e) => {
      if (Array.isArray(e)) return e;
      if ("string" == typeof e) {
        const t = e.trim();
        if (!t) return [];
        try {
          const e = JSON.parse(t);
          return Array.isArray(e) ? e : [];
        } catch (e) {
          return [];
        }
      }
      return [];
    },
    F = (e) =>
      String(e || "")
        .replace(/[_]+/g, " ")
        .replace(/\s+/g, " ")
        .trim(),
    K = (e) => {
      const t = F(e);
      return t
        ? t.length > 2 && t === t.toUpperCase()
          ? t.toLowerCase().replace(/\b[a-z]/g, (e) => e.toUpperCase())
          : t
        : "";
    },
    G = (e) =>
      F(e)
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, " ")
        .trim(),
    W = (e) => {
      const t = [],
        n = (e) => {
          if (null == e) return;
          if (Array.isArray(e)) {
            for (const t of e) n(t);
            return;
          }
          if (e && "object" == typeof e)
            return Object.prototype.hasOwnProperty.call(e, "value")
              ? void n(e.value)
              : Object.prototype.hasOwnProperty.call(e, "name")
                ? void n(e.name)
                : void 0;
          const r = String(e || "").trim();
          if (r) {
            if (
              (r.startsWith("[") && r.endsWith("]")) ||
              (r.startsWith("{") && r.endsWith("}"))
            )
              try {
                return void n(JSON.parse(r));
              } catch (e) {}
            if (/[,|\n;]/.test(r))
              for (const e of r.split(/[,|\n;]/)) {
                const n = e.trim();
                n && t.push(n);
              }
            else t.push(r);
          }
        };
      return (n(e), t);
    },
    Y = (e) =>
      String(e || "")
        .replace(/\s*\[cite:[^\]]+\]\s*/gi, " ")
        .replace(/\s+/g, " ")
        .trim(),
    z = (e, t = 0) => {
      if ("number" == typeof e && Number.isFinite(e)) return e;
      const n = Number.parseFloat(String(e ?? "").replace(/[^0-9.-]/g, ""));
      return Number.isFinite(n) ? n : t;
    },
    J = (e, t = "USD", n = "en") => {
      const r = Number.isFinite(e) ? e : 0,
        i = String(t || "USD").toUpperCase(),
        a = String(n || document.documentElement.lang || "en").trim() || "en";
      try {
        return new Intl.NumberFormat(a, {
          style: "currency",
          currency: i,
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(r);
      } catch (e) {
        return `${i} ${Math.round(r)}`;
      }
    },
    V = (e, t = "") => {
      const n = String(e || "").toLowerCase();
      return n.includes("infant")
        ? "Infant"
        : n.includes("teen")
          ? "Teen"
          : n.includes("child")
            ? "Child"
            : n.includes("senior")
              ? "Senior"
              : n.includes("adult")
                ? "Adult"
                : t;
    },
    Z = (e) => {
      const t = w(e, Number.NaN);
      return Number.isNaN(t)
        ? ""
        : t <= 2
          ? "Infant"
          : t <= 12
            ? "Child"
            : t <= 17
              ? "Teen"
              : t >= 65
                ? "Senior"
                : "Adult";
    },
    Q = (e) =>
      (Array.isArray(e) ? e : [])
        .map((e) => {
          if (!e || "object" != typeof e) return null;
          const t = Y(T(e, ["label", "title"])),
            n = Y(T(e, ["description", "summary"]));
          return t || n ? { label: t || "Priority", description: n } : null;
        })
        .filter(Boolean),
    X = (e) => {
      const t = _(e, "journey_dna");
      return t && "object" == typeof t
        ? {
            priorities: Q(
              _(t, "priorities_and_values") || _(t, "prioritiesAndValues"),
            ),
            standards: Q(
              _(t, "operational_standards") || _(t, "operationalStandards"),
            ),
            badges: ((b) => {
              const arr = Array.isArray(b) ? b : [];
              return arr.map((item) => ({
                name: String(item?.name || item?.label || "").trim(),
                icon: String(item?.icon || "").trim(),
                description: String(item?.description || "").trim(),
                priority: w(item?.priority || item?.priority_level, 0),
              })).filter((x) => x.name);
            })(_(e, "journey_dna")),
          }
        : { priorities: [], standards: [], badges: [] };
    },
    clientFacingExtract = (e) => {
      const cfs = _(e, "client_facing_summary"),
        customerView = _(e, "customer_view"),
        preDepartureView = _(e, "pre_departure_view");
      if (
        (!cfs || "object" != typeof cfs) &&
        (!customerView || "object" != typeof customerView) &&
        (!preDepartureView || "object" != typeof preDepartureView)
      )
        return {
        travellerProfiles: [],
        preDeparturePack: null,
        propertyRationales: [],
        journeyDnaBadges: [],
        accessibilitySummary: null,
      };
      const customerParty = customerView && "object" == typeof customerView ? customerView.party_overview : null,
        tpRaw = Array.isArray(customerParty?.traveller_profiles)
          ? customerParty.traveller_profiles
          : Array.isArray(cfs?.traveller_profiles)
            ? cfs.traveller_profiles
            : [];
      const travellerProfiles = tpRaw.map((tp) => ({
        name: String(tp?.name || "").trim(),
        role: String(tp?.role || "").trim(),
        interestsSummary: String(tp?.interests_summary || tp?.interestsSummary || "").trim(),
        dietarySummary: String(tp?.dietary_summary || tp?.dietarySummary || "").trim(),
        accommodationsMade: Array.isArray(tp?.accommodations_made)
          ? tp.accommodations_made.map((a) => String(a || "").trim()).filter(Boolean)
          : [],
      })).filter((x) => x.name);
      const pdp =
        preDepartureView && "object" == typeof preDepartureView
          ? preDepartureView
          : cfs && "object" == typeof cfs
            ? cfs.pre_departure_pack
            : null;
      const preDeparturePack = pdp && "object" == typeof pdp ? {
        packingAdvisory: pdp.packing_advisory && "object" == typeof pdp.packing_advisory ? {
          climateSummary: String(pdp.packing_advisory.climate_summary || "").trim(),
          essentialItems: Array.isArray(pdp.packing_advisory.essential_items)
            ? pdp.packing_advisory.essential_items.map((i) => String(i || "").trim()).filter(Boolean)
            : [],
          recommendedItems: Array.isArray(pdp.packing_advisory.recommended_items)
            ? pdp.packing_advisory.recommended_items.map((i) => String(i || "").trim()).filter(Boolean)
            : [],
          dressCodeNotes: String(pdp.packing_advisory.dress_code_notes || "").trim(),
        } : null,
        tippingGuidelines: pdp.tipping_guidelines && "object" == typeof pdp.tipping_guidelines ? {
          currencyRecommendations: String(pdp.tipping_guidelines.currency_recommendations || "").trim(),
          generalGuidance: String(pdp.tipping_guidelines.general_guidance || "").trim(),
          suggestedAmounts: Array.isArray(pdp.tipping_guidelines.suggested_amounts)
            ? pdp.tipping_guidelines.suggested_amounts.map((sa) => ({
                context: String(sa?.context || "").trim(),
                amount: String(sa?.amount || "").trim(),
              })).filter((x) => x.context && x.amount)
            : [],
        } : null,
        healthBriefing: pdp.health_briefing && "object" == typeof pdp.health_briefing ? {
          vaccinationRecommendations: Array.isArray(pdp.health_briefing.vaccination_recommendations)
            ? pdp.health_briefing.vaccination_recommendations.map((v) => String(v || "").trim()).filter(Boolean)
            : [],
          malariaAdvisory: String(pdp.health_briefing.malaria_advisory || "").trim(),
          generalHealthTips: Array.isArray(pdp.health_briefing.general_health_tips)
            ? pdp.health_briefing.general_health_tips.map((t) => String(t || "").trim()).filter(Boolean)
            : [],
        } : null,
        emergencyContacts: Array.isArray(pdp.emergency_contacts)
          ? pdp.emergency_contacts.map((ec) => ({
              type: String(ec?.type || "").trim(),
              name: String(ec?.name || "").trim(),
              phone: String(ec?.phone || "").trim(),
              notes: String(ec?.notes || "").trim(),
            })).filter((x) => x.name || x.phone)
          : [],
        visaSummary: String(pdp.visa_summary || "").trim(),
      } : null;
      const prRaw = Array.isArray(customerView?.property_rationales)
        ? customerView.property_rationales
        : Array.isArray(cfs?.property_rationales)
          ? cfs.property_rationales
          : [];
      const propertyRationales = prRaw.map((pr) => ({
        segmentId: String(pr?.segment_id || pr?.segmentId || "").trim(),
        propertyName: String(pr?.property_name || pr?.propertyName || "").trim(),
        location: String(pr?.location || "").trim(),
        rationale: String(pr?.rationale || "").trim(),
      })).filter((x) => x.rationale);
      const badgesRaw = Array.isArray(customerView?.journey_dna_badges)
        ? customerView.journey_dna_badges
        : Array.isArray(cfs?.journey_dna_badges)
          ? cfs.journey_dna_badges
          : [];
      const journeyDnaBadges = badgesRaw.map((b) => ({
        name: String(b?.name || "").trim(),
        icon: String(b?.icon || "").trim(),
        description: String(b?.description || "").trim(),
        priority: w(b?.priority, 0),
      })).filter((x) => x.name);
      const as = cfs && "object" == typeof cfs ? cfs.accessibility_summary : null;
      const accessibilitySummary = as && "object" == typeof as ? {
        hasAccessibilityRequirements: Boolean(as.has_accessibility_requirements),
        summaryText: String(as.summary_text || "").trim(),
      } : null;
      return {
        travellerProfiles,
        preDeparturePack,
        propertyRationales,
        journeyDnaBadges,
        accessibilitySummary,
      };
    },
    isBufferActivity = (act) => {
      const name = String(act?.name || "").toLowerCase();
      const desc = String(act?.description || act?.descriptionHtml || "").toLowerCase();
      const type = String(act?.type || "").toLowerCase();
      if (name.includes("open recovery window")) return !0;
      if (name.includes("buffer") || type.includes("buffer")) return !0;
      if (desc.includes("type: buffer")) return !0;
      if (/^(free time|leisure|rest|recovery|relaxation)\s*$/i.test(name) && !act?.contentEntityId) return !0;
      return !1;
    },
    ee = (e, t = {}) => {
      if (!e) return t;
      try {
        const n = JSON.parse(e);
        return n && "object" == typeof n ? n : t;
      } catch (e) {
        return t;
      }
    },
    te = (e, t = "/") => {
      const n = String(t || "/").trim() || "/",
        r = String(e || "").trim();
      if (!r) return n;
      try {
        const e = new URL(r, window.location.origin);
        return `${e.pathname || "/"}${e.search}${e.hash}`;
      } catch (e) {
        return n;
      }
    },
    ne = ["preview_theme_id", "pb"],
    re = (e) => {
      if (!(e instanceof URL)) return;
      let t;
      try {
        t = new URL(window.location.href);
      } catch (e) {
        return;
      }
      for (const n of ne) {
        if (e.searchParams.has(n)) continue;
        const r = String(t.searchParams.get(n) || "").trim();
        r && e.searchParams.set(n, r);
      }
    },
    ie = (e) => {
      if (!e) return "";
      if ("object" == typeof e) {
        if (Array.isArray(e.children)) {
          let t = "";
          for (const n of e.children) t += ie(n);
          return t;
        }
        return "string" == typeof e.value ? e.value : "";
      }
      const t = String(e).trim();
      if (!t) return "";
      if (t.startsWith("{") || t.startsWith("["))
        try {
          const e = JSON.parse(t);
          return ie(e);
        } catch (e) {
          return t;
        }
      return t;
    },
    ae = (e, t, n = {}) => {
      const r = H(n.pinLinkContext || {}),
        i =
          ((a = r.registry),
          (o = r.contextKey),
          a && "object" == typeof a
            ? (a.linkedPinsByContext instanceof Map ||
                (a.linkedPinsByContext = new Map()),
              a.linkedPinsByContext.has(o) ||
                a.linkedPinsByContext.set(o, new Set()),
              a.linkedPinsByContext.get(o))
            : null);
      var a, o;
      return String(e || "").replace(
        /\{\{PIN:(\d+)\|([^}]+)\}\}/g,
        (e, n, a) => {
          const o = A(n);
          if (Boolean(i && o && i.has(o))) return b(a);
          let c = !1;
          const s =
              r.registry?.introLinkedPins instanceof Set
                ? r.registry.introLinkedPins
                : null,
            l =
              r.registry?.introConsumedPins instanceof Set
                ? r.registry.introConsumedPins
                : null;
          "leg" === r.scope &&
            o &&
            s &&
            l &&
            s.has(o) &&
            !l.has(o) &&
            ((c = !0), l.add(o));
          const d = Ne(n, t, {
            kind: "inline",
            title: a,
            categoryHints: ["inline narrative"],
          });
          if (!d) return (i && o && i.add(o), b(a));
          if (D(d.corpus, a)) return (i && o && i.add(o), b(a));
          if (c) return (i && o && i.add(o), b(a));
          const m = d.handle,
            u = et(d, {
              kind: "inline",
              title: a,
              categoryHints: ["inline narrative"],
            });
          return (
            i && o && i.add(o),
            "intro" === r.scope &&
              r.registry?.introLinkedPins instanceof Set &&
              o &&
              r.registry.introLinkedPins.add(o),
            `<a class="itin-command-center__inline-pin-link" href="${b(u)}" data-command-center-inline-product-handle="${b(m)}" data-command-center-inline-pin="${b(n)}">${b(a)}</a>`
          );
        },
      );
    },
    oe = (e, t, n = {}) => {
      const r = ((e) =>
        String(e || "")
          .replace(new RegExp(m), "")
          .replace(/\n{3,}/g, "\n\n")
          .replace(/[ \t]{2,}/g, " ")
          .trim())(ie(e)).trim();
      if (!r) return "";
      if (v(r)) return ae(r, t, n);
      const i = b(r).replace(/\n\n+/g, "</p><p>").replace(/\n/g, "<br>");
      return `<p>${ae(i, t, n)}</p>`;
    },
    ce = (e) =>
      String(e || "")
        .replace(/<[^>]*>/g, " ")
        .replace(/\s+/g, " ")
        .trim(),
    se = (e) => {
      const t = ce(e).trim();
      return !t || d.some((e) => e.test(t));
    },
    le = (e) => {
      const t = String(e || "").trim();
      if (!t) return "";
      const n = new DOMParser().parseFromString(`<div>${t}</div>`, "text/html")
        .body.firstElementChild;
      if (!n) return "";
      const r = Array.from(
        n.querySelectorAll("p, li, h1, h2, h3, h4, h5, h6, blockquote"),
      );
      for (const e of r) se(e.textContent || "") && e.remove();
      const i = Array.from(n.querySelectorAll("*"));
      for (const e of i)
        e.children.length > 0 ||
          ("" === String(e.textContent || "").trim() && e.remove());
      return n.innerHTML
        .replace(/\s{2,}/g, " ")
        .replace(/\n{3,}/g, "\n\n")
        .trim();
    },
    dedupeRoutesForDay = (e = []) => {
      if (!Array.isArray(e) || 0 === e.length) return [];
      const t = new Set();
      return e.filter((e) => {
        if (!e || "object" != typeof e) return !1;
        const n = [
          String(e.mode || "").trim().toLowerCase(),
          String(e.label || "").trim().toLowerCase(),
          String(e.type || "").trim().toLowerCase(),
          String(e.variant || "").trim().toLowerCase(),
          String(e.startDay ?? "").trim(),
          String(e.endDay ?? "").trim(),
          String(e.startTime || e.departureTime || e.checkInTime || "")
            .trim()
            .toLowerCase(),
          String(e.endTime || e.arrivalTime || "").trim().toLowerCase(),
          String(e.startPin || "").trim(),
          String(e.endPin || "").trim(),
          String(e.startLocation || "").trim().toLowerCase(),
          String(e.endLocation || "").trim().toLowerCase(),
          String(e.referenceCode || "").trim().toLowerCase(),
          String(e.flightCode || "").trim().toLowerCase(),
          ce(
            [
              e.descriptionHtml || "",
              e.directionsHtml || "",
              e.generalDescriptionHtml || "",
            ].join(" "),
          )
            .slice(0, 220)
            .toLowerCase(),
        ].join("||");
        if (!n || t.has(n)) return !1;
        return t.add(n), !0;
      });
    },
    de = (e) => {
      const t = String(e || "").trim();
      if (!t) return { title: "", bodyHtml: "" };
      const n = new DOMParser().parseFromString(`<div>${t}</div>`, "text/html")
        .body.firstElementChild;
      if (!n) return { title: "", bodyHtml: t };
      const r = (e) => $(e ? String(e.textContent || "").trim() : "");
      let i = "";
      const a = n.querySelector("h1, h2, h3, h4, h5, h6");
      if ((a && ((i = r(a)), i && a.remove()), !i)) {
        const e = n.querySelector("p, li, div, blockquote"),
          t = e ? e.querySelector("strong, b") : n.querySelector("strong, b");
        if (t) {
          const e = r(t);
          if (e) {
            i = e;
            const n = t.parentElement;
            n &&
              (ce(n.innerHTML).toLowerCase() === e.toLowerCase()
                ? n.remove()
                : (t.remove(),
                  "" === String(n.textContent || "").trim() && n.remove()));
          }
        }
      }
      return {
        title: i,
        bodyHtml: n.innerHTML
          .replace(/^\s*(<br\s*\/?>\s*)+/i, "")
          .replace(/\s{2,}/g, " ")
          .replace(/\n{3,}/g, "\n\n")
          .trim(),
      };
    },
    me = (e) =>
      String(e || "")
        .replace(/\s+/g, " ")
        .trim()
        .toLowerCase(),
    ue = ({
      destinationName: e,
      accommodationName: t,
      stopNames: n = [],
      fallbackTitle: r,
    }) => {
      const i = [],
        a = new Set(),
        o = (e) => {
          const t = String(e || "")
            .replace(/\s+/g, " ")
            .trim();
          if (!t) return;
          const n = me(t);
          n && !a.has(n) && (a.add(n), i.push(t));
        };
      if ((o(e), o(t), 0 === i.length)) {
        const e = Array.isArray(n)
          ? n
              .map((e) =>
                String(e || "")
                  .replace(/\s+/g, " ")
                  .trim(),
              )
              .filter(Boolean)
          : [];
        if (1 === e.length) o(e[0]);
        else if (e.length > 1) {
          const t = e[0],
            n = e[e.length - 1];
          me(t) === me(n) ? o(t) : i.push(`${t} to ${n}`);
        }
      }
      return i.length > 0
        ? i.join(" · ")
        : String(r || "")
            .replace(/\s+/g, " ")
            .trim() || "Leg";
    },
    pe = (e) =>
      [...U(e)].sort((e, t) => w(_(e, "sequence"), 0) - w(_(t, "sequence"), 0)),
    ge = (e, t) => {
      const n = String(e || "").trim(),
        r = String(t || "").trim(),
        i = Ce([n, r]).toLowerCase();
      switch (n) {
        case "ScheduledFlight":
          return "Scheduled flight";
        case "CharterFlight":
          return "Charter flight";
        case "Transfer":
          return /\bprivate\b/.test(i) ? "Private transfer" : "Transfer";
        case "Train":
        case "Rail":
          return "Rail transfer";
        case "Selfdrive":
          return "Self-drive";
        case "CarHire":
          return "Car hire";
        case "Boat":
          return r ? `Boat - ${r}` : "Boat transfer";
        case "Hike":
          return r ? `Guided ${r.toLowerCase()}` : "Guided transfer";
        default:
          return n || r || "Transfer";
      }
    },
    ye = (e, t = "") => {
      const n = Ce([e, t]).toLowerCase();
      return n.includes("flight") || n.includes("air")
        ? "Flight"
        : n.includes("train") || n.includes("rail")
          ? "Rail"
          : /(^|\b)self\s*[- ]?\s*drive\b/.test(n)
            ? "Self-drive"
            : n.includes("boat") || n.includes("ferry")
            ? "Boat"
            : n.includes("car hire") ||
                n.includes("carhire") ||
                n.includes("rental")
              ? "Car hire"
              : n.includes("transfer") ||
                  n.includes("shuttle") ||
                  n.includes("drive")
                ? "Transfer"
                : "Travel segment";
    },
    fe = (e) => {
      const t = Ce([
        e.type,
        e.name,
        e.mode,
        e.location,
        e.referenceCode,
        e.terminal,
        e.meetingInstructions,
        e.contactName,
        e.contactPhone,
        e.contactEmail,
      ]);
      return (
        a.some((e) => e.test(t)) ||
        D(t) ||
        Boolean(
          e.referenceCode ||
          e.terminal ||
          e.meetingInstructions ||
          e.contactName ||
          e.contactPhone ||
          e.contactEmail,
        )
      );
    },
    v2ClassifyDailyEvent = (e = "", t = "", n = "") => {
      const r = Ce([e, t, ce(n)]).toLowerCase();
      if (
        /\bexpert\b|\binsider\b|\bguide tip\b|\bexpert tip\b|\blocal tip\b/i.test(
          r,
        )
      )
        return { eventTypeId: "expert-tip", eventTypeLabel: "Expert tip" };
      if (
        /\boptional\b|\brecommend(?:ation|ed)?\b|\bsuggest(?:ion|ed)?\b/i.test(
          r,
        )
      )
        return {
          eventTypeId: "optional-recommendation",
          eventTypeLabel: "Optional recommendation",
        };
      if (
        /\brestaurant\b|\bdining\b|\bdinner\b|\blunch\b|\bbreakfast\b|\bsupper\b|\bbistro\b/i.test(
          r,
        )
      )
        return {
          eventTypeId: "restaurant-dining",
          eventTypeLabel: "Restaurant & dining",
        };
      return {
        eventTypeId: "scheduled-activity",
        eventTypeLabel: "Scheduled activity",
      };
    },
    v2ClassifyRouteEvent = (e = {}) => {
      const t = Ce([e.mode, e.type, e.variant, e.label, e.vehicle]).toLowerCase();
      return /scheduled\s*flight|flight|air/.test(t)
        ? { eventTypeId: "scheduled-flight", eventTypeLabel: "Scheduled flight" }
        : /self\s*[- ]?\s*drive/.test(t)
          ? { eventTypeId: "self-drive", eventTypeLabel: "Self-drive" }
          : /car\s*hire|carhire|rental|rent-a-car/.test(t)
            ? { eventTypeId: "car-hire", eventTypeLabel: "Car hire" }
            : /transfer|shuttle|road/.test(t)
              ? {
                  eventTypeId: /\bprivate\b/.test(t)
                    ? "private-transfer"
                    : "private-transfer",
                  eventTypeLabel: "Private transfer",
                }
              : { eventTypeId: "arrival-greeting", eventTypeLabel: "Arrival / greeting" };
    },
    v2ClassifyStopEvent = (e = {}, t = null) => {
      const n = Ce([
        e.type,
        e.name,
        e.location,
        e.meetingInstructions,
        t?.type,
      ]).toLowerCase();
      if (Boolean(t?.isMobileLeg) || /\bmobile\b/.test(n))
        return /\bcheck\s*[- ]?\s*in\b/.test(n)
          ? { eventGroup: "stay", eventTypeId: "mobile-check-in", eventTypeLabel: "Mobile check-in" }
          : { eventGroup: "stay", eventTypeId: "mobile-stop", eventTypeLabel: "Mobile stop" };
      return /\bcheck\s*[- ]?\s*in\b/.test(n)
        ? { eventGroup: "stay", eventTypeId: "property-check-in", eventTypeLabel: "Property check-in" }
        : /\barriv(?:e|al)\b|\bdestination\b/.test(n)
          ? { eventGroup: "stay", eventTypeId: "destination-arrival", eventTypeLabel: "Destination arrival" }
          : /\bflight|air\b/.test(n)
            ? { eventGroup: "logistics", eventTypeId: "scheduled-flight", eventTypeLabel: "Scheduled flight" }
            : /\bself\s*[- ]?\s*drive\b/.test(n)
              ? { eventGroup: "logistics", eventTypeId: "self-drive", eventTypeLabel: "Self-drive" }
              : /\bcar\s*hire|carhire|rental|rent-a-car\b/.test(n)
                ? { eventGroup: "logistics", eventTypeId: "car-hire", eventTypeLabel: "Car hire" }
                : /\btransfer|shuttle|greeting|meet\b/.test(n)
                  ? { eventGroup: "logistics", eventTypeId: "private-transfer", eventTypeLabel: "Private transfer" }
                  : { eventGroup: "stay", eventTypeId: "mobile-stop", eventTypeLabel: "Mobile stop" };
    },
    v2EventPriority = (e = "", t = "") => {
      const n = String(e || "").trim().toLowerCase(),
        r = String(t || "").trim().toLowerCase();
      return "logistics" === n
        ? "arrival-greeting" === r
          ? 0
          : 1
        : "stay" === n
          ? 2
          : "daily" === n
            ? 3
            : 4;
    },
    v2ProductInspectorClass = (e = {}) => {
      if (!e || "product" !== e.type) return "";
      const t = Ce([
        e.wetuType,
        e.wetuCategory,
        e.wetuSubcategory,
        e.title,
      ]).toLowerCase();
      return /\bdestination|city|region|country\b/.test(t)
        ? "destination"
        : /\bproperty|accommodation|lodge|hotel|camp|resort\b/.test(t)
          ? "property"
          : "";
    },
    he = (e, t) => {
      const n = ((e, t) => {
        if (!e) return null;
        const n = Number.isFinite(t) ? t : 0,
          r = new Date(Date.UTC(e.year, e.month - 1, e.day + n));
        return Number.isNaN(r.getTime()) ? null : r;
      })(e, t);
      return n
        ? {
            weekday: n
              .toLocaleDateString(void 0, { weekday: "short", timeZone: "UTC" })
              .toUpperCase(),
            day: n.toLocaleDateString(void 0, {
              day: "2-digit",
              timeZone: "UTC",
            }),
            month: n
              .toLocaleDateString(void 0, { month: "short", timeZone: "UTC" })
              .toUpperCase(),
            year: n.toLocaleDateString(void 0, {
              year: "numeric",
              timeZone: "UTC",
            }),
            label: n.toLocaleDateString("en-GB", {
              weekday: "long",
              day: "2-digit",
              month: "long",
              year: "numeric",
              timeZone: "UTC",
            }),
          }
        : { weekday: "", day: "", month: "", year: "", label: "" };
    },
    Se = (e, t) => {
      const n = "dark" === t ? "dark" : "light";
      ((e.dataset.theme = n),
        e.classList.toggle("is-theme-dark", "dark" === n),
        e.classList.toggle("is-theme-light", "dark" !== n));
      const r = e.querySelector("[data-command-center-theme-toggle]");
      if (!r) return;
      const i = r.querySelector("[data-command-center-theme-toggle-label]");
      "dark" === n
        ? ((r.dataset.themeMode = "dark"),
          r.setAttribute("aria-label", "Switch to light mode"),
          r.setAttribute("title", "Switch to light mode"),
          i && (i.textContent = "Switch to light mode"))
        : ((r.dataset.themeMode = "light"),
          r.setAttribute("aria-label", "Switch to dark mode"),
          r.setAttribute("title", "Switch to dark mode"),
          i && (i.textContent = "Switch to dark mode"));
    },
    be = (e) => {
      const t = [],
        n = new Set();
      for (const r of e) {
        const e = String(r || "").trim();
        if (!e) continue;
        const i = e.toLowerCase();
        n.has(i) || (n.add(i), t.push(e));
      }
      return t;
    },
    ve = (e) => {
      const t = ce(ie(e))
        .replace(/\u2022/g, "|")
        .replace(/\r/g, "\n")
        .trim();
      if (!t) return [];
      let n = [t];
      return (
        t.includes("|")
          ? (n = t.split("|"))
          : t.includes("\n")
            ? (n = t.split(/\n+/))
            : t.includes(";") && (n = t.split(";")),
        be(
          n.map((e) =>
            String(e || "")
              .replace(/^[-•\s]+/, "")
              .trim(),
          ),
        )
      );
    },
    _e = (e) =>
      ce(ie(e))
        .toLowerCase()
        .replace(/&[a-z0-9#]+;/g, " ")
        .replace(/[^a-z0-9\s]/g, " ")
        .replace(/\s+/g, " ")
        .trim(),
    Te = (e, t = 4) => {
      const n = be(e).filter(Boolean);
      return 0 === n.length
        ? ""
        : n.length <= t
          ? n.join(", ")
          : `${n.slice(0, t).join(", ")}, and ${n.length - t} more`;
    },
    we = (e) => {
      const t = String(e || "")
        .trim()
        .split(/\s+/)
        .filter(Boolean);
      return 0 === t.length
        ? "WC"
        : 1 === t.length
          ? t[0].slice(0, 2).toUpperCase()
          : `${t[0][0] || ""}${t[1][0] || ""}`.toUpperCase();
    },
    ke = (e, t, n) => {
      const r = String(
          T(e, [
            "reference_number",
            "reference",
            "itinerary_reference",
            "client_reference",
          ]) ||
            T(_(e, "quick_reference"), ["reference"]) ||
            "",
        ).trim(),
        i = ((e) => {
          const t = String(
            T(e, ["journey_type", "type", "itinerary_type"]) || "",
          ).trim();
          if (!t) return "Private journey";
          const n = t.toLowerCase();
          return n.includes("private") || n.includes("personal")
            ? "Private journey"
            : n.includes("group")
              ? "Group journey"
              : n.includes("scheduled")
                ? "Scheduled journey"
                : n.includes("journey")
                  ? t
                  : `${t.charAt(0).toUpperCase()}${t.slice(1)} journey`;
        })(e),
        a = ((e) => {
          const t = [
            T(e, ["start_date", "travel_start_date", "arrival_date"]),
            T(e, ["end_date", "travel_end_date", "departure_date"]),
          ];
          for (const e of t) {
            const t = new Date(String(e || "").trim());
            if (!Number.isNaN(t.getTime())) return String(t.getFullYear());
          }
          const n = U(_(e, "tags"));
          for (const e of n) {
            const t = String(e || "").match(/\b(20\d{2})\b/);
            if (t) return t[1];
          }
          return "";
        })(e),
        o = ((e) => {
          const t = U(_(e, "travellers"));
          let n = 0,
            r = 0;
          const i = [];
          for (const e of t) {
            const t = String(
                T(e, ["type", "traveller_type", "traveler_type"]) || "",
              )
                .trim()
                .toLowerCase(),
              a = [
                String(T(e, ["title"]) || "").trim(),
                String(
                  T(e, ["name", "display_name", "full_name"]) || "",
                ).trim(),
              ]
                .filter(Boolean)
                .join(" ")
                .trim();
            t.includes("child")
              ? ((r += 1), a && i.push(a))
              : t.includes("adult") && (n += 1);
          }
          let a = w(
              T(e, [
                "travellers_adult",
                "travelers_adult",
                "travellers_adults",
                "travelers_adults",
                "adults",
              ]),
              0,
            ),
            o = w(
              T(e, ["travellers_children", "travelers_children", "children"]),
              0,
            );
          (a <= 0 && n > 0 && (a = n), o <= 0 && r > 0 && (o = r));
          let c = w(
            T(e, [
              "travellers_total",
              "travelers_total",
              "total_travellers",
              "total_travelers",
              "travellers",
              "travelers",
              "guest_count",
              "guests",
            ]),
            0,
          );
          (c <= 0 && (c = a + o), c <= 0 && t.length > 0 && (c = t.length));
          const s = [];
          (a > 0 && s.push(`${a} ${1 === a ? "adult" : "adults"}`),
            o > 0 && s.push(`${o} ${1 === o ? "child" : "children"}`),
            0 === s.length &&
              c > 0 &&
              s.push(`${c} ${1 === c ? "guest" : "guests"}`));
          const l = i.length > 0 ? i.slice(0, 2).join(", ") : "";
          let d = s.join(" · ");
          return (
            l
              ? (d += ` (${l}${i.length > 2 ? ` +${i.length - 2} more` : ""}) included`)
              : d && (d += " included"),
            {
              adults: a,
              children: o,
              totalGuests: c,
              partyContext: d,
              initialGuests: a > 0 ? a : Math.max(1, c || 1),
            }
          );
        })(e),
        c = ve(T(e, ["price_includes", "pricing_includes", "includes"])),
        s = ve(T(e, ["price_excludes", "pricing_excludes", "excludes"]));
      let l = c;
      if (0 === l.length) {
        const e = n
          .map((e) => e.accommodationName || e.destinationName || "")
          .filter(Boolean);
        l = be(e);
      }
      const pPricing = _(e, "pricing"),
        pArchitecture = _(e, "pricing_architecture"),
        pTerms = _(e, "financial_terms"),
        journeyCurrency =
          String(T(pPricing || {}, ["currency"]) || "").trim() ||
          String(T(pArchitecture || {}, ["currency"]) || "").trim() ||
          String(T(e, ["currency"]) || "").trim() ||
          "USD",
        journeySchedule = Array.isArray(pPricing?.payment_schedule)
          ? pPricing.payment_schedule
          : Array.isArray(pPricing?.paymentSchedule)
            ? pPricing.paymentSchedule
            : Array.isArray(pPricing?.financial_terms?.payment_schedule)
              ? pPricing.financial_terms.payment_schedule
              : Array.isArray(pArchitecture?.financial_terms?.payment_schedule)
                ? pArchitecture.financial_terms.payment_schedule
                : Array.isArray(pTerms?.payment_schedule)
                  ? pTerms.payment_schedule
                  : [],
        journeySchedulePreview = journeySchedule
          .slice(0, 3)
          .map((e) => {
            const t = Y(
                T(e, ["label", "name", "milestone", "description"]) ||
                  "Payment",
              ),
              n = z(T(e, ["amount", "total"]), Number.NaN),
              r = Y(T(e, ["due_date", "dueDate", "date"]) || "");
            return [t, Number.isFinite(n) ? J(n, journeyCurrency) : "", r]
              .filter(Boolean)
              .join(" due ");
          })
          .filter(Boolean)
          .join("; "),
        journeyTotal = z(
          T(pPricing || {}, ["total_investment", "totalInvestment"]),
          z(T(pArchitecture || {}, ["total_investment", "totalInvestment"]), 0),
        ),
        d = [],
        m = Te(l, 5),
        u = Te(s, 3);
      if (journeyTotal > 0) {
        const e =
          o.totalGuests > 0
            ? `${J(journeyTotal, journeyCurrency)} for ${o.totalGuests} ${1 === o.totalGuests ? "guest" : "guests"}`
            : J(journeyTotal, journeyCurrency);
        d.push(`Journey investment is ${e}.`);
        if (journeySchedule.length > 0) {
          const e = journeySchedule
            .slice(0, 3)
            .map((e) => {
              const t = Y(
                  T(e, ["label", "name", "milestone", "description"]) ||
                    "Payment",
                ),
                n = z(T(e, ["amount", "total"]), Number.NaN),
                r = Y(T(e, ["due_date", "dueDate", "date"]) || "");
              return [t, Number.isFinite(n) ? J(n, journeyCurrency) : "", r]
                .filter(Boolean)
                .join(" due ");
            })
            .filter(Boolean)
            .join("; ");
          e && d.push(`Payment schedule: ${e}.`);
        }
      } else
        d.push(
          `Price is structured for ${o.totalGuests > 0 ? `${o.totalGuests} ${1 === o.totalGuests ? "guest" : "guests"}` : `${o.initialGuests} ${1 === o.initialGuests ? "guest" : "guests"}`}. Confirm final investment with your travel designer.`,
        );
      (m && d.push(`Includes ${m}.`), u && d.push(`Excludes ${u}.`));
      const p = ((e) => {
          const t = U(_(e, "contacts"));
          for (const e of t) {
            const t = String(
                T(e, ["contact_person", "name", "full_name"]) || "",
              ).trim(),
              n = String(
                T(e, ["company", "company_name", "organization"]) || "",
              ).trim(),
              r = String(T(e, ["title", "role", "designation"]) || "").trim(),
              i = String(T(e, ["telephone", "phone", "mobile"]) || "").trim(),
              a = String(T(e, ["email"]) || "").trim();
            if (t || n || i || a)
              return {
                name: t || n || "Travel consultant",
                role: r || n || "Journey consultant",
                phone: i,
                email: a,
              };
          }
          const n = String(T(e, ["client_phone", "phone"]) || "").trim(),
            r = String(T(e, ["client_email", "email"]) || "").trim();
          return n || r
            ? {
                name: "Journey consultant",
                role: "Operations desk",
                phone: n,
                email: r,
              }
            : null;
        })(e),
        g = [i];
      return (
        a && g.push(a),
        r && g.push(`REF ${r}`),
        {
          type: "landing",
          template: "default",
          title: t || "Reservation control panel",
          topLine: g.join(" · "),
          referenceNumber: r,
          partyContext: o.partyContext,
          initialGuestCount: o.initialGuests,
          priceNarrative: d.join(" "),
          travelStartDate: T(e, ["start_date", "travel_start_date", "arrival_date"]),
          travelEndDate: T(e, ["end_date", "travel_end_date", "departure_date"]),
          checkoutCurrency: journeyCurrency,
          checkoutTotalMinor: Number.isFinite(journeyTotal) ? Math.round(100 * journeyTotal) : 0,
          checkoutTotalDisplay: journeyTotal > 0 ? J(journeyTotal, journeyCurrency) : "",
          checkoutPaymentSchedulePreview: journeySchedulePreview,
          includes: l,
          consultant: p ? { ...p, initials: we(p.name) } : null,
          customizationUrl: p?.email ? `mailto:${p.email}` : "/pages/contact",
        }
      );
    },
    $e = (e) => {
      const t = String(e || "")
        .trim()
        .toLowerCase();
      if (!t) return 9999;
      const n = t.replace(/\./g, "").replace(/\s+/g, " "),
        r = n.match(/\b(am|pm)\b/);
      let i = Number.NaN,
        a = Number.NaN;
      const o = n.match(/(\d{1,2})\s*:\s*(\d{1,2})/);
      if (o) ((i = Number.parseInt(o[1], 10)), (a = Number.parseInt(o[2], 10)));
      else {
        const e = n.match(/\b(\d{3,4})\b/);
        if (e) {
          const t = e[1];
          ((i = Number.parseInt(t.slice(0, t.length - 2), 10)),
            (a = Number.parseInt(t.slice(-2), 10)));
        } else {
          const e = n.match(/\b(\d{1,2})\b/);
          e && ((i = Number.parseInt(e[1], 10)), (a = 0));
        }
      }
      if (!Number.isFinite(i) || !Number.isFinite(a)) return 9999;
      if (a < 0 || a > 59 || i < 0 || i > 24) return 9999;
      if (r) {
        const e = r[1];
        if (i < 1 || i > 12) return 9999;
        i = "am" === e ? (12 === i ? 0 : i) : 12 === i ? 12 : i + 12;
      }
      return 24 === i && 0 !== a ? 9999 : 24 === i ? 1440 : 60 * i + a;
    },
    Ce = (e) =>
      e
        .flatMap((e) => (U(e).length > 0 ? U(e) : [e]))
        .map((e) => String(e || "").trim())
        .filter(Boolean)
        .join(" "),
    Le = (...e) => {
      const t = Ce(e);
      return !!t && r.some((e) => e.test(t));
    },
    Ie = ({
      rootProductHandle: e,
      pinMap: t,
      componentCandidates: n,
      manifest: r,
    }) => {
      const i = new Map(),
        a = new Map();
      let c = 0;
      const s = (t, n = 0) => {
        const r = String(t.pin || "").trim(),
          s = String(t.handle || "").trim();
        if (!r || !s) return;
        const d = {
          pin: r,
          handle: s,
          url: te(t.url, Xe(s)),
          featuredImage: String(
            t.featured_image || t.featuredImage || "",
          ).trim(),
          featuredImageLarge: String(
            t.featured_image_large || t.featuredImageLarge || "",
          ).trim(),
          title: String(t.title || "").trim(),
          tagline: String(t.tagline || "").trim(),
          templateSuffix: String(
            t.template_suffix || t.templateSuffix || "",
          ).trim(),
          productType: String(t.product_type || t.productType || "").trim(),
          tags: U(t.tags),
          wetuType: String(t.wetu_type || t.wetuType || "").trim(),
          wetuCategory: String(t.wetu_category || t.wetuCategory || "").trim(),
          wetuSubcategory: String(
            t.wetu_subcategory || t.wetuSubcategory || "",
          ).trim(),
          source: String(t.source || "unknown").trim(),
          pinField: String(t.pin_field || t.pinField || "").trim(),
          sourceRank: n,
          pinFieldRank: l[String(t.pin_field || t.pinField || "").trim()] || 0,
          order: c,
        };
        ((c += 1),
          (d.isItineraryTemplate = ((e, t) => {
            const n = Ce([e.templateSuffix, e.productType, e.handle]);
            return !!o.some((e) => e.test(n)) || e.handle === t;
          })(d, e)),
          (d.corpus = Ce([
            d.title,
            d.tagline,
            d.templateSuffix,
            d.productType,
            d.wetuType,
            d.wetuCategory,
            d.wetuSubcategory,
            d.tags,
            d.handle,
          ]).toLowerCase()),
          i.has(r) || i.set(r, []),
          i.get(r).push(d),
          a.has(s) || a.set(s, []),
          a.get(s).push(d));
      };
      for (const e of U(n)) s(e, 120);
      for (const [e, t] of Object.entries(r.handleByPin || {}))
        s({ pin: e, handle: t, source: "manifest", pin_field: "manifest" }, 70);
      for (const [e, n] of Object.entries(t || {}))
        s({ pin: e, handle: n, source: "pin-map", pin_field: "pin-map" }, 60);
      return { byPin: i, byHandle: a, statusByPin: r.statusByPin || {} };
    },
    Ne = (e, t, n = {}) => {
      const r = String(e || "").trim();
      if (!r) return null;
      const i = t?.statusByPin?.[r];
      if (i && "found" !== i) return null;
      const a = [...(t?.byPin?.get(r) || [])];
      if (0 === a.length) return null;
      const o = new Set(
          ((...e) =>
            Ce(e)
              .toLowerCase()
              .replace(/[^a-z0-9\s-]/g, " ")
              .split(/[\s-]+/)
              .map((e) => e.trim())
              .filter((e) => e.length > 1))(
            n.kind,
            n.title,
            n.meta,
            n.categoryHints,
          ),
        ),
        c = s[String(n.kind || "").trim()] || [];
      for (const e of c) o.add(String(e).toLowerCase());
      const l = a.map((e) => {
        let t = e.sourceRank;
        if (((t += 3 * e.pinFieldRank), n.kind && c.length > 0))
          for (const n of c)
            e.corpus.includes(String(n).toLowerCase()) && (t += 18);
        for (const n of o) e.corpus.includes(n) && (t += 6);
        return (
          n.kind &&
            "" !== String(n.kind).trim() &&
            "inline" !== n.kind &&
            (e.isItineraryTemplate ? (t -= 16) : (t += 12)),
          Le(e.title, e.wetuType, e.wetuCategory, e.handle) && (t -= 80),
          { candidate: e, score: t }
        );
      });
      l.sort((e, t) =>
        t.score !== e.score
          ? t.score - e.score
          : t.candidate.sourceRank !== e.candidate.sourceRank
            ? t.candidate.sourceRank - e.candidate.sourceRank
            : t.candidate.pinFieldRank !== e.candidate.pinFieldRank
              ? t.candidate.pinFieldRank - e.candidate.pinFieldRank
              : e.candidate.order !== t.candidate.order
                ? e.candidate.order - t.candidate.order
                : e.candidate.handle.localeCompare(t.candidate.handle),
      );
      const d = l[0]?.candidate || null;
      return d
        ? Le(n.title, n.meta, n.categoryHints, d.title, d.handle)
          ? null
          : d
        : null;
    },
    Pe = (...e) =>
      W(e)
        .map((e) => Y(e))
        .filter(Boolean)
        .join(" · "),
    xe = (...e) =>
      W(e)
        .map((e) => Y(e))
        .filter(Boolean)
        .join(" · "),
    Ae = (e) => {
      const t = String(e.startTerminal || e.terminal || "").trim(),
        n = String(e.endTerminal || "").trim();
      if (t && n && t !== n) return `Terminals: ${t} → ${n}`;
      const r = t || n;
      return r ? `Terminal: ${r}` : "";
    },
    qe = (e = {}, t = {}) => {
      const n =
          String(t.title || e.title || "Logistics event").trim() ||
          "Logistics event",
        r = String(t.meta || e.meta || "").trim(),
        i = String(
          e.summaryHtml || e.descriptionHtml || e.generalDescriptionHtml || "",
        ).trim(),
        a = ce(i),
        o = String(e.path || "").trim(),
        c = Pe(e.referenceCode, e.flightCode, e.ticketClass),
        s = String(e.terminalLine || "").trim(),
        l = String(e.arrivalTime || "").trim(),
        d = String(e.departureTime || "").trim(),
        m = String(e.checkInTime || "").trim(),
        u = Y(String(e.meetingInstructions || "").trim()),
        p = xe(e.contactName, e.contactPhone, e.contactEmail);
      return {
        type: "logistics",
        template: "logistics",
        title: n,
        meta: r,
        path: o ? `Route: ${o}` : "Route: Not provided",
        reference: c ? `Reference: ${c}` : "Reference: Not provided",
        terminals: s || "Terminal: Not provided",
        arrival: l ? `Arrival: ${l}` : "Arrival: Not provided",
        departure: d ? `Departure: ${d}` : "Departure: Not provided",
        checkIn: m ? `Check-in: ${m}` : "Check-in: Not provided",
        meeting: u ? `Meeting: ${u}` : "Meeting: Not provided",
        contact: p ? `Contact: ${p}` : "Contact: Not provided",
        summary: a || "Logistics notes are pending for this event.",
        mapTitle:
          String(e.mapTitle || "Logistics detail placeholder").trim() ||
          "Logistics detail placeholder",
        mapCopy: String(
          e.mapCopy ||
            "This panel captures the transfer, greeting, and terminal operations for this logistics event.",
        ).trim(),
        featuredImage: String(e.featuredImage || "").trim(),
        tagline: R(String(e.tagline || "").trim(), {
          pin: e.pin,
          handle: e.handle,
        }),
        sourceType: String(e.sourceType || t.sourceType || "logistics").trim(),
        eventGroup: String(e.eventGroup || t.eventGroup || "logistics").trim(),
        eventTypeId: String(
          e.eventTypeId || t.eventTypeId || "arrival-greeting",
        ).trim(),
        mapPins:
          e.mapPins && "object" == typeof e.mapPins
            ? {
                startPin: A(e.mapPins.startPin),
                endPin: A(e.mapPins.endPin),
                primaryPin: A(e.mapPins.primaryPin || e.pin),
              }
            : {
                startPin: A(e.startPin),
                endPin: A(e.endPin),
                primaryPin: A(e.pin),
              },
        mapPath: String(e.mapPath || e.path || "").trim(),
        originName: String(e.originName || "").trim(),
        destinationName: String(e.destinationName || "").trim(),
        durationRaw: String(e.durationRaw || "").trim(),
        descriptionHtml: String(e.descriptionHtml || "").trim(),
        directionsHtml: String(e.directionsHtml || "").trim(),
        contactNameRaw: String(e.contactNameRaw || e.contactName || "").trim(),
        contactPhoneRaw: String(e.contactPhoneRaw || e.contactPhone || "").trim(),
        contactEmailRaw: String(e.contactEmailRaw || e.contactEmail || "").trim(),
        meetingInstructionsRaw: String(e.meetingInstructionsRaw || e.meetingInstructions || "").trim(),
        referenceCodeRaw: String(e.referenceCodeRaw || e.referenceCode || "").trim(),
        flightCodeRaw: String(e.flightCodeRaw || e.flightCode || "").trim(),
        terminalRaw: String(e.terminalRaw || "").trim(),
        departureTimeRaw: String(e.departureTimeRaw || e.departureTime || "").trim(),
        arrivalTimeRaw: String(e.arrivalTimeRaw || e.arrivalTime || "").trim(),
        modeLabel: String(e.modeLabel || "").trim(),
        routeMode: String(e.routeMode || e.mode || "").trim(),
        eventTypeLabel: String(e.eventTypeLabel || t.eventTypeLabel || "").trim(),
      };
    },
    Ee = (e, t, n = {}) => {
      const r = Ce([
          e.mode,
          e.label,
          e.type,
          e.variant,
          e.startLocation,
          e.endLocation,
          n.startLabelText,
          n.endLabelText,
          e.referenceCode,
          e.flightCode,
          e.startTerminal,
          e.endTerminal,
          e.terminal,
          e.meetingInstructions,
          e.contactName,
          e.contactPhone,
          e.contactEmail,
        ]),
        i = a.some((e) => e.test(r)),
        o = Boolean(
          e.referenceCode ||
          e.flightCode ||
          e.startTerminal ||
          e.endTerminal ||
          e.terminal ||
          e.checkInTime ||
          e.arrivalTime ||
          e.departureTime ||
          e.meetingInstructions ||
          e.contactName ||
          e.contactPhone ||
          e.contactEmail,
        ),
        c = [
          { pin: e.startPin, fallbackLabel: n.startLabelText },
          { pin: e.endPin, fallbackLabel: n.endLabelText },
        ].some((e) => {
          const n = String(e.pin || "").trim();
          if (!n) return !1;
          const r = t?.byPin?.get(n) || [];
          return 0 === r.length
            ? D(e.fallbackLabel)
            : r.some((e) =>
                D(
                  e.corpus,
                  e.title,
                  e.wetuType,
                  e.wetuCategory,
                  e.wetuSubcategory,
                ),
              );
        });
      return i || o || c;
    },
    He = (e, t, r, i, a = {}) => {
      const o = U(a.categoryHints),
        c = [t, r, o];
      if (Le(c)) return null;
      if (
        !((...e) => {
          const t = Ce(e);
          return !!t && n.some((e) => e.test(t));
        })(c)
      )
        return null;
      const s = Ne(e, i, {
        kind: a.kind || "product",
        title: t,
        meta: r,
        categoryHints: o,
      });
      if (!s) return null;
      const l = s.handle,
        d = et(s, {
          kind: a.kind || "product",
          title: t,
          meta: r,
          categoryHints: o,
        });
      return {
        type: "product",
        template: "product",
        title:
          String(s.title || "").trim() ||
          String(t || "Linked product").trim() ||
          "Linked product",
        meta: String(r || "").trim(),
        tagline: R(String(s.tagline || "").trim(), { pin: e, handle: l }),
        handle: l,
        url: d,
        displayUrl: d,
        featuredImage: s.featuredImageLarge || s.featuredImage || "",
        resolutionSource: s.source,
        wetuType: String(s.wetuType || "").trim(),
        wetuCategory: String(s.wetuCategory || "").trim(),
        wetuSubcategory: String(s.wetuSubcategory || "").trim(),
        entityPin: A(e),
      };
    },
    De = ({
      pin: e,
      title: t,
      meta: n,
      entityResolver: r,
      kind: i,
      categoryHints: a,
      fallbackHandle: o,
      fallbackUrl: c,
      fallbackImage: s,
      fallbackResolutionSource: l,
    }) => {
      const d = He(e, t, n, r, { kind: i, categoryHints: a });
      if (d) return d;
      const m = String(o || "").trim(),
        u = String(c || Xe(m)).trim();
      return u
        ? {
            type: "product",
            template: "product",
            title: String(t || "Linked product").trim(),
            meta: String(n || "").trim(),
            tagline: "",
            handle: m,
            url: u,
            displayUrl: u,
            featuredImage: String(s || "").trim(),
            resolutionSource: String(l || "leg-fallback").trim(),
            entityPin: A(e),
          }
        : null;
    },
    Me = (e, t, n, r) => {
      const i = (e, t, n) => String(t || "").trim() || (e ? `PIN ${e}` : n),
        a = ((e) => {
          const t = String(e || "")
            .trim()
            .toLowerCase();
          return /(^|\b)self\s*[- ]?\s*drive\b/.test(t)
            ? "route-selfdrive"
            : t.includes("flight") || t.includes("air")
              ? "route-flight"
              : "route-transfer";
        })(e.mode);
      let o = "Route map placeholder",
        c =
          "Interactive route map plotting is queued for this itinerary route.";
      return (
        "route-selfdrive" === a
          ? ((o = "Self-drive route map placeholder"),
            (c =
              "This panel will render the plotted self-drive route map in a follow-up map task."))
          : "route-flight" === a
            ? ((o = "Flight path placeholder"),
              (c =
                "This panel will render the plotted flight path map in a follow-up map task."))
            : "route-transfer" === a &&
              ((o = "Transfer route map placeholder"),
              (c =
                "This panel will render the plotted transfer route map in a follow-up map task.")),
        {
          type: "route",
          template: a,
          title: n,
          meta: `${t} | ${ge(e.mode, e.label)}`,
          path: `${i(e.startPin, e.startLocation, "Origin")} → ${i(e.endPin, e.endLocation, "Destination")}`,
          window:
            e.startTime || e.endTime
              ? `Time window: ${[e.startTime, e.endTime].filter(Boolean).join(" - ")}`
              : "Time window: Not scheduled",
          duration: e.duration
            ? `Duration: ${e.duration}`
            : "Duration: Not provided",
          vehicle: e.vehicle
            ? `Vehicle: ${e.vehicle}`
            : "Vehicle: Not provided",
          agency: e.agency ? `Agency: ${e.agency}` : "Agency: Not provided",
          summary: r,
          mapTitle: o,
          mapCopy: c,
          sourceType: "route",
          eventGroup: "logistics",
          eventTypeId: v2ClassifyRouteEvent(e).eventTypeId,
          mapPins: {
            startPin: A(e.startPin),
            endPin: A(e.endPin),
            primaryPin: A(e.endPin || e.startPin),
          },
          mapPath: `${i(e.startPin, e.startLocation, "Origin")} → ${i(e.endPin, e.endLocation, "Destination")}`,
        }
      );
    },
    je = (e, t, n, r) => {
      const i = ye(e.type, e.name || n);
      let a = "Travel segment map placeholder",
        o =
          "This panel will render plotted transport details in a follow-up map task.";
      "Flight" === i
        ? ((a = "Flight segment map placeholder"),
          (o =
            "This panel will render the plotted flight segment map in a follow-up map task."))
        : "Rail" === i
          ? ((a = "Rail segment map placeholder"),
            (o =
              "This panel will render the plotted rail segment map in a follow-up map task."))
          : "Self-drive" === i
            ? ((a = "Self-drive segment map placeholder"),
              (o =
                "This panel will render the plotted self-drive segment map in a follow-up map task."))
            : "Transfer" === i &&
              ((a = "Transfer segment map placeholder"),
              (o =
                "This panel will render the plotted transfer segment map in a follow-up map task."));
      const c = ce(e.descriptionHtml || "");
      return {
        type: "travel-stop",
        template: "travel-stop",
        title: n,
        meta: r || `${t} | ${i}`,
        mode: i,
        path: String(e.name || "").trim() || "Location pending",
        window:
          e.arrivalTime || e.departureTime
            ? `Time window: ${[e.arrivalTime, e.departureTime].filter(Boolean).join(" - ")}`
            : "Time window: Not scheduled",
        summary: c || "Detailed transport notes are pending for this segment.",
        mapTitle: a,
        mapCopy: o,
        sourceType: "stop",
        eventGroup: "stay",
        eventTypeId: "mobile-stop",
        mapPins: {
          startPin: "",
          endPin: "",
          primaryPin: A(e.contentEntityId),
        },
        mapPath: String(e.name || "").trim() || "Location pending",
      };
    },
    Re = ({ label: e, title: t, meta: n, summary: r, source: i }) => ({
      type: "timeline",
      template: "timeline-detail",
      label: String(e || "Timeline").trim() || "Timeline",
      title: String(t || "Timeline event").trim() || "Timeline event",
      meta: String(n || "").trim(),
      summary:
        ce(r) || "No additional timeline detail available for this item.",
      source: String(i || "").trim(),
      eventGroup: "daily",
      eventTypeId: "expert-tip",
      eventTypeLabel: "Expert tip",
    }),
    Be = (e) => {
      const t = [];
      for (const [n, r] of Object.entries(e || {})) {
        if (!n || "string" != typeof n || !n.startsWith("data-")) continue;
        if (null == r) continue;
        const e = String(r).trim();
        e && t.push(`${n}="${b(e)}"`);
      }
      return t.length > 0 ? ` ${t.join(" ")}` : "";
    },
    Oe = (e) => {
      const t = Array.isArray(e.timelineEvents)
        ? e.timelineEvents.filter(Boolean)
        : [];
      return 0 === t.length
        ? ""
        : `\n        <section class="itin-command-center__day-activities">\n          <p class="itin-command-center__ui-label">Timeline</p>\n          <ol class="itin-command-center__activity-timeline" role="list">\n            ${t
            .map((t) => {
              const n = ["itin-command-center__activity-item"];
              t.isHighlight && n.push("is-highlight");
              const rGroup = String(t.eventGroup || "").trim().toLowerCase();
              rGroup && n.push(`is-group-${rGroup}`);
              const r =
                  String(t.title || "Scheduled item").trim() ||
                  "Scheduled item",
                i = ((e) => {
                  const t = String(e?.startTime || "").trim(),
                    n = String(e?.endTime || "").trim();
                  return t && n && t !== n
                    ? `${t} - ${n}`
                    : t || n || "Any time";
                })(t),
                a = ((e) =>
                  String(e.eventTypeLabel || "").trim() ||
                  ("route" === e.kind
                    ? ge(e.routeMode, e.title)
                    : "travel-stop" === e.kind
                      ? "Stay"
                      : "day-tour" === e.kind
                        ? "Daily"
                        : "logistics" === e.kind
                          ? "Logistics"
                          : String(e.eventTypeLabel || "Activity").trim() ||
                            "Activity"))(t),
                o = ((e) =>
                  "route" === e.kind
                    ? String(e.routePathText || "").trim()
                    : "travel-stop" === e.kind
                      ? String(e.routePathText || e.title || "").trim()
                      : "logistics" === e.kind
                        ? String(e.meta || "").trim()
                        : "")(t),
                c = [a, o].filter(Boolean).join(" · "),
                s = String(t.cardId || "").trim();
              if (s) {
                const a = String(
                    t.inspectorPayload?.featuredImage || "",
                  ).trim(),
                  o =
                    t.inspectorPayload && "object" == typeof t.inspectorPayload
                      ? t.inspectorPayload
                      : null,
                  l = R(String(o?.tagline || "").trim(), {
                    pin: o?.entityPin || t.sourceContentEntityId,
                    handle: o?.handle,
                  }),
                  d = Boolean(o && "product" === o.type),
                  m = r,
                  u = [];
                if (d) {
                  const e = String(o?.title || "").trim();
                  e && _e(e) !== _e(m) && u.push(e);
                }
                c && u.push(c);
                const p = u.join(" · "),
                  g =
                    l && _e(l) !== _e(m) && (!d || _e(l) !== _e(o?.title || ""))
                      ? l
                      : "",
                  y = {
                    "data-card-kind": t.kind || "activity",
                    ...(t.dataset || {}),
                    "data-command-center-event-group": t.eventGroup || "",
                    "data-command-center-event-type": t.eventTypeId || "",
                    "data-command-center-card-id": s,
                    "data-command-center-card-day-key": e.dayKey,
                    "data-command-center-card-day-number": e.dayNumber,
                  },
                  f = Be(y),
                  h = ["itin-command-center__activity-card"];
                return (
                  a && h.push("has-media"),
                  `\n            <li class="${n.join(" ")}">\n              <button type="button" class="${h.join(" ")}" aria-pressed="false"${f}>\n                ${a ? `<span class="itin-command-center__activity-card-media">\n                       <img src="${b(a)}" alt="${b(r)}" loading="lazy" width="192" height="144">\n                     </span>` : ""}\n                <span class="itin-command-center__activity-card-copy">\n                  <span class="itin-command-center__activity-card-time">${b(i)}</span>\n                  <span class="itin-command-center__activity-card-title">${b(m)}</span>\n                  ${p ? `<span class="itin-command-center__activity-card-meta">${b(p)}</span>` : ""}\n                  ${g ? `<span class="itin-command-center__activity-card-tagline">${b(g)}</span>` : ""}\n                </span>\n              </button>\n            </li>\n          `
                );
              }
              return `\n          <li class="${n.join(" ")}">\n            <p class="itin-command-center__activity-inline">\n              <span class="itin-command-center__activity-inline-time">${b(i)}</span>\n              <span class="itin-command-center__activity-inline-title">${b(r)}</span>\n              ${c ? `<span class="itin-command-center__activity-inline-meta">${b(c)}</span>` : ""}\n            </p>\n          </li>\n        `;
            })
            .join("")}\n          </ol>\n        </section>\n      `;
    },
    Ue = (e, t) => {
      if (!e || "object" != typeof e) return null;
      const n =
          e.source_json && "object" == typeof e.source_json ? e.source_json : e,
        r = pe(_(n, "legs"));
      if (0 === r.length) return null;
      const i = pe(_(n, "routes")),
        a = String(
          _(n, "name") || _(n, "reference_number") || "Itinerary",
        ).trim(),
        o = q(),
        c = H({ scope: "intro", contextKey: "journey-intro", registry: o }),
        s = _(n, "introductory_headline"),
        l = Y(T(s && "object" == typeof s ? s : {}, ["text", "headline"])),
        d = ((e) => {
          const t = String(e || "").trim();
          if (!t) return "";
          const n = new DOMParser().parseFromString(
            `<div>${t}</div>`,
            "text/html",
          ).body.firstElementChild;
          if (!n) return t;
          const r = (e) => /^tour frame\b/i.test(String(e || "").trim()),
            i = (e) => {
              if (!(e instanceof Element)) return !0;
              if (/^H[1-6]$/i.test(e.tagName)) return !0;
              const t = ce(e.textContent || "");
              return (
                !!t && /^(overview|highlights?|journey|day\s+\d+)\b/i.test(t)
              );
            },
            a = Array.from(n.children);
          for (const e of a) {
            const t = ce(e.textContent || "");
            if (!r(t)) continue;
            const n =
              /^H[1-6]$/i.test(e.tagName) || /^tour frame\s*:?$/i.test(t);
            let a = e.nextElementSibling;
            if ((e.remove(), n))
              for (; a && !i(a); ) {
                const e = a.nextElementSibling;
                (a.remove(), (a = e));
              }
          }
          const o = Array.from(
            n.querySelectorAll(
              "p, li, h1, h2, h3, h4, h5, h6, blockquote, strong",
            ),
          );
          for (const e of o) {
            const t = ce(e.textContent || "");
            if (!/^demonstration itinerary\b/i.test(t)) continue;
            const n = e.parentElement;
            (e.remove(),
              n &&
                ["P", "LI", "BLOCKQUOTE"].includes(n.tagName) &&
                "" === ce(n.textContent || "") &&
                n.remove());
          }
          return n.innerHTML
            .replace(/\s{2,}/g, " ")
            .replace(/\n{3,}/g, "\n\n")
            .trim();
        })(
          oe(_(n, "summary") || _(n, "description"), t, { pinLinkContext: c }),
        ),
        m = l ? `<p>${b(l)}</p>` : d,
        u = ((e) => {
          const t = X(e),
            n = [];
          if (
            (t.priorities.length > 0 &&
              n.push({
                label: "Priorities and values",
                items: t.priorities.map((e) => e.label),
              }),
            t.standards.length > 0 &&
              n.push({
                label: "Operational standards",
                items: t.standards.map((e) => e.label),
              }),
            n.length > 0)
          )
            return n;
          const r = W(_(e, "categories")),
            i = W(_(e, "special_interests") || _(e, "specialInterests")),
            a = new Set(),
            o = ((e) => {
              const t = [];
              for (const n of e) {
                const e = K(n),
                  r = G(e);
                if (
                  e &&
                  r &&
                  !a.has(r) &&
                  (a.add(r), t.push(e), t.length >= 12)
                )
                  break;
              }
              return t;
            })([...i, ...r]);
          return (o.length > 0 && n.push({ label: "Trip focus", items: o }), n);
        })(n),
        p = w(_(n, "days"), 0),
        g = ((e) => {
          const t = String(e || "").trim();
          if (!t) return null;
          const n = t.match(/^(\d{4})-(\d{2})-(\d{2})/);
          if (!n) return null;
          const r = Number.parseInt(n[1], 10),
            i = Number.parseInt(n[2], 10),
            a = Number.parseInt(n[3], 10);
          return Number.isFinite(r) && Number.isFinite(i) && Number.isFinite(a)
            ? { year: r, month: i, day: a }
            : null;
        })(T(n, ["start_date", "travel_start_date", "arrival_date"])),
        y = X(n),
        cfs = clientFacingExtract(n),
        f = ((e, t) => {
          const n = U(_(e, "participant_model")),
            r = U(_(e, "travellers")),
            i = Array.isArray(t?.travellerProfiles) ? t.travellerProfiles : [],
            a = [];
          let o = "legacy";
          if (n.length > 0)
            for (const e of n) {
              const t = e && "object" == typeof e.identity ? e.identity : {},
                n = e && "object" == typeof e.biography ? e.biography : {},
                r =
                  e && "object" == typeof e.party_dynamics
                    ? e.party_dynamics
                    : {},
                i =
                  e && "object" == typeof e.logistics_preferences
                    ? e.logistics_preferences
                    : {},
                o = String(T(t, ["full_name", "name"]) || "").trim();
              if (!o) continue;
              const c = String(T(t, ["age_category"]) || "").trim(),
                s = V(c, Z(T(t, ["age", "age_years"])));
              a.push({
                participantId: String(
                  T(e, ["participant_id", "id"]) || "",
                ).trim(),
                fullName: o,
                knownAs: String(
                  T(t, ["known_as", "display_name"]) || "",
                ).trim(),
                honorific: String(T(t, ["honorific", "title"]) || "").trim(),
                ageCategory: s || "Adult",
                role: String(
                  T(r, ["relationship_to_lead", "relationship"]) || "",
                ).trim(),
                familyUnit: String(
                  T(r, ["immediate_family_unit"]) || "",
                ).trim(),
                guardianId: String(T(r, ["guardian_id"]) || "").trim(),
                biographySummary: String(
                  T(n, ["public_persona", "professional_background"]) || "",
                ).trim(),
                achievements: U(_(n, "notable_achievements"))
                  .map((e) => String(e || "").trim())
                  .filter(Boolean),
                interests: U(_(i, "interests"))
                  .map((e) => String(e || "").trim())
                  .filter(Boolean),
              });
            }
          a.length > 0 && (o = "participant_model");
          if (0 === a.length && r.length > 0)
            for (const e of r) {
              const t = String(
                T(e, ["name", "display_name", "full_name"]) || "",
              ).trim();
              if (!t) continue;
              const n = String(
                  T(e, ["type", "traveller_type", "traveler_type"]) || "",
                ).trim(),
                r = T(e, ["age"]),
                i = V(n, Z(r) || "Adult");
              a.push({
                participantId: "",
                fullName: [String(T(e, ["title"]) || "").trim(), t]
                  .filter(Boolean)
                  .join(" ")
                  .trim(),
                knownAs: "",
                honorific: String(T(e, ["title"]) || "").trim(),
                ageCategory: i || "Adult",
                role: "",
                familyUnit: "",
                guardianId: "",
                biographySummary: "",
                achievements: [],
                interests: [],
              });
            }
          0 === a.length && r.length > 0 && (o = "travellers");
          if (0 === a.length && i.length > 0)
            for (const e of i) {
              const t = String(e?.name || "").trim();
              if (!t) continue;
              a.push({
                participantId: "",
                fullName: t,
                knownAs: "",
                honorific: "",
                ageCategory: "Adult",
                role: String(e?.role || "").trim(),
                familyUnit: "",
                guardianId: "",
                biographySummary: "",
                achievements: [],
                interests: String(e?.interestsSummary || "")
                  .split(",")
                  .map((e) => String(e || "").trim())
                  .filter(Boolean),
                dietarySummary: String(e?.dietarySummary || "").trim(),
                accommodationsMade: Array.isArray(e?.accommodationsMade)
                  ? e.accommodationsMade
                  : [],
              });
            }
          "legacy" === o &&
            0 !== a.length &&
            0 !== i.length &&
            (o = "client_facing_summary");
          const c = new Map();
          for (const e of a) {
            const t = String(e.participantId || "")
              .trim()
              .toLowerCase();
            t && e.fullName && c.set(t, e.fullName);
          }
          for (const e of a) {
            const t = String(e.guardianId || "").trim();
            if (!t) {
              e.guardianLabel = "";
              continue;
            }
            const n = t.toLowerCase();
            e.guardianLabel = c.get(n) || t;
          }
          let s = 0,
            l = 0,
            d = 0;
          for (const e of a) {
            const t = String(e.ageCategory || "").toLowerCase();
            ["infant", "child", "teen"].includes(t)
              ? ((l += 1), e.guardianId && (d += 1))
              : (s += 1);
          }
          return {
            profiles: a,
            total: a.length,
            adults: s,
            children: l,
            linkedMinors: d,
            source: o,
          };
        })(n, cfs),
        h = ((e) => {
          const t = _(e, "pricing"),
            n = _(e, "pricing_architecture"),
            r = _(e, "financial_terms"),
            pp = _(e, "plekify_pricing"),
            cm = _(e, "commercial"),
            pSrc =
              pp && "object" == typeof pp
                ? pp
                : cm && "object" == typeof cm
                  ? cm
                  : null,
            i =
              t && "object" == typeof t
                ? t
                : null,
            a =
              n && "object" == typeof n
                ? n
                : null,
            o =
              r && "object" == typeof r
                ? r
                : null,
            c = Array.isArray(i?.breakdown)
              ? i.breakdown
              : Array.isArray(i?.price_components)
                ? i.price_components
                : [],
            s = W(
              i?.inclusions ||
                i?.financial_terms?.inclusions ||
                a?.financial_terms?.inclusions ||
                o?.inclusions ||
                T(e, ["price_includes", "pricing_includes", "includes"]),
            ),
            l = W(
              i?.exclusions ||
                i?.financial_terms?.exclusions ||
                a?.financial_terms?.exclusions ||
                o?.exclusions ||
                T(e, ["price_excludes", "pricing_excludes", "excludes"]),
            ),
            safePriceFromString = (v) => {
              if ("number" == typeof v && Number.isFinite(v)) return v;
              const t = String(v ?? "").trim();
              if (!t) return 0;
              const n = t.match(/[\d][,\d]*(?:\.\d+)?/);
              if (!n) return 0;
              const r = Number.parseFloat(n[0].replace(/,/g, ""));
              return Number.isFinite(r) ? r : 0;
            },
            phasesFromSrc = Array.isArray(i?.phases)
              ? i.phases
              : pSrc && Array.isArray(pSrc.phases)
                ? pSrc.phases
                : Array.isArray(a?.phases)
                  ? a.phases
                  : [],
            scheduleFromSrc = Array.isArray(i?.payment_schedule)
              ? i.payment_schedule
              : Array.isArray(i?.paymentSchedule)
                ? i.paymentSchedule
                : Array.isArray(i?.financial_terms?.payment_schedule)
                  ? i.financial_terms.payment_schedule
                  : Array.isArray(i?.financial_terms?.paymentSchedule)
                    ? i.financial_terms.paymentSchedule
                    : pSrc && Array.isArray(pSrc.payment_schedule)
                      ? pSrc.payment_schedule
                      : Array.isArray(a?.payment_schedule)
                        ? a.payment_schedule
                        : Array.isArray(a?.financial_terms?.payment_schedule)
                          ? a.financial_terms.payment_schedule
                          : Array.isArray(a?.financial_terms?.paymentSchedule)
                            ? a.financial_terms.paymentSchedule
                            : Array.isArray(o?.payment_schedule)
                              ? o.payment_schedule
                              : Array.isArray(o?.paymentSchedule)
                                ? o.paymentSchedule
                                : [],
            scheduleTotal = scheduleFromSrc.reduce((e, t) => {
              const n = z(T(t || {}, ["amount", "total"]), Number.NaN);
              return Number.isFinite(n) ? e + n : e;
            }, 0),
            grandTotal = z(
              T(i || {}, ["total_investment", "totalInvestment"]),
              z(
                T(a || {}, ["total_investment", "totalInvestment"]),
                z(
                  T(pSrc || {}, [
                    "grand_total",
                    "grandTotal",
                    "total_investment",
                    "totalInvestment",
                  ]),
                  scheduleTotal > 0
                    ? scheduleTotal
                    : safePriceFromString(T(e, ["price"])),
                ),
              ),
            ),
            pCurrency =
              String(T(i || {}, ["currency"]) || "").trim() ||
              String(T(a || {}, ["currency"]) || "").trim() ||
              String(T(o || {}, ["currency"]) || "").trim() ||
              String(T(pSrc || {}, ["currency"]) || "").trim() ||
              String(T(e, ["currency"]) || "").trim() ||
              "USD",
            pSummary = i?.summary || a?.summary || pSrc?.summary || {};
          return {
            currency: pCurrency,
            totalInvestment: grandTotal,
            adultAverage: z(pSummary?.adult_rate_average, 0),
            childAverage: z(pSummary?.child_rate_average, 0),
            logisticsTotal: z(pSummary?.fixed_logistics_total, 0),
            includes: be(s.map((e) => Y(e)).filter(Boolean)),
            excludes: be(l.map((e) => Y(e)).filter(Boolean)),
            componentCount: c.length,
            components: c,
            phases: phasesFromSrc,
            paymentSchedule: scheduleFromSrc,
          };
        })(n),
        S = _(n, "quick_reference"),
        v =
          S && "object" == typeof S
            ? {
                client: Y(T(S, ["client"])),
                timeline: Y(T(S, ["timeline"])),
                status: Y(T(S, ["status"])),
                includedLogic: Y(
                  T(S?.pricing_summary || {}, [
                    "included_logic",
                    "includedLogic",
                  ]),
                ),
                excludedLogic: Y(
                  T(S?.pricing_summary || {}, [
                    "excluded_logic",
                    "excludedLogic",
                  ]),
                ),
              }
            : {
                client: Y(T(n, ["client_name"])),
                timeline: "",
                status: Y(T(n, ["booking_status"])),
                includedLogic: Y(T(n, ["price_includes", "pricing_includes"])),
                excludedLogic: Y(T(n, ["price_excludes", "pricing_excludes"])),
              },
        k = [];
      for (const e of i) {
        const t = w(_(e, "start_day"), Number.NaN),
          n = w(_(e, "end_day"), Number.NaN);
        (Number.isNaN(t) || k.push(t), Number.isNaN(n) || k.push(n));
      }
      const C = k.includes(0),
        L = (e) => {
          if (Number.isNaN(e)) return null;
          const t = C ? e + 1 : e;
          return t < 1 ? 1 : p > 0 && t > p ? p : t;
        },
        A = (e, n = {}) => {
          const r = w(_(e, "start_day"), Number.NaN),
            i = w(_(e, "end_day"), Number.NaN),
            a = n.pinLinkContext || null,
            o = oe(_(e, "description"), t, { pinLinkContext: a }),
            c = oe(_(e, "directions"), t, { pinLinkContext: a }),
            s = le(
              oe(_(e, "general_description") || _(e, "generalDescription"), t, {
                pinLinkContext: a,
              }),
            );
          return {
            sequence: w(_(e, "sequence"), 0),
            periodSequence: w(n.periodSequence, 0),
            routeScope: String(n.routeScope || "top-level"),
            mode: String(_(e, "mode") || ""),
            label: String(_(e, "label") || ""),
            type: String(_(e, "type") || ""),
            variant: String(_(e, "variant") || ""),
            startTime: P(
              _(e, "start_time") ||
                _(e, "departure_time") ||
                _(e, "check_in_time"),
            ),
            endTime: P(_(e, "end_time") || _(e, "arrival_time")),
            departureTime: P(_(e, "departure_time")),
            arrivalTime: P(_(e, "arrival_time")),
            checkInTime: P(_(e, "check_in_time")),
            startPin: _(e, "start_content_entity_id"),
            endPin: _(e, "end_content_entity_id"),
            startLocation:
              _(e, "start_location") || _(e, "first_location") || "",
            endLocation: _(e, "end_location") || _(e, "second_location") || "",
            descriptionHtml: o,
            directionsHtml: c,
            generalDescriptionHtml: s,
            duration: String(_(e, "duration") || "").trim(),
            vehicle: String(_(e, "vehicle") || "").trim(),
            agency: String(_(e, "agency") || "").trim(),
            referenceCode: Pe(
              _(e, "reference_codes"),
              _(e, "reference_code"),
              _(e, "reference"),
              _(e, "booking_reference"),
            ),
            flightCode: Y(
              String(
                T(e, ["flight_code", "flight_number", "flight_no", "flight"]) ||
                  "",
              ).trim(),
            ),
            ticketClass: Y(String(_(e, "ticket_class") || "").trim()),
            startTerminal: Y(
              String(
                _(e, "start_terminal") || _(e, "departure_terminal") || "",
              ).trim(),
            ),
            endTerminal: Y(
              String(
                _(e, "end_terminal") || _(e, "arrival_terminal") || "",
              ).trim(),
            ),
            terminal: Y(String(_(e, "terminal") || "").trim()),
            meetingInstructions: Y(
              String(
                T(e, [
                  "meeting_instructions",
                  "instructions",
                  "contact_instructions",
                ]) || "",
              ).trim(),
            ),
            contactName: Y(
              String(
                T(e, ["contact_name", "contact_person", "contact"]) || "",
              ).trim(),
            ),
            contactPhone: xe(
              _(e, "contact_numbers"),
              _(e, "contact_alternative_numbers"),
              _(e, "contact_phone"),
              _(e, "phone"),
            ),
            contactEmail: Y(
              String(T(e, ["contact_email", "email"]) || "").trim(),
            ),
            image: B(_(e, "images") || _(e, "image_gallery") || _(e, "media")),
            startDay: L(r),
            endDay: L(i),
          };
        },
        E = i.map((e) => A(e, { periodSequence: 0, routeScope: "top-level" })),
        D = {};
      for (const e of E) {
        const t = e.startDay || e.endDay || (p > 0 ? p : null);
        t && (D[t] || (D[t] = []), D[t].push(e));
      }
      const M = (e, n, r = "") => {
          const i = Ne(e, t, { kind: n, title: r, categoryHints: [n, r] });
          if (!i) return "";
          return (
            String(i.title || "").trim() ||
            ((a = i.handle),
            String(a || "")
              .replace(/[-_]+/g, " ")
              .trim()
              .replace(/\b\w/g, (e) => e.toUpperCase()))
          );
          var a;
        },
        R = [],
        F = [],
        J = {},
        Q = {};
      let ee = "",
        te = 1;
      for (let e = 0; e < r.length; e += 1) {
        const n = r[e],
          i = H({ scope: "leg", legKey: `leg-${e + 1}`, registry: o }),
          a = (e) => oe(e, t, { pinLinkContext: i }),
          c = U(_(n, "periods")),
          s = [];
        for (let e = 0; e < c.length; e += 1) {
          const t = c[e],
            n = w(_(t, "sequence"), e),
            r = Math.max(1, w(_(t, "days"), 1)),
            o = I(
              _(t, "day_narrative"),
              _(t, "dayNarrative"),
              _(t, "notes"),
              _(t, "consultant_notes"),
            ),
            l = N(t, o.dayTitles, r),
            d = (() => {
              const e = _(t, "day_narrative") ?? _(t, "dayNarrative");
              return String(e || "").trim() ? e : (_(t, "notes") ?? "");
            })(),
            m = pe(
              _(t, "greetings") ||
                _(t, "greeting_entries") ||
                _(t, "arrival_greetings") ||
                _(t, "greeting"),
            ).map((e, t) => ({
              sequence: w(_(e, "sequence"), t),
              name: String(
                _(e, "name") ||
                  _(e, "label") ||
                  _(e, "title") ||
                  _(e, "type") ||
                  "Arrival greeting",
              ).trim(),
              type: String(_(e, "type") || _(e, "mode") || "Greeting").trim(),
              dayWithinPeriod: Math.max(
                1,
                w(
                  T(e, [
                    "period_day",
                    "day_in_period",
                    "day_within_period",
                    "day",
                    "start_day",
                    "arrival_day",
                  ]),
                  1,
                ),
              ),
              startTime: P(
                _(e, "start_time") || _(e, "time") || _(e, "arrival_time"),
              ),
              endTime: P(_(e, "end_time") || _(e, "departure_time")),
              arrivalTime: P(_(e, "arrival_time")),
              departureTime: P(_(e, "departure_time")),
              checkInTime: P(_(e, "check_in_time") || _(e, "checkin_time")),
              contentEntityId:
                _(e, "content_entity_id") ||
                _(e, "entity_id") ||
                _(e, "pin_id"),
              location: Y(
                String(
                  _(e, "location") ||
                    _(e, "meeting_point") ||
                    _(e, "venue") ||
                    _(e, "airport") ||
                    "",
                ).trim(),
              ),
              descriptionHtml: le(
                a(
                  _(e, "description") ||
                    _(e, "commentary") ||
                    _(e, "general_description") ||
                    _(e, "notes"),
                ),
              ),
              referenceCode: Pe(
                _(e, "reference"),
                _(e, "reference_code"),
                _(e, "reference_codes"),
                _(e, "flight_number"),
                _(e, "booking_reference"),
              ),
              flightCode: Y(
                String(
                  T(e, ["flight_code", "flight_number", "flight_no"]) || "",
                ).trim(),
              ),
              terminal: Y(
                String(
                  T(e, [
                    "terminal",
                    "arrival_terminal",
                    "departure_terminal",
                  ]) || "",
                ).trim(),
              ),
              meetingInstructions: Y(
                String(
                  T(e, ["meeting_instructions", "instructions"]) || "",
                ).trim(),
              ),
              contactName: Y(
                String(
                  T(e, ["contact_name", "contact_person", "contact"]) || "",
                ).trim(),
              ),
              contactPhone: xe(
                _(e, "contact_numbers"),
                _(e, "contact_alternative_numbers"),
                _(e, "contact_phone"),
                _(e, "phone"),
              ),
              contactEmail: Y(
                String(T(e, ["contact_email", "email"]) || "").trim(),
              ),
              image: B(
                _(e, "images") || _(e, "media") || _(e, "image_gallery"),
              ),
            }));
          s.push({
            periodSequence: n,
            days: r,
            dayTitles: l,
            narrativeHtml: le(a(d)),
            notesHtml: le(a(_(t, "notes"))),
            includedHtml: a(_(t, "included")),
            excludedHtml: a(_(t, "excluded")),
            roomBasis: String(_(t, "room_basis") || _(t, "roomBasis") || "").trim(),
            drinksBasis: String(_(t, "drinks_basis") || _(t, "drinksBasis") || "").trim(),
            verseHtml: a(_(t, "verse") || _(t, "morning_verse")),
            commentaryItems: U(_(t, "commentary_items"))
              .map((e) => ({
                time: P(_(e, "time")),
                contentHtml: le(a(_(e, "content"))),
              }))
              .filter((e) => e.contentHtml && !se(e.contentHtml)),
            activities: pe(_(t, "activities"))
              .map((e) => ({
                sequence: w(_(e, "sequence"), 0),
                name: String(_(e, "name") || "").trim(),
                type: String(_(e, "type") || "").trim(),
                startTime: P(_(e, "start_time")),
                endTime: P(_(e, "end_time")),
                contentEntityId: _(e, "content_entity_id"),
                descriptionHtml: le(
                  a(_(e, "description") || _(e, "commentary")),
                ),
                isHighlight:
                  x(
                    T(e, [
                      "highlight",
                      "is_highlight",
                      "featured",
                      "is_featured",
                    ]),
                  ) || /\bhighlight\b/i.test(String(_(e, "type") || "")),
                dayWithinPeriod: (() => {
                  const t = w(
                    T(e, [
                      "period_day",
                      "day_in_period",
                      "day_within_period",
                      "day",
                      "start_day",
                      "arrival_day",
                    ]),
                    Number.NaN,
                  );
                  return Number.isNaN(t) ? null : Math.max(1, t);
                })(),
                repeatDaily:
                  x(
                    T(e, [
                      "repeat_daily",
                      "show_daily",
                      "all_days",
                      "is_daily",
                    ]),
                  ) ||
                  /\b(daily|every day)\b/i.test(
                    `${String(_(e, "type") || "")} ${String(_(e, "name") || "")}`,
                  ),
              }))
              .filter((e) => (e.name || e.descriptionHtml) && !isBufferActivity(e)),
            dayTours: pe(_(t, "day_tours"))
              .map((e) => ({
                sequence: w(_(e, "sequence"), 0),
                name: String(_(e, "name") || "").trim(),
                type: String(_(e, "type") || "").trim(),
                startTime: P(_(e, "start_time")),
                endTime: P(_(e, "end_time")),
                contentEntityId: _(e, "content_entity_id"),
                descriptionHtml: le(a(_(e, "description"))),
                isHighlight:
                  x(
                    T(e, [
                      "highlight",
                      "is_highlight",
                      "featured",
                      "is_featured",
                    ]),
                  ) || /\bhighlight\b/i.test(String(_(e, "type") || "")),
                dayWithinPeriod: (() => {
                  const t = w(
                    T(e, [
                      "period_day",
                      "day_in_period",
                      "day_within_period",
                      "day",
                      "start_day",
                      "arrival_day",
                    ]),
                    Number.NaN,
                  );
                  return Number.isNaN(t) ? null : Math.max(1, t);
                })(),
                repeatDaily:
                  x(
                    T(e, [
                      "repeat_daily",
                      "show_daily",
                      "all_days",
                      "is_daily",
                    ]),
                  ) ||
                  /\b(daily|every day)\b/i.test(
                    `${String(_(e, "type") || "")} ${String(_(e, "name") || "")}`,
                  ),
              }))
              .filter((e) => e.name || e.descriptionHtml),
            periodRoutes: pe(_(t, "routes")).map((e) =>
              A(e, {
                periodSequence: n,
                routeScope: "period",
                pinLinkContext: i,
              }),
            ),
            greetings: m,
          });
        }
        const l = s.reduce((e, t) => e + t.days, 0),
          d = Math.max(0, w(_(n, "nights"), 0)),
          m = l || d || (s.length > 0 ? s.length : 1),
          u = te,
          p = u + m - 1,
          g = String(_(n, "type") || "").trim(),
          y = _(n, "destination_content_entity_id"),
          f = _(n, "content_entity_id"),
          h = String(_(n, "destination_name") || "").trim(),
          S = String(_(n, "accommodation_name") || "").trim(),
          legTitleRaw = String(_(n, "leg_title") || "").trim(),
          legTitleDest = legTitleRaw.replace(/\s*\(\d+\s*days?\)\s*$/i, "").trim(),
          b = h || legTitleDest || M(y, "destination", g),
          v = S || M(f, "accommodation", g),
          k = ce(
            a(_(n, "day_summary") || _(n, "summary") || _(n, "description")),
          ),
          propertyRationaleRaw = String(_(n, "property_selection_rationale") || "").trim(),
          $ = Ne(y, t, {
            kind: "destination",
            title: b || g || `Leg ${e + 1}`,
            categoryHints: ["destination", "city", "region", "country", b],
          }),
          C = Ne(f, t, {
            kind: "accommodation",
            title: v || b || g || `Leg ${e + 1}`,
            categoryHints: ["accommodation", "property", "lodge", b, v],
          }),
          L = pe(_(n, "stops")),
          q = [];
        for (const e of L) {
          const t = w(_(e, "arrival_day"), Number.NaN);
          Number.isNaN(t) || q.push(t);
        }
        const E = q.includes(0),
          D = (e) => {
            if (Number.isNaN(e)) return 1;
            const t = E ? e + 1 : e;
            return Math.max(1, t);
          },
          j = L.map((t, n) => {
            const r = w(_(t, "arrival_day"), Number.NaN),
              i = w(_(t, "departure_day"), Number.NaN),
              o = D(r),
              c = D(i),
              s = _(t, "content_entity_id"),
              l = String(_(t, "type") || "").trim(),
              d =
                String(_(t, "name") || _(t, "title") || "").trim() ||
                M(s, "destination", l);
            return {
              sequence: w(_(t, "sequence"), n),
              stopId: _(t, "id") || _(t, "stop_id") || `leg-${e}-stop-${n}`,
              name: d || l || `Stop ${n + 1}`,
              type: l || "Stop",
              arrivalDayWithinLeg: o,
              departureDayWithinLeg: c,
              arrivalDay: Math.min(p, Math.max(u, u + o - 1)),
              arrivalTime: P(_(t, "arrival_time") || _(t, "start_time")),
              departureTime: P(_(t, "departure_time") || _(t, "end_time")),
              checkInTime: P(_(t, "check_in_time") || _(t, "checkin_time")),
              contentEntityId: s,
              location: Y(
                String(
                  _(t, "location") ||
                    _(t, "meeting_point") ||
                    _(t, "airport") ||
                    "",
                ).trim(),
              ),
              descriptionHtml: le(a(_(t, "description") || _(t, "commentary"))),
              referenceCode: Pe(
                _(t, "reference"),
                _(t, "reference_code"),
                _(t, "reference_codes"),
                _(t, "flight_number"),
                _(t, "booking_reference"),
              ),
              terminal: Y(
                String(
                  T(t, [
                    "terminal",
                    "arrival_terminal",
                    "departure_terminal",
                  ]) || "",
                ).trim(),
              ),
              meetingInstructions: Y(
                String(
                  T(t, ["meeting_instructions", "instructions"]) || "",
                ).trim(),
              ),
              contactName: Y(
                String(
                  T(t, ["contact_name", "contact_person", "contact"]) || "",
                ).trim(),
              ),
              contactPhone: xe(
                _(t, "contact_numbers"),
                _(t, "contact_alternative_numbers"),
                _(t, "contact_phone"),
                _(t, "phone"),
              ),
              contactEmail: Y(
                String(T(t, ["contact_email", "email"]) || "").trim(),
              ),
              image: B(
                _(t, "images") || _(t, "media") || _(t, "image_gallery"),
              ),
            };
          }),
          O = g || `Leg ${e + 1}`,
          K = ue({
            destinationName: b,
            accommodationName: v,
            stopNames: j.map((e) => e.name),
            fallbackTitle: O,
          }),
          G = K,
          W = g.toLowerCase(),
          z = W.includes("standard") || "" === g,
          J = W.includes("mobile");
        if (
          (R.push({
            index: e,
            name: K,
            chapterTitle: G,
            type: g,
            accommodationName: v,
            destinationName: b,
            daySummaryText: k,
            contentEntityId: f,
            destinationContentEntityId: y,
            primaryProductHandle: C?.handle || "",
            primaryProductUrl: C
              ? et(C, {
                  kind: "accommodation",
                  title: v || b || g || `Leg ${e + 1}`,
                  categoryHints: ["accommodation", "property", "lodge", b, v],
                })
              : "",
            primaryProductImage:
              C?.featuredImageLarge || C?.featuredImage || "",
            destinationProductHandle: $?.handle || "",
            destinationProductUrl: $
              ? et($, {
                  kind: "destination",
                  title: b || g || `Leg ${e + 1}`,
                  categoryHints: [
                    "destination",
                    "city",
                    "region",
                    "country",
                    b,
                  ],
                })
              : "",
            destinationProductImage:
              $?.featuredImageLarge || $?.featuredImage || "",
            propertyProductHandle: C?.handle || "",
            propertyProductUrl: C
              ? et(C, {
                  kind: "accommodation",
                  title: v || b || g || `Leg ${e + 1}`,
                  categoryHints: ["accommodation", "property", "lodge", b, v],
                })
              : "",
            propertyProductImage:
              C?.featuredImageLarge || C?.featuredImage || "",
            checkInTime: P(_(n, "check_in_time")),
            checkOutTime: P(_(n, "check_out_time")),
            startDay: u,
            endDay: p,
            isStandardLeg: z,
            isMobileLeg: J,
            stops: j,
            propertySelectionRationale: propertyRationaleRaw,
            tagline: String(_(n, "tagline") || "").trim(),
          }),
          s.length > 0)
        ) {
          const v2ItemsForPeriodDay = (e, t, n) =>
            Array.isArray(e)
              ? e
                  .filter((e) => {
                    const r = w(e.dayWithinPeriod, Number.NaN);
                    if (!Number.isNaN(r)) {
                      const i = Math.max(1, Math.min(n, r));
                      return i === t;
                    }
                    return Boolean(e.repeatDaily) || 1 === t;
                  })
                  .map((e) => ({ ...e }))
              : [];
          let t = 0;
          for (const r of s)
            for (let i = 0; i < r.days; i += 1) {
              const a = u + t;
              ((t += 1),
                F.push({
                  dayNumber: a,
                  legIndex: e,
                  legName: K,
                  sourceDayTitle: r.dayTitles[i] || r.dayTitles[0] || "",
                  destinationName: b,
                  destinationContentEntityId: y,
                  accommodationName: v,
                  accommodationContentEntityId: f,
                  checkInTime: P(_(n, "check_in_time")),
                  checkOutTime: P(_(n, "check_out_time")),
                  periodSequence: r.periodSequence,
                  narrativeHtml: r.narrativeHtml,
                  notesHtml: r.notesHtml,
                  includedHtml: r.includedHtml,
                  excludedHtml: r.excludedHtml,
                  roomBasis: r.roomBasis,
                  drinksBasis: r.drinksBasis,
                  verseHtml: r.verseHtml,
                  commentaryItems: r.commentaryItems,
                  activities: v2ItemsForPeriodDay(r.activities, i + 1, r.days),
                  dayTours: v2ItemsForPeriodDay(r.dayTours, i + 1, r.days),
                  periodRoutes: r.periodRoutes.map((e) => ({ ...e })),
                  greetings: r.greetings
                    .filter((e) => w(e.dayWithinPeriod, 1) === i + 1)
                    .map((e) => ({ ...e })),
                  topRoutes: [],
                  timelineEvents: [],
                }));
            }
        } else
          for (let t = 0; t < m; t += 1)
            F.push({
              dayNumber: u + t,
              legIndex: e,
              legName: K,
              sourceDayTitle: "",
              destinationName: b,
              destinationContentEntityId: y,
              accommodationName: v,
              accommodationContentEntityId: f,
              checkInTime: P(_(n, "check_in_time")),
              checkOutTime: P(_(n, "check_out_time")),
              periodSequence: 0,
              narrativeHtml: "",
              notesHtml: "",
              includedHtml: "",
              excludedHtml: "",
              roomBasis: "",
              drinksBasis: "",
              verseHtml: "",
              commentaryItems: [],
              activities: [],
              dayTours: [],
              periodRoutes: [],
              greetings: [],
              topRoutes: [],
              timelineEvents: [],
            });
        te = p + 1;
      }
      const ne = p > 0 ? p : F.length,
        re = F.filter((e) => e.dayNumber <= ne).sort(
          (e, t) => e.dayNumber - t.dayNumber,
        );
      for (const e of re)
        e.topRoutes = D[e.dayNumber]
          ? D[e.dayNumber].map((e) => ({ ...e }))
          : [];
      const ie = (e, t) => {
        const n = String(
            e.startTime ||
              e.arrivalTime ||
              e.departureTime ||
              e.checkInTime ||
              e.endTime ||
              "",
          ).trim(),
          r = String(
            t.startTime ||
              t.arrivalTime ||
              t.departureTime ||
              t.checkInTime ||
              t.endTime ||
              "",
          ).trim(),
          i = Boolean(n),
          a = Boolean(r);
        if (i !== a) return i ? -1 : 1;
        if (i && a) {
          const e = $e(n) - $e(r);
          if (0 !== e) return e;
        }
        const o = w(e.periodSequence, 0) - w(t.periodSequence, 0);
        if (0 !== o) return o;
        const c = w(e.eventPriority, 99) - w(t.eventPriority, 99);
        if (0 !== c) return c;
        const s = w(e.sequence, 0) - w(t.sequence, 0);
        if (0 !== s) return s;
        const l = w(e.sourceOrder, 0) - w(t.sourceOrder, 0);
        return 0 !== l
          ? l
          : String(e.kind || "").localeCompare(String(t.kind || ""));
      };
      for (const e of re) {
        const n = `Day ${String(e.dayNumber).padStart(2, "0")}`,
          r = he(g, e.dayNumber - 1),
          i = r.label || "",
          a = `day-${e.dayNumber}`,
          o = [],
          c = [],
          s = [],
          l = [];
        let d = 0;
        const m = R[e.legIndex] || null,
          u = de(e.narrativeHtml),
          p = u.bodyHtml,
          y = $(u.title),
          f = (e) => {
            const t = Re({
              label: e.label,
              title: e.title,
              meta: e.meta,
              summary: e.copyHtml,
              source: e.sourceLabel,
            });
            (c.push({
              ...e,
              inspectorPayload: e.inspectorPayload || t,
              periodSequence: w(e.periodSequence, 0),
              sequence: w(e.sequence, 0),
              sourceOrder: d,
            }),
              (d += 1));
          },
          h = Boolean(m && w(m.startDay, 0) === e.dayNumber),
          v = De({
            pin: e.accommodationContentEntityId || m?.contentEntityId,
            title:
              e.accommodationName ||
              m?.accommodationName ||
              e.destinationName ||
              "Accommodation",
            meta: `${n} | Accommodation`,
            entityResolver: t,
            kind: "accommodation",
            categoryHints: [
              "accommodation",
              "property",
              "lodge",
              e.accommodationName,
              e.destinationName,
              m?.name,
            ],
            fallbackHandle: m?.propertyProductHandle || m?.primaryProductHandle,
            fallbackUrl: m?.propertyProductUrl || m?.primaryProductUrl,
            fallbackImage: m?.propertyProductImage || m?.primaryProductImage,
            fallbackResolutionSource: "leg-accommodation-fallback",
          }),
          _ = String(
            v?.title ||
              e.accommodationName ||
              m?.accommodationName ||
              e.destinationName ||
              "Accommodation",
          ).trim();
        if (h && e.checkInTime)
          f({
            kind: "logistics",
            label: "Stay",
            title: `Check-in at ${_}`,
            meta: e.accommodationName
              ? `Arrival at ${e.accommodationName}`
              : "Arrival and check-in",
            copyHtml: "",
            startTime: e.checkInTime,
            endTime: "",
            periodSequence: e.periodSequence,
            eventPriority: v2EventPriority("stay", "property-check-in"),
            sequence: -2,
            inspectorPayload:
              v
                ? {
                    ...v,
                    eventGroup: "stay",
                    eventTypeId: "property-check-in",
                    mapPins: {
                      startPin: "",
                      endPin: "",
                      primaryPin: A(
                        e.accommodationContentEntityId || m?.contentEntityId || "",
                      ),
                    },
                    mapPath: e.accommodationName || e.destinationName || "",
                  }
                : qe({
                    title: `Check-in at ${_}`,
                    meta: `${n} | Arrival logistics`,
                    checkInTime: e.checkInTime,
                    path: e.accommodationName || e.destinationName || "",
                    featuredImage: m?.propertyProductImage || "",
                    pin:
                      e.accommodationContentEntityId || m?.contentEntityId || "",
                    sourceType: "check-in",
                    eventGroup: "stay",
                    eventTypeId: "property-check-in",
                    mapPath: e.accommodationName || e.destinationName || "",
                  }),
            isDeepLinked: Boolean(v),
            sourceLabel: "Leg logistics",
            sourceContentEntityId: e.accommodationContentEntityId || "",
            eventGroup: "stay",
            eventTypeId: "property-check-in",
            eventTypeLabel: "Property check-in",
            dataset: {
              "data-command-center-source-content-entity-id":
                e.accommodationContentEntityId || "",
            },
          });
        const checkoutLeg = (() => {
          if (
            m &&
            m.checkOutTime &&
            w(m.endDay, 0) + 1 === e.dayNumber
          )
            return m;
          if (h) {
            const t = R[e.legIndex - 1] || null;
            if (t && t.checkOutTime) return t;
          }
          return null;
        })();
        if (checkoutLeg) {
          const r = De({
              pin: checkoutLeg.contentEntityId,
              title:
                checkoutLeg.accommodationName ||
                checkoutLeg.destinationName ||
                "Accommodation",
              meta: `${n} | Accommodation`,
              entityResolver: t,
              kind: "accommodation",
              categoryHints: [
                "accommodation",
                "property",
                "lodge",
                checkoutLeg.accommodationName,
                checkoutLeg.destinationName,
                checkoutLeg.name,
              ],
              fallbackHandle:
                checkoutLeg.propertyProductHandle ||
                checkoutLeg.primaryProductHandle,
              fallbackUrl:
                checkoutLeg.propertyProductUrl || checkoutLeg.primaryProductUrl,
              fallbackImage:
                checkoutLeg.propertyProductImage ||
                checkoutLeg.primaryProductImage,
              fallbackResolutionSource: "leg-accommodation-fallback",
            }),
            i = String(
              r?.title ||
                checkoutLeg.accommodationName ||
                checkoutLeg.destinationName ||
                "Accommodation",
            ).trim();
          f({
            kind: "logistics",
            label: "Stay",
            title: `Check-out from ${i}`,
            meta: checkoutLeg.accommodationName
              ? `Departure from ${checkoutLeg.accommodationName}`
              : "Departure preparation",
            copyHtml: "",
            startTime: checkoutLeg.checkOutTime,
            endTime: "",
            periodSequence: e.periodSequence,
            eventPriority: v2EventPriority("stay", "property-check-out"),
            sequence: -1,
            inspectorPayload:
              r
                ? {
                    ...r,
                    eventGroup: "stay",
                    eventTypeId: "property-check-out",
                    mapPins: {
                      startPin: "",
                      endPin: "",
                      primaryPin: A(checkoutLeg.contentEntityId || ""),
                    },
                    mapPath:
                      checkoutLeg.accommodationName ||
                      checkoutLeg.destinationName ||
                      "",
                  }
                : qe({
                    title: `Check-out from ${i}`,
                    meta: `${n} | Departure logistics`,
                    departureTime: checkoutLeg.checkOutTime,
                    path:
                      checkoutLeg.accommodationName ||
                      checkoutLeg.destinationName ||
                      "",
                    featuredImage: checkoutLeg.propertyProductImage || "",
                    pin: checkoutLeg.contentEntityId || "",
                    sourceType: "check-out",
                    eventGroup: "stay",
                    eventTypeId: "property-check-out",
                    mapPath:
                      checkoutLeg.accommodationName ||
                      checkoutLeg.destinationName ||
                      "",
                  }),
            isDeepLinked: Boolean(r),
            sourceLabel: "Leg logistics",
            sourceContentEntityId: checkoutLeg.contentEntityId || "",
            eventGroup: "stay",
            eventTypeId: "property-check-out",
            eventTypeLabel: "Property check-out",
            dataset: {
              "data-command-center-source-content-entity-id":
                checkoutLeg.contentEntityId || "",
            },
          });
        }
        for (const t of Array.isArray(e.greetings) ? e.greetings : []) {
          const r =
              String(t.name || t.type || "Arrival greeting").trim() ||
              "Arrival greeting",
            i = O(
              t.startTime || t.arrivalTime,
              t.endTime || t.departureTime,
              t.type || "Logistics",
            ),
            a = String(t.descriptionHtml || "").trim();
          f({
            kind: "logistics",
            label: "Logistics",
            title: r,
            meta: i,
            copyHtml: a || `<p>${b(r)}</p>`,
            startTime: t.startTime || t.arrivalTime,
            endTime: t.endTime || t.departureTime,
            periodSequence: e.periodSequence,
            eventPriority: v2EventPriority("logistics", "arrival-greeting"),
            sequence: w(t.sequence, 0),
            inspectorPayload: qe({
              title: r,
              meta: `${n} | ${i}`,
              summaryHtml: a,
              path: t.location || e.destinationName || "",
              referenceCode: t.referenceCode,
              flightCode: t.flightCode,
              terminalLine: t.terminal ? `Terminal: ${t.terminal}` : "",
              arrivalTime: t.arrivalTime || t.startTime,
              departureTime: t.departureTime || t.endTime,
              checkInTime: t.checkInTime,
              meetingInstructions: t.meetingInstructions,
              contactName: t.contactName,
              contactPhone: t.contactPhone,
              contactEmail: t.contactEmail,
              featuredImage: t.image,
              pin: t.contentEntityId,
              sourceType: "greeting",
              eventGroup: "logistics",
              eventTypeId: "arrival-greeting",
              mapPath: t.location || e.destinationName || "",
            }),
            isDeepLinked: !1,
            sourceLabel: "Leg greeting",
            sourceContentEntityId: t.contentEntityId || "",
            eventGroup: "logistics",
            eventTypeId: "arrival-greeting",
            eventTypeLabel: "Arrival / greeting",
            dataset: {
              "data-command-center-source-content-entity-id":
                t.contentEntityId || "",
              "data-command-center-source-greeting-sequence": t.sequence,
            },
          });
        }
        const dedupedRoutes = dedupeRoutesForDay([...e.topRoutes, ...e.periodRoutes]);
        for (const r of dedupedRoutes) {
          if (
            !(
              r.mode ||
              r.descriptionHtml ||
              r.directionsHtml ||
              r.startLocation ||
              r.endLocation ||
              r.startPin ||
              r.endPin
            )
          )
            continue;
          if (
            !(r.startDay
              ? r.startDay === e.dayNumber
              : !r.endDay || r.endDay === e.dayNumber)
          )
            continue;
          const i = [];
          ((r.startTime || r.endTime) &&
            i.push([r.startTime, r.endTime].filter(Boolean).join(" - ")),
            r.duration && i.push(r.duration),
            r.vehicle && i.push(r.vehicle));
          const a = i.join(" | "),
            o = ge(r.mode, r.label),
            c = M(r.startPin, "destination", ""),
            s = M(r.endPin, "destination", ""),
            l =
              String(r.startLocation || c || "").trim() ||
              (r.startPin ? `PIN ${r.startPin}` : "Origin"),
            d =
              String(r.endLocation || s || "").trim() ||
              (r.endPin ? `PIN ${r.endPin}` : "Destination"),
            m = [`<p>${b(l)} &rarr; ${b(d)}</p>`];
          (r.descriptionHtml && m.push(r.descriptionHtml),
            r.directionsHtml && m.push(r.directionsHtml),
            r.generalDescriptionHtml && m.push(r.generalDescriptionHtml));
          const u = Ee(r, t, { startLabelText: l, endLabelText: d });
          let p = "";
          const g =
            (r.endPin &&
              He(r.endPin, d || o, `${n} | ${a || ge(r.mode, r.label)}`, t, {
                kind: "route",
                categoryHints: [
                  "destination",
                  "accommodation",
                  "route",
                  r.mode,
                  r.label,
                  d,
                  l,
                ],
              })) ||
            (r.startPin &&
              He(r.startPin, l || o, `${n} | ${a || ge(r.mode, r.label)}`, t, {
                kind: "route",
                categoryHints: [
                  "destination",
                  "accommodation",
                  "route",
                  r.mode,
                  r.label,
                  l,
                  d,
                ],
              })) ||
            null;
          g
            ? (p = String(g.entityPin || r.endPin || r.startPin || "").trim())
            : (r.endPin || r.startPin) &&
              (p = String(r.endPin || r.startPin || "").trim());
          const y = v2ClassifyRouteEvent(r),
            E = y.eventTypeId,
            T = y.eventTypeLabel,
            k = ["scheduled-flight", "private-transfer", "self-drive"].includes(
              E,
            ),
            L = {
              ...Me(r, n, o, a),
              eventGroup: "logistics",
              eventTypeId: E,
              eventTypeLabel: T,
              mapPins: {
                startPin: A(r.startPin),
                endPin: A(r.endPin),
                primaryPin: A(p || r.endPin || r.startPin),
              },
              mapPath: `${l} → ${d}`,
            },
            v =
              k || u || "car-hire" === E || "arrival-greeting" === E || !g
                ? qe({
                    title: o,
                    meta: `${n} | ${a || ge(r.mode, r.label)}`,
                    summaryHtml: m.join(""),
                    path: `${l} → ${d}`,
                    referenceCode: r.referenceCode,
                    flightCode: r.flightCode,
                    terminalLine: Ae(r),
                    arrivalTime: r.arrivalTime || r.endTime,
                    departureTime: r.departureTime || r.startTime,
                    checkInTime: r.checkInTime,
                    meetingInstructions: r.meetingInstructions,
                    contactName: r.contactName,
                    contactPhone: r.contactPhone,
                    contactEmail: r.contactEmail,
                    featuredImage: r.image || "",
                    pin: p,
                    sourceType: "route",
                    eventGroup: "logistics",
                    eventTypeId: E,
                    eventTypeLabel: T,
                    mapPath: `${l} → ${d}`,
                    mapPins: {
                      startPin: A(r.startPin),
                      endPin: A(r.endPin),
                      primaryPin: A(p || r.endPin || r.startPin),
                    },
                    originName: l,
                    destinationName: d,
                    durationRaw: r.duration,
                    descriptionHtml: r.descriptionHtml || "",
                    directionsHtml: r.directionsHtml || "",
                    contactNameRaw: r.contactName,
                    contactPhoneRaw: r.contactPhone,
                    contactEmailRaw: r.contactEmail,
                    meetingInstructionsRaw: r.meetingInstructions,
                    referenceCodeRaw: r.referenceCode,
                    flightCodeRaw: r.flightCode,
                    terminalRaw: r.startTerminal || r.terminal || "",
                    departureTimeRaw: r.departureTime || r.startTime || "",
                    arrivalTimeRaw: r.arrivalTime || r.endTime || "",
                    modeLabel: ge(r.mode, r.label),
                    routeMode: r.mode,
                  })
                : null,
            _ = k
              ? v || L
              : "car-hire" === E || "arrival-greeting" === E
                ? v || L
                : g || v || L;
          f({
            kind: "route",
            label: "Logistics",
            title: o,
            meta: a,
            copyHtml: j(m.join(""), { pin: p, handle: g?.handle }),
            startTime: r.startTime || r.departureTime || r.checkInTime,
            endTime: r.endTime || r.arrivalTime,
            periodSequence: r.periodSequence,
            eventPriority: v2EventPriority("logistics", E),
            sequence: r.sequence,
            inspectorPayload: _,
            isDeepLinked: Boolean(g && _ === g),
            sourceLabel:
              "period" === r.routeScope ? "Period route" : "Top-level route",
            sourceContentEntityId: p,
            sourceRouteStartPin: r.startPin,
            sourceRouteEndPin: r.endPin,
            routeMode: r.mode,
            routePathText: `${l} → ${d}`,
            routeDuration: r.duration,
            eventGroup: "logistics",
            eventTypeId: E,
            eventTypeLabel: T,
            routeTimeWindow: O(
              r.startTime || r.departureTime || r.checkInTime,
              r.endTime || r.arrivalTime,
              "Time window not scheduled",
            ),
            dataset: {
              "data-command-center-source-route-start-pin": r.startPin,
              "data-command-center-source-route-end-pin": r.endPin,
              "data-command-center-source-route-sequence": r.sequence,
              "data-command-center-source-route-scope": r.routeScope,
            },
          });
        }
        for (const r of e.activities) {
          const i = r.type || "Activity",
            a = v2ClassifyDailyEvent(i, r.name, r.descriptionHtml),
            o = He(
              r.contentEntityId,
              r.name || "Scheduled activity",
              `${n} | ${i}`,
              t,
              { kind: "activity", categoryHints: ["activity", r.type, r.name] },
            );
          let c = null;
          c =
            "expert-tip" === a.eventTypeId && !o
              ? Re({
                  label: "Daily",
                  title: r.name || "Expert tip",
                  meta: O(r.startTime, r.endTime, i),
                  summary: r.descriptionHtml,
                  source: "Activity",
                })
              : o
                ? {
                    ...o,
                    eventGroup: "daily",
                    eventTypeId: a.eventTypeId,
                    eventTypeLabel: a.eventTypeLabel,
                  }
                : null;
          f({
            kind: "activity",
            label: "Daily",
            title: r.name || "Scheduled activity",
            meta: O(r.startTime, r.endTime, i),
            copyHtml: r.descriptionHtml,
            startTime: r.startTime,
            endTime: r.endTime,
            periodSequence: e.periodSequence,
            eventPriority: v2EventPriority("daily", a.eventTypeId),
            sequence: r.sequence,
            inspectorPayload: c,
            isDeepLinked: Boolean(o),
            sourceLabel: "Activity",
            sourceContentEntityId: r.contentEntityId,
            eventGroup: "daily",
            eventTypeId: a.eventTypeId,
            eventTypeLabel: a.eventTypeLabel,
            isHighlight: Boolean(r.isHighlight),
            dataset: {
              "data-command-center-source-content-entity-id": r.contentEntityId,
              "data-command-center-source-activity-sequence": r.sequence,
            },
          });
        }
        for (const r of e.dayTours) {
          const i = r.type || "Day tour",
            a = v2ClassifyDailyEvent(i, r.name, r.descriptionHtml),
            o = He(
              r.contentEntityId,
              r.name || "Scheduled day tour",
              `${n} | ${i}`,
              t,
              {
                kind: "day-tour",
                categoryHints: ["activity", "day tour", r.type, r.name],
              },
            );
          let c = null;
          c =
            "expert-tip" === a.eventTypeId && !o
              ? Re({
                  label: "Daily",
                  title: r.name || "Expert tip",
                  meta: O(r.startTime, r.endTime, i),
                  summary: r.descriptionHtml,
                  source: "Day tour",
                })
              : o
                ? {
                    ...o,
                    eventGroup: "daily",
                    eventTypeId: a.eventTypeId,
                    eventTypeLabel: a.eventTypeLabel,
                  }
                : null;
          f({
            kind: "day-tour",
            label: "Daily",
            title: r.name || "Scheduled day tour",
            meta: O(r.startTime, r.endTime, i),
            copyHtml: r.descriptionHtml,
            startTime: r.startTime,
            endTime: r.endTime,
            periodSequence: e.periodSequence,
            eventPriority: v2EventPriority("daily", a.eventTypeId),
            sequence: r.sequence,
            inspectorPayload: c,
            isDeepLinked: Boolean(o),
            sourceLabel: "Day tour",
            sourceContentEntityId: r.contentEntityId,
            eventGroup: "daily",
            eventTypeId: a.eventTypeId,
            eventTypeLabel: a.eventTypeLabel,
            isHighlight: Boolean(r.isHighlight),
            dataset: {
              "data-command-center-source-content-entity-id": r.contentEntityId,
              "data-command-center-source-day-tour-sequence": r.sequence,
            },
          });
        }
        const k = Array.isArray(m?.stops)
          ? m.stops.filter((t) => w(t.arrivalDay, 0) === e.dayNumber)
          : [];
        for (const r of k) {
          const i = ye(r.type, r.name),
            a =
              String(r.name || r.type || i || "Travel segment").trim() ||
              "Travel segment",
            o = O(r.arrivalTime, r.departureTime, i),
            c = r.descriptionHtml || "",
            s = fe(r),
            l = v2ClassifyStopEvent(r, m),
            d =
              "stay" === l.eventGroup &&
              ["mobile-stop", "mobile-check-in"].includes(l.eventTypeId),
            u = s || d
              ? null
              : He(r.contentEntityId, a, `${n} | ${o}`, t, {
                  kind: "destination",
                  categoryHints: [
                    "destination",
                    "property",
                    "activity",
                    "restaurant",
                    r.type,
                    r.name,
                    e.destinationName,
                    e.accommodationName,
                  ],
                }),
            p = s
              ? qe({
                  title: a,
                  meta: `${n} | ${o}`,
                  summaryHtml: c,
                  path: r.location || r.name || a,
                  referenceCode: r.referenceCode,
                  terminalLine: r.terminal ? `Terminal: ${r.terminal}` : "",
                  arrivalTime: r.arrivalTime,
                  departureTime: r.departureTime,
                  checkInTime: r.checkInTime,
                  meetingInstructions: r.meetingInstructions,
                  contactName: r.contactName,
                  contactPhone: r.contactPhone,
                  contactEmail: r.contactEmail,
                  featuredImage: r.image,
                  pin: r.contentEntityId,
                  sourceType: "stop",
                  eventGroup: "logistics",
                  eventTypeId: l.eventTypeId,
                  mapPath: r.location || r.name || a,
                })
              : u
                ? {
                    ...u,
                    eventGroup: l.eventGroup,
                    eventTypeId: l.eventTypeId,
                    eventTypeLabel: l.eventTypeLabel,
                  }
                : "Travel segment" !== i
                  ? {
                      ...je(r, n, a, o),
                      eventGroup: l.eventGroup,
                      eventTypeId: l.eventTypeId,
                      eventTypeLabel: l.eventTypeLabel,
                      mapPins: {
                        startPin: "",
                        endPin: "",
                        primaryPin: A(r.contentEntityId),
                      },
                      mapPath: r.location || r.name || a,
                    }
                  : null;
          p &&
            f({
              kind: "logistics" === l.eventGroup ? "logistics" : "travel-stop",
              label:
                "stay" === l.eventGroup
                  ? "Stay"
                  : "daily" === l.eventGroup
                    ? "Daily"
                    : "Logistics",
              title: a,
              meta: o,
              copyHtml: j(c || `<p>${b(a)}</p>`, {
                pin: r.contentEntityId,
                handle: u?.handle,
              }),
              startTime: r.arrivalTime || r.departureTime,
              endTime: r.departureTime || "",
              periodSequence: e.periodSequence,
              eventPriority: v2EventPriority(l.eventGroup, l.eventTypeId),
              sequence: r.sequence,
              inspectorPayload: p,
              isDeepLinked: Boolean(u && p === u),
              sourceLabel: "Leg stop",
              sourceContentEntityId: r.contentEntityId || "",
              sourceStopId: r.stopId || "",
              routeMode: i,
              routePathText: String(r.name || "").trim() || a,
              routeDuration: c ? ce(c) : "",
              eventGroup: l.eventGroup,
              eventTypeId: l.eventTypeId,
              eventTypeLabel: l.eventTypeLabel,
              routeTimeWindow: O(
                r.arrivalTime,
                r.departureTime,
                "Time window not scheduled",
              ),
              dataset: {
                "data-command-center-source-content-entity-id":
                  r.contentEntityId || "",
                "data-command-center-source-stop-id": r.stopId || "",
                "data-command-center-source-stop-type": r.type || "",
              },
            });
        }
        c.sort(ie);
        let C = 0;
        const v2DayInspectorHandleSet = new Set(),
          v2CanSurfacePayload = (e, t = !1) => {
            if (!e || "object" != typeof e) return !1;
            if ("product" !== String(e.type || "").trim()) return !0;
            const n = v2ProductInspectorClass(e);
            if (!n) return !0;
            const r = String(e.handle || "")
              .trim()
              .toLowerCase();
            return r
              ? !!v2DayInspectorHandleSet.has(r) && !!t ||
                  (!v2DayInspectorHandleSet.has(r) &&
                    (v2DayInspectorHandleSet.add(r), !0))
              : !0;
          };
        if (Boolean(m && w(m.startDay, 0) === e.dayNumber) && m) {
          const r = [n];
          (i && r.push(i), m.destinationName && r.push(m.destinationName));
          const c =
              m.destinationName || e.destinationName || m.name || "Destination",
            s = ({
              payload: t,
              kind: n,
              label: i,
              sourcePin: c,
              fallbackTitle: s,
              imageAlt: l,
            }) => {
              if (!t) return "";
              v2CanSurfacePayload(t, !0);
              C += 1;
              const d = `${a}-card-${String(C).padStart(2, "0")}`;
              return (
                o.push({
                  kind: n,
                  label: i,
                  title: t.title || s,
                  meta: t.meta || r.join(" | "),
                  id: d,
                  dayKey: a,
                  dayNumber: e.dayNumber,
                  selectable: !0,
                  imageUrl: String(t.featuredImage || "").trim(),
                  imageAlt: l || t.title || s,
                  dataset: {
                    "data-command-center-source-content-entity-id": c,
                    "data-command-center-leg-index": m.index,
                    "data-command-center-leg-start": "true",
                    "data-command-center-leg-entity-kind": n,
                    "data-command-center-event-group": "stay",
                    "data-command-center-event-type": "destination-arrival",
                  },
                }),
                (J[d] = {
                  ...t,
                  cardId: d,
                  cardKind: n,
                  dayKey: a,
                  dayNumber: e.dayNumber,
                  legIndex: m.index,
                  isLegStart: !0,
                  sourceContentEntityId: c,
                  sourceRouteStartPin: "",
                  sourceRouteEndPin: "",
                  sourceStopId: "",
                }),
                ee || (ee = d),
                d
              );
            },
            l =
              s({
                payload: ((n) =>
                  n
                    ? {
                        ...n,
                        eventGroup: "stay",
                        eventTypeId: "destination-arrival",
                        eventTypeLabel: "Destination arrival",
                        mapPins: {
                          startPin: "",
                          endPin: "",
                          primaryPin: A(
                            e.destinationContentEntityId ||
                              m.destinationContentEntityId ||
                              "",
                          ),
                        },
                        mapPath: c,
                      }
                    : null)(
                  De({
                    pin:
                      e.destinationContentEntityId ||
                      m.destinationContentEntityId,
                    title: c,
                    meta: r.join(" | "),
                    entityResolver: t,
                    kind: "destination",
                    categoryHints: [
                      "destination",
                      "city",
                      "region",
                      "country",
                      m.destinationName,
                      e.destinationName,
                    ],
                    fallbackHandle: m.destinationProductHandle,
                    fallbackUrl: m.destinationProductUrl,
                    fallbackImage: m.destinationProductImage,
                    fallbackResolutionSource: "leg-destination-fallback",
                  }),
                ),
                kind: "leg-destination",
                label: "Destination",
                sourcePin:
                  e.destinationContentEntityId ||
                  m.destinationContentEntityId ||
                  "",
                fallbackTitle: c,
                imageAlt: `${c} destination`,
              }) || "";
          l && (Q[a] = l);
        }
        for (const t of c) {
          const n = ["activity", "day-tour"].includes(t.kind),
            r = String(t.inspectorPayload?.type || "").trim();
          if (
            "stay" === String(t.eventGroup || "").trim() &&
            "property-check-out" === String(t.eventTypeId || "").trim()
          ) {
            t.dayKey = e.dayKey;
            t.dayNumber = e.dayNumber;
            continue;
          }
          let i = "";
          (Boolean(
            t.inspectorPayload &&
            ("stay" === t.eventGroup
              ? v2CanSurfacePayload(t.inspectorPayload)
              : !0) &&
            (["logistics", "route", "travel-stop", "timeline"].includes(r) ||
              (t.isDeepLinked && "product" === r)),
          ) &&
            ((C += 1),
            (i = `${a}-card-${String(C).padStart(2, "0")}`),
            o.push({
              kind: t.kind,
              title: t.title,
              meta: t.meta,
              id: i,
              dayKey: a,
              dayNumber: e.dayNumber,
              selectable: !0,
              imageUrl: String(t.inspectorPayload?.featuredImage || "").trim(),
              imageAlt: t.title || "",
              dataset: {
                ...(t.dataset || {}),
                "data-command-center-event-group": t.eventGroup || "",
                "data-command-center-event-type": t.eventTypeId || "",
              },
            }),
            (J[i] = {
              ...t.inspectorPayload,
              cardId: i,
              cardKind: t.kind,
              dayKey: a,
              dayNumber: e.dayNumber,
              eventGroup:
                t.inspectorPayload?.eventGroup || t.eventGroup || "",
              eventTypeId: t.inspectorPayload?.eventTypeId || t.eventTypeId || "",
              eventTypeLabel:
                t.inspectorPayload?.eventTypeLabel || t.eventTypeLabel || "",
              sourceContentEntityId: t.sourceContentEntityId || "",
              sourceRouteStartPin: t.sourceRouteStartPin || "",
              sourceRouteEndPin: t.sourceRouteEndPin || "",
              sourceStopId: t.sourceStopId || "",
            }),
            ee || (ee = i)),
            (t.cardId = i),
            (t.dayKey = e.dayKey),
            (t.dayNumber = e.dayNumber),
            n
              ? s.push({
                  kind: t.kind,
                  title: t.title,
                  timeLabel: O(t.startTime, t.endTime, t.meta || "Any time"),
                  typeLabel:
                    t.eventTypeLabel ||
                    ("day-tour" === t.kind ? "Day tour" : "Activity"),
                  isHighlight: Boolean(t.isHighlight),
                  isExternalVenue: Boolean(i),
                  cardId: i,
                  dayKey: a,
                  dayNumber: e.dayNumber,
                  thumbnailUrl: String(
                    t.inspectorPayload?.featuredImage || "",
                  ).trim(),
                  dataset: t.dataset || {},
                })
              : ("route" === t.kind &&
                  i &&
                  l.push({
                    cardKind: "route",
                    cardId: i,
                    dayKey: a,
                    dayNumber: e.dayNumber,
                    title: t.title,
                    mode: t.routeMode,
                    path: t.routePathText,
                    duration: t.routeDuration || "Duration not provided",
                    timeWindow:
                      t.routeTimeWindow || "Time window not scheduled",
                    dataset: t.dataset || {},
                  }),
                "travel-stop" === t.kind &&
                  i &&
                  l.push({
                    cardKind: "travel-stop",
                    cardId: i,
                    dayKey: a,
                    dayNumber: e.dayNumber,
                    title: t.title,
                    mode: t.routeMode || ye(t.meta, t.title),
                    path: t.routePathText || t.title || "Travel segment",
                    duration:
                      t.routeDuration || "Travel segment details pending",
                    timeWindow:
                      t.routeTimeWindow || "Time window not scheduled",
                    dataset: t.dataset || {},
                  })));
        }
        const L =
            c.find((e) => ["activity", "day-tour"].includes(e.kind)) || c[0],
          I =
            y ||
            $(e.sourceDayTitle) ||
            (L ? L.title : "") ||
            e.destinationName ||
            e.accommodationName ||
            e.legName ||
            n;
        ((e.dayLabel = n),
          (e.dateLabel = i),
          (e.weekdayShort = r.weekday),
          (e.dayOfMonth = r.day),
          (e.monthShort = r.month),
          (e.year = r.year),
          (e.dayKey = a),
          (e.title = I),
          (e.narrativeDisplayHtml = p),
          (e.activityTimelineEntries = s),
          (e.routeCards = l),
          (e.timelineEvents = c),
          (e.cards = o),
          (e.legStartCardId = Q[a] || ""));
      }
      const ae = ke(n, a, R),
        me = Object.keys(J).length,
        Se = ((e) => {
          const t = String(e || "").trim();
          if (!t) return "";
          const n = new Date(t);
          return Number.isNaN(n.getTime())
            ? t
            : n.toLocaleDateString(void 0, {
                day: "2-digit",
                month: "short",
                year: "numeric",
              });
        })(T(n, ["start_date", "travel_start_date", "arrival_date"])),
        ve = Se
          ? `${Se} · ${ne} ${1 === ne ? "day" : "days"}`
          : `${ne} ${1 === ne ? "day" : "days"}`,
        _e = { ...v, timeline: v.timeline || ve },
        Te = ((e, t = [], n = 0) => {
          if (!e || "object" != typeof e)
            return { locationLine: "--", dayCountLine: "-- days" };
          const r = [],
            i = new Set(),
            a = (e) => {
              const t = String(e || "").trim();
              if (!t) return;
              const n = t.toLowerCase();
              i.has(n) || (i.add(n), r.push(t));
            };
          for (const e of U(t)) a(e.destinationName);
          if (0 === r.length) {
            for (const e of U(t)) a(e.accommodationName || e.name);
          }
          if (0 === r.length) {
            const t = [
              _(e, "locations"),
              _(e, "destinations"),
              _(e, "countries"),
              _(e, "regions"),
              T(e, ["location", "destination_name", "country", "region"]),
            ];
            for (const e of t) {
              if (Array.isArray(e)) {
                for (const t of e) a(t);
                continue;
              }
              if (e && "object" == typeof e) {
                for (const t of Object.values(e)) a(t);
                continue;
              }
              const t = String(e || "").trim();
              if (t)
                if (t.includes("|")) for (const e of t.split("|")) a(e);
                else if (t.includes(",")) for (const e of t.split(",")) a(e);
                else a(t);
            }
          }
          const o = r.slice(0, 4),
            c = Math.max(0, r.length - o.length);
          let s = o.join(" · ");
          c > 0 && (s += ` · +${c} more`);
          const l = w(_(e, "days"), 0),
            d = l > 0 ? l : Math.max(0, w(n, 0));
          return {
            locationLine: s || "--",
            dayCountLine:
              d > 0 ? `${d} ${1 === d ? "day" : "days"}` : "-- days",
          };
        })(n, R, ne);
      return {
        itinerary: {
          name: a,
          introductionHtml: m,
          summaryHtml: m,
          introPillGroups: u,
          days: ne,
          legs: R.length,
          routes: E.length,
          selectableStops: me,
          journeyDna: y,
          clientFacingSummary: cfs,
          participants: f,
          pricing: h,
          pricingArchitecture: _(n, "pricing_architecture") || null,
          financialTerms: _(n, "financial_terms") || null,
          quickReference: _e,
          templateGuidance:
            _(n, "template_guidance") || _(n, "agent_notes") || null,
        },
        hero: Te,
        legs: R,
        days: re,
        routesByDay: D,
        cardsById: J,
        legStartCardByDayKey: Q,
        firstSelectableCardId: ee,
        defaultInspectorPayload: ae,
      };
    },
    Fe = (e, t = []) => {
      const n = t[0] || null,
        r = String(e?.name || n?.destinationName || "Leg").trim() || "Leg",
        i = String(n?.destinationName || e?.destinationName || r).trim() || r,
        a = Math.max(1, w(e?.endDay, 0) - w(e?.startDay, 0) + 1),
        o = Math.max(1, t.length || a),
        c = `${o} ${1 === o ? "Night" : "Nights"}`,
        s = String(n?.accommodationName || e?.accommodationName || "").trim();
      return {
        firstDay: n,
        destinationLine: i,
        nightsLabel: c,
        detailLine: s ? `${c} at ${s}` : c,
      };
    },
    Ke = (e) => {
      const t = String(e || "")
        .split(",")
        .map((e) => e.trim())
        .filter(Boolean);
      return t.length > 1 ? t.slice(1).join(", ").trim() : t[0] || "";
    },
    Ge = (e = []) => {
      if (!Array.isArray(e) || 0 === e.length) return "";
      const t = e[0],
        n = e[e.length - 1],
        r = Ke(t?.dateLabel),
        i = Ke(n?.dateLabel);
      return r || i ? (i && r !== i ? `${r} - ${i}` : r || i) : "";
    },
    We = (e) => {
      const normalizeTravellerName = (value) =>
          String(value || "")
            .toLowerCase()
            .replace(/\b(mr|mrs|ms|dr|prof)\.?\b/g, " ")
            .replace(/\s+/g, " ")
            .trim(),
        firstMeaningfulToken = (value) =>
          normalizeTravellerName(value).split(" ").filter(Boolean)[0] || "",
        namesLookEquivalent = (left, right) => {
          const a = normalizeTravellerName(left),
            b = normalizeTravellerName(right);
          if (!a || !b) return !1;
          if (a === b) return !0;
          if (a.includes(b) || b.includes(a)) return !0;
          const c = firstMeaningfulToken(a),
            d = firstMeaningfulToken(b);
          return Boolean(c && d && c === d);
        };
      const t = e?.itinerary?.participants || {},
        cfs = e?.itinerary?.clientFacingSummary || {},
        cfsTravellers = Array.isArray(cfs.travellerProfiles) ? cfs.travellerProfiles : [],
        n = Array.isArray(t.profiles) ? t.profiles : [],
        r = w(t.total, n.length),
        i = w(t.adults, 0),
        a = w(t.children, 0),
        enrichedTravellers = n.map((tr) => {
          const cfMatch = cfsTravellers.find((cf) =>
            namesLookEquivalent(cf?.name, tr?.fullName || tr?.knownAs || tr?.name),
          );
          return {
            ...tr,
            interestsSummary: cfMatch?.interestsSummary || (tr.interests && tr.interests.length > 0 ? tr.interests.join(", ") : ""),
            dietarySummary: cfMatch?.dietarySummary || "",
            accommodationsMade: cfMatch?.accommodationsMade || [],
            role: cfMatch?.role || tr.role || "",
          };
        }),
        preDeparturePack = cfs.preDeparturePack || null,
        accessibilitySummary = cfs.accessibilitySummary || null;
      return {
        type: "guests",
        template: "guests",
        id: "participants-overview",
        label: "Guest list",
        modeLabel: "Guest list",
        title: "Your Travel Party",
        meta: `${r} guests · ${i} adults · ${a} children`,
        summary:
          r > 0
            ? "A warm look at everyone joining this journey."
            : "Traveller profiles were not supplied in this itinerary source.",
        travellers: enrichedTravellers,
        preDeparturePack,
        accessibilitySummary,
        source: String(t.source || "participant_model").trim() || "participant_model",
      };
    },
    Ye = (e) => {
      const t = e?.itinerary?.pricing || {},
        n = String(t.currency || "USD").trim() || "USD",
        r = z(t.totalInvestment, 0),
        i = Array.isArray(t.components) ? t.components : [],
        a = Array.isArray(t.includes) ? t.includes : [],
        o = Array.isArray(t.excludes) ? t.excludes : [],
        pArch = e?.itinerary?.pricingArchitecture || null,
        fTerms = e?.itinerary?.financialTerms || null,
        srcPhases = Array.isArray(t?.phases) ? t.phases
          : Array.isArray(pArch?.phases) ? pArch.phases : [],
        phases = srcPhases.map((p) => {
          const name = Y(T(p, ["name", "phase", "label"])) || "Phase",
            dateRange = Y(T(p, ["date_range", "dateRange", "dates"]) || ""),
            total = z(T(p, ["total", "phase_total"]), Number.NaN),
            rawItems = Array.isArray(p.line_items) ? p.line_items
              : Array.isArray(p.lineItems) ? p.lineItems
              : Array.isArray(p.items) ? p.items : [];
          return {
            name,
            dateRange,
            total: Number.isFinite(total) ? total : null,
            lineItems: rawItems.map((li) => ({
              description: Y(T(li, ["description", "label", "name"]) || "Item"),
              quantity: z(T(li, ["quantity", "qty"]), 0),
              unitPrice: z(T(li, ["unit_price", "unitPrice", "rate"]), Number.NaN),
              total: z(T(li, ["total", "line_total", "lineTotal"]), Number.NaN),
            })),
          };
        }),
        rawSchedule = Array.isArray(t?.paymentSchedule) ? t.paymentSchedule
          : Array.isArray(t?.payment_schedule) ? t.payment_schedule
          : Array.isArray(fTerms?.payment_schedule) ? fTerms.payment_schedule
          : Array.isArray(fTerms?.paymentSchedule) ? fTerms.paymentSchedule : [],
        paymentSchedule = rawSchedule.map((ms) => ({
          label: Y(T(ms, ["label", "name", "milestone", "description"]) || "Payment"),
          amount: z(T(ms, ["amount", "total"]), Number.NaN),
          dueDate: Y(T(ms, ["due_date", "dueDate", "date"]) || ""),
          percentage: z(T(ms, ["percentage", "percent"]), Number.NaN),
          status: Y(T(ms, ["status"]) || ""),
        })),
        pp = e?.itinerary?.participants || {},
        partySize = w(pp.total, 1) || 1,
        perPerson = r > 0 && partySize > 0 ? Math.round(r / partySize) : 0;
      return {
        type: "pricing",
        template: "pricing",
        id: "pricing-overview",
        modeLabel: "Pricing breakdown",
        title: "Pricing & Inclusions",
        currency: n,
        totalInvestment: r,
        perPerson,
        partySize,
        adultAverage: z(t.adultAverage, 0),
        childAverage: z(t.childAverage, 0),
        logisticsTotal: z(t.logisticsTotal, 0),
        phases,
        includes: a,
        excludes: o,
        paymentSchedule,
        source: "pricing",
      };
    },
    chapterText = (e) =>
      ce(String(e || ""))
        .replace(/\s+/g, " ")
        .trim(),
    chapterSentence = (e, t = 180) => {
      const n = chapterText(e);
      if (!n) return "";
      const r = n.match(/[^.!?]+[.!?]+(?:\s|$)|[^.!?]+$/g),
        i = Array.isArray(r)
          ? r.map((e) => String(e || "").trim()).filter(Boolean)
          : [];
      return truncateChapterText(i[0] || n, t);
    },
    truncateChapterText = (e, t = 220) => {
      const n = chapterText(e);
      return n.length > t ? `${n.slice(0, Math.max(0, t - 1)).trim()}…` : n;
    },
    chapterLocationFallback = ({
      dayEntry: e,
      leg: t,
      propertyPayload: n,
      locationPayload: r,
      logisticsCardId: i,
      chapterLabel: a,
      mapboxToken: o,
      mapboxStyle: c,
      coordIndex: s,
    }) => {
      if (!t || r) return r || null;
      const l = String(t.destinationName || "").trim();
      if (!l) return null;
      const d = [];
      const m = (e) => {
        const t = A(e);
        if (!t || d.some((e) => e.key === t)) return;
        const n = s instanceof Map ? s.get(t) : null;
        n &&
          Number.isFinite(n.lng) &&
          Number.isFinite(n.lat) &&
          d.push({ key: t, lng: n.lng, lat: n.lat });
      };
      m(t.destinationContentEntityId || t.contentEntityId || "");
      m(t.accommodationContentEntityId || t.contentEntityId || "");
      const u =
          /^pk\./i.test(String(o || "").trim()) &&
          !/your_mapbox_public_token|replace_me|example/i.test(
            String(o || ""),
          ) &&
          d.length > 0
            ? v2BuildInspectorStaticMapUrl({
                token: o,
                stylePath: v2MapboxStylePath(c),
                points: d,
                includeLine: !1,
              })
            : "",
        p =
          chapterSentence(e?.narrativeDisplayHtml || e?.notesHtml || "", 160) ||
          truncateChapterText(
            t.daySummaryText ||
              t.propertySelectionRationale ||
              n?.tagline ||
              "",
            160,
          ) ||
          `${l} frames this chapter with calm arrivals, clear bearings, and easy movement into the next part of the journey.`,
        g = [a, String(e?.dateLabel || "").trim()]
          .filter(Boolean)
          .join(" | ");
      return {
        label: "Location lens",
        title: l,
        meta: g || "Destination orientation",
        copy: p,
        image: String(u || "").trim(),
        imageAlt: l,
        actionLabel: i ? "Open route map" : "",
        cardId: i || "",
        handle: "",
        url: "",
      };
    },
    chapterHighlightLabel = (e) => {
      const t = String(e?.eventTypeLabel || "").trim();
      if (t) return t;
      const n = String(e?.cardKind || e?.type || "").trim().toLowerCase();
      return "leg-destination" === n
        ? "Location"
        : ["activity", "day-tour"].includes(n)
          ? "Experience"
          : "route" === n
            ? "Routing"
            : ["travel-stop", "logistics"].includes(n)
              ? "Movement"
              : "product" === n
                ? "Featured stop"
                : "Journey detail";
    },
    renderChapterInspector = (e, t) => {
      if (!e || !t) return;
      const n2 = e.querySelector("[data-inspector-chapter-kicker]");
      n2 &&
        ((n2.textContent = String(t.kicker || "Journey chapter").trim()),
        (n2.hidden = "" === n2.textContent));
      Ze(e, "[data-inspector-chapter-title]", t.title || "Journey chapter");
      const r2 = e.querySelector("[data-inspector-chapter-meta]");
      r2 &&
        ((r2.textContent = String(t.meta || "").trim()),
        (r2.hidden = "" === r2.textContent));
      const n = e.querySelector("[data-inspector-chapter-summary]");
      n &&
        ((n.textContent = String(t.summary || "").trim()),
        (n.hidden = "" === String(t.summary || "").trim()));
      const r = e.querySelector("[data-inspector-chapter-stats]");
      if (r) {
        const e = Array.isArray(t.stats)
          ? t.stats.map((e) => String(e || "").trim()).filter(Boolean)
          : [];
        ((r.hidden = 0 === e.length),
          (r.innerHTML = e
            .map(
              (e) =>
                `<span class="itin-command-center__chapter-detail-stat">${b(e)}</span>`,
            )
            .join("")));
      }
      const i = (e, n) => {
        const r = t[n];
        if (!e) return;
        if (!r) return void (e.hidden = !0);
        e.hidden = !1;
        const i = e.querySelector(`[data-inspector-chapter-${n}-media-wrap]`),
          a = e.querySelector(`[data-inspector-chapter-${n}-image]`);
        if (i && a) {
          const e = String(r.image || "").trim();
          ((i.hidden = "" === e),
            e
              ? ((a.src = e),
                (a.alt = String(
                  r.imageAlt || r.title || "Journey detail",
                ).trim()))
              : (a.removeAttribute("src"), a.setAttribute("alt", "")));
        }
        Ze(e, `[data-inspector-chapter-${n}-label]`, r.label || "");
        Ze(e, `[data-inspector-chapter-${n}-title]`, r.title || "");
        const o = e.querySelector(`[data-inspector-chapter-${n}-meta]`);
        o &&
          ((o.textContent = String(r.meta || "").trim()),
          (o.hidden = "" === String(r.meta || "").trim()));
        const c = e.querySelector(`[data-inspector-chapter-${n}-copy]`);
        c &&
          ((c.textContent = String(r.copy || "").trim()),
          (c.hidden = "" === String(r.copy || "").trim()));
        const s = e.querySelector(`[data-inspector-chapter-${n}-cta]`);
        if (!s) return;
        s.hidden = !1;
        s.textContent = String(r.actionLabel || "Open detail").trim();
        (s.removeAttribute("data-command-center-card-id"),
          s.removeAttribute("data-command-center-inspector-product-trigger"),
          delete s.dataset.commandCenterInspectorProductHandle,
          delete s.dataset.commandCenterInspectorProductUrl,
          delete s.dataset.commandCenterInspectorProductTitle);
        const l = String(r.cardId || "").trim(),
          d = String(r.handle || "").trim(),
          m = String(r.url || "").trim();
        l
          ? s.setAttribute("data-command-center-card-id", l)
          : d || m
            ? (s.setAttribute("data-command-center-inspector-product-trigger", ""),
              d && (s.dataset.commandCenterInspectorProductHandle = d),
              m && (s.dataset.commandCenterInspectorProductUrl = m),
              (s.dataset.commandCenterInspectorProductTitle = String(
                r.title || "Related detail",
              ).trim()))
            : (s.hidden = !0);
      };
      (i(e.querySelector("[data-inspector-chapter-primary]"), "primary"),
        i(e.querySelector("[data-inspector-chapter-secondary]"), "secondary"));
      const a = e.querySelector("[data-inspector-chapter-notes]");
      if (a) {
        const e = t.notes && "object" == typeof t.notes ? t.notes : null,
          n = e ? String(e.copy || "").trim() : "",
          r = a.querySelector("[data-inspector-chapter-notes-copy]");
        ((a.hidden = !n),
          e &&
            (Ze(
              a,
              "[data-inspector-chapter-notes-label]",
              e.label || "Journey note",
            ),
            r && (r.textContent = n)));
      }
      const o = e.querySelector("[data-inspector-chapter-highlights]"),
        c = e.querySelector("[data-inspector-chapter-highlights-list]");
      if (o && c) {
        const e = Array.isArray(t.highlights)
          ? t.highlights
              .map((e) => ({
                cardId: String(e?.cardId || "").trim(),
                label: String(e?.label || "").trim(),
                title: String(e?.title || "").trim(),
                meta: String(e?.meta || "").trim(),
              }))
              .filter((e) => e.cardId && e.title)
          : [];
        ((o.hidden = 0 === e.length),
          (c.innerHTML = e
            .map(
              (e) =>
                `\n            <button type="button" class="itin-command-center__chapter-highlight" data-command-center-card-id="${b(e.cardId)}">\n              <span class="itin-command-center__chapter-highlight-label">${b(e.label || "Detail")}</span>\n              <span class="itin-command-center__chapter-highlight-title">${b(e.title)}</span>\n              ${e.meta ? `<span class="itin-command-center__chapter-highlight-meta">${b(e.meta)}</span>` : ""}\n            </button>\n          `,
            )
            .join("")));
      }
    },
    defaultDayInspectorPayload = (e, t) => {
      const n = String(t || e?.activeDay || "").trim(),
        r =
          n && n === String(e?.overviewKey || "").trim()
            ? String(e?.firstDayKey || "").trim() || n
            : n;
      return !n
        ? null
        : (e?.dayToChapterPayload && e.dayToChapterPayload[r]) ||
            (e?.dayToPropertyPayload && e.dayToPropertyPayload[r]) ||
            (e?.dayToLocationPayload && e.dayToLocationPayload[r]) ||
            null;
    },
    buildDayInspectorMappings = (e) => {
      const t = Array.isArray(e?.itineraryLegs) ? e.itineraryLegs : [],
        n = Array.isArray(e?.itineraryDays) ? e.itineraryDays : [],
        r = e?.cardsById && "object" == typeof e.cardsById ? e.cardsById : {},
        i =
          e?.dayToLegIndex && "object" == typeof e.dayToLegIndex
            ? e.dayToLegIndex
            : {},
        a = new Map(),
        o = new Map(),
        c = (e) => {
          const t = String(e || "")
            .trim()
            .toLowerCase();
          return t;
        },
        s = (e) => {
          if (!e || "object" != typeof e) return !1;
          return "product" === String(e.type || "").trim().toLowerCase();
        };
      for (const [e, t] of Object.entries(r)) {
        if (!t || "object" != typeof t) continue;
        const n = i[t.dayKey];
        if (void 0 === n) continue;
        a.has(n) || a.set(n, []);
        a.get(n).push({ cardId: e, payload: t });
        o.has(t.dayKey) || o.set(t.dayKey, []);
        o.get(t.dayKey).push({ cardId: e, payload: t });
      }
      const l = (e, t) => {
          const n = a.get(e) || [];
          return n.find((e) => t(e.payload, e.cardId)) || null;
        },
        d = (e) =>
          Array.isArray(e)
            ? e
                .map((e) => String(e || "").trim())
                .filter(Boolean)
                .filter((t, n, r) => r.indexOf(t) === n)
            : [];
      ((e.dayToPropertyPayload = {}),
        (e.dayToPropertyCardId = {}),
        (e.dayToLocationPayload = {}),
        (e.dayToLocationCardId = {}),
        (e.dayToChapterPayload = {}));
      for (const m of t) {
        if (!m || "object" != typeof m) continue;
        const t2 = w(m.index, -1);
        if (t2 < 0) continue;
        const r2 = c(m.propertyProductHandle || m.primaryProductHandle),
          i2 = c(m.destinationProductHandle),
          i =
            l(
              t2,
              (e) =>
                s(e) &&
                r2 &&
                c(e.handle) === r2 &&
                "property-check-in" === String(e.eventTypeId || "").trim(),
            ) ||
            l(
              t2,
              (e) =>
                s(e) &&
                r2 &&
                c(e.handle) === r2 &&
                "property-check-out" !== String(e.eventTypeId || "").trim(),
            ) ||
            l(
              t2,
              (e) => s(e) && r2 && c(e.handle) === r2,
            ) ||
            l(
              t2,
              (e) =>
                s(e) &&
                "leg-destination" !== String(e.cardKind || "").trim() &&
                "stay" === String(e.eventGroup || "").trim() &&
                "property-check-out" !== String(e.eventTypeId || "").trim() &&
                (!i2 || c(e.handle) !== i2),
            ) ||
            null,
          m2 =
            l(
              t2,
              (e) => s(e) && i2 && c(e.handle) === i2,
            ) ||
            l(
              t2,
              (e) =>
                s(e) && "leg-destination" === String(e.cardKind || "").trim(),
            ) ||
            null,
          u = i ? i.payload : null,
          p = m2 ? m2.payload : null,
          g = i ? i.cardId : "",
          y = m2 ? m2.cardId : "";
        for (const dayEntry of n.filter((e) => w(e.legIndex, -1) === t2)) {
          const n = String(dayEntry.dayKey || "").trim();
          if (!n) continue;
          (u &&
            ((e.dayToPropertyPayload[n] = u), (e.dayToPropertyCardId[n] = g)),
            p &&
              ((e.dayToLocationPayload[n] = p), (e.dayToLocationCardId[n] = y)));
          const locationPayload = p && c(p.handle) !== c(u?.handle || "") ? p : null,
            h = Math.max(
              1,
              w(m.endDay, dayEntry.dayNumber) - w(m.startDay, dayEntry.dayNumber) + 1,
            ),
            chapterLabel = Number.isFinite(t2 + 1) ? `Chapter ${t2 + 1}` : "",
            S = d([
              chapterLabel,
              h > 0 ? `${h} ${1 === h ? "night" : "nights"}` : "",
              String(dayEntry.dayLabel || "").trim(),
            ]),
            b = d([
              chapterLabel,
              String(m.destinationName || locationPayload?.title || "").trim(),
              h > 0 ? `${h} ${1 === h ? "night" : "nights"}` : "",
            ]).join(" · "),
            C =
              chapterSentence(
                dayEntry.narrativeDisplayHtml ||
                  dayEntry.notesHtml ||
                  m.daySummaryText ||
                  m.tagline ||
                  u?.tagline ||
                  locationPayload?.tagline ||
                  "",
                240,
              ) ||
              truncateChapterText(
                m.daySummaryText ||
                  m.tagline ||
                  u?.tagline ||
                  locationPayload?.tagline ||
                  "",
                240,
              ),
            P = truncateChapterText(
              m.propertySelectionRationale ||
                (C !== truncateChapterText(m.daySummaryText || "", 240)
                  ? m.daySummaryText || ""
                  : m.tagline || ""),
              280,
            ),
            chapterCards = (o.get(n) || []).filter(
              ({ cardId: t, payload: n }) =>
                t !== g &&
                t !== y &&
                !(
                  s(n) &&
                  "stay" === String(n.eventGroup || "").trim().toLowerCase()
                ),
            ),
            routeFocus =
              chapterCards.find(({ payload: e }) => {
                const t = String(e?.type || "").trim().toLowerCase(),
                  n = String(e?.eventGroup || "").trim().toLowerCase();
                return (
                  ["route", "logistics", "travel-stop"].includes(t) ||
                  "logistics" === n
                );
              }) || null,
            x = [],
            f = u || p,
            B = chapterLocationFallback({
              dayEntry,
              leg: m,
              propertyPayload: u,
              locationPayload,
              logisticsCardId: routeFocus?.cardId || "",
              chapterLabel,
              mapboxToken: e?.mapboxToken,
              mapboxStyle: e?.mapboxStyle,
              coordIndex: e?.componentMapCoordIndex,
            });
          for (const { cardId: e, payload: t } of chapterCards) {
            const n = chapterHighlightLabel(t),
              r = String(t.title || "").trim() || "Journey detail",
              i = `${c(n)}|${c(r)}`;
            if (!r || x.some((e) => e.signature === i)) continue;
            x.push({
              signature: i,
              cardId: e,
              label: n,
              title: r,
              meta:
                truncateChapterText(
                  t.meta || t.summary || t.tagline || "",
                  92,
                ) || "",
            });
            if (x.length >= 4) break;
          }
          f &&
            (e.dayToChapterPayload[n] = {
              type: "chapter",
              template: "chapter",
              title:
                String(f.title || m.chapterTitle || m.name || "Journey chapter").trim(),
              kicker:
                u && (locationPayload || B)
                  ? "Featured stay with location context"
                  : u
                    ? "Featured stay"
                    : "Featured location",
              meta: b,
              summary: C,
              stats: S,
              primary: f
                ? {
                    label: u ? "Featured stay" : "Featured location",
                    title: String(f.title || "").trim(),
                    meta:
                      truncateChapterText(
                        f.meta ||
                          (u ? m.accommodationName : m.destinationName) ||
                          "",
                        96,
                      ) || "",
                    copy:
                      truncateChapterText(
                        f.tagline ||
                          (u ? m.tagline : "") ||
                          "",
                        150,
                      ) || "",
                    image: String(f.featuredImage || "").trim(),
                    imageAlt: String(f.title || "").trim(),
                    actionLabel: u ? "Open stay" : "Open location",
                    cardId: u ? g : y,
                    handle: String(f.handle || "").trim(),
                    url: String(f.url || f.displayUrl || "").trim(),
                  }
                : null,
              secondary: locationPayload
                ? {
                    label: "Location lens",
                    title: String(locationPayload.title || "").trim(),
                    meta:
                      truncateChapterText(
                        locationPayload.meta || m.destinationName || "",
                        96,
                      ) || "",
                    copy: truncateChapterText(locationPayload.tagline || "", 140) || "",
                    image: String(locationPayload.featuredImage || "").trim(),
                    imageAlt: String(locationPayload.title || "").trim(),
                    actionLabel: "Open location",
                    cardId: y,
                    handle: String(locationPayload.handle || "").trim(),
                    url: String(locationPayload.url || locationPayload.displayUrl || "").trim(),
                  }
                : B,
              notes: P
                ? {
                    label: m.propertySelectionRationale
                      ? "Why this chapter works"
                      : "Journey note",
                    copy: P,
                  }
                : null,
              highlights: x.map(({ signature: _discard, ...e }) => e),
              source: "chapter",
            });
        }
      }
    },
    ze = (e) => /^day-\d+$/i.test(String(e || "").trim()),
    Je = (e) =>
      ((e) =>
        String(e || "")
          .trim()
          .toLowerCase() === t)(e) || ze(e),
    Ve = (e, t, n = {}) => {
      const r = Boolean(n.suppressSidebarAutoScroll),
        i = e.querySelectorAll("[data-command-center-nav-key]");
      for (const e of i) {
        const n = e.dataset.commandCenterNavKey === t;
        (e.classList.toggle("is-active", n),
          e.setAttribute("aria-current", n ? "true" : "false"));
      }
      const a = e.querySelectorAll("[data-command-center-pill-key]");
      for (const e of a) {
        const n = e.dataset.commandCenterPillKey === t;
        (e.classList.toggle("is-active", n),
          e.setAttribute("aria-current", n ? "true" : "false"));
      }
      const o = e.commandCenterState || {},
        c = o.dayToLegIndex || {},
        s = Object.prototype.hasOwnProperty.call(c, t) ? c[t] : null,
        l = e.querySelectorAll("[data-command-center-intro-leg-index]");
      for (const e of l) {
        const n = w(e.dataset.commandCenterIntroLegIndex, -1),
          r =
            String(e.dataset.commandCenterIntroLegKey || "").trim() === t ||
            (null !== s && n === s);
        (e.classList.toggle("is-active-leg", r),
          e.setAttribute("aria-current", r ? "true" : "false"));
      }
      const d = e.querySelectorAll("[data-command-center-nav-leg-index]");
      for (const e of d) {
        const t = w(e.dataset.commandCenterNavLegIndex, -1),
          n = null !== s && t === s;
        e.classList.toggle("is-active-leg", n);
        const r = e.querySelector("[data-command-center-leg-days]");
        r && n && ((r.hidden = !1), e.classList.remove("is-collapsed"));
        const i = e.querySelector(".itin-command-center__nav-leg-hero");
        i &&
          (i.classList.toggle("is-active-leg", n),
          n && i.setAttribute("aria-expanded", "true"));
      }
      const m = e.querySelectorAll("[data-command-center-tour-leg-index]");
      for (const e of m) {
        const n = w(e.dataset.commandCenterTourLegIndex, -1),
          r =
            String(e.dataset.commandCenterNavKey || "").trim() === t ||
            (null !== s && n === s);
        (e.classList.toggle("is-active", r),
          e.setAttribute("aria-current", r ? "true" : "false"));
      }
      const u =
        o.sidebarPane || e.querySelector("[data-command-center-sidebar]");
      if (!r && u && t) {
        const e = String(t).replace(/"/g, '\\"'),
          n =
            u.querySelector(
              `.itin-command-center__nav-card[data-command-center-nav-key="${e}"]`,
            ) || u.querySelector(`[data-command-center-nav-key="${e}"]`);
        n &&
          "function" == typeof n.scrollIntoView &&
          n.scrollIntoView({ block: "nearest", inline: "nearest" });
      }
    },
    Ze = (e, t, n) => {
      const r = e.querySelector(t);
      r && (r.textContent = String(n || ""));
    },
    Qe = (e, t, n) => Math.min(n, Math.max(t, e)),
    Xe = (e) => {
      const t = String(e || "").trim();
      return t ? `/products/${encodeURIComponent(t)}` : "/";
    },
    et = (e, t = {}) => {
      const n = String(e?.handle || t.handle || "").trim(),
        r = Xe(n);
      return te(e?.url, r);
    },
    tt = (e) => {
      if (!e) return "";
      const t = e.querySelector(
        '[id^="shopify-section-template--"][id$="__main"]',
      );
      if (t) return t.outerHTML;
      const n = Array.from(e.querySelectorAll('[id^="shopify-section-"]'));
      for (const e of n)
        if (
          !String(e.className || "").includes(
            "shopify-section-group-header-group",
          )
        )
          return e.outerHTML;
      const r = e.querySelector("#MainContent");
      return r ? r.innerHTML : "";
    },
    nt = (e, t) =>
      e
        ? t > 0
          ? Math.max(0, e.scrollHeight - e.clientHeight - e.scrollTop)
          : Math.max(0, e.scrollTop)
        : 0,
    rt = (e, t) => {
      if (!e || 0 === t) return 0;
      const n = e.scrollTop;
      return ((e.scrollTop = n + t), e.scrollTop - n);
    },
    it = (e) => {
      if (!e) return;
      const t = e.querySelector(".wetu-command-center-panel__media-column"),
        n = e.querySelector(".wetu-command-center-panel__details-column");
      t &&
        n &&
        !h.has(e) &&
        (e.addEventListener(
          "wheel",
          (e) => {
            if (!window.matchMedia("(min-width: 901px)").matches) return;
            if (Math.abs(e.deltaY) <= Math.abs(e.deltaX || 0)) return;
            const r = e.deltaY > 0 ? 1 : -1,
              i = Math.abs(e.deltaY);
            if (0 === i) return;
            const a = [t, n],
              o = a.map((e) => nt(e, r));
            if (!o.some((e) => e > 0)) return;
            e.preventDefault();
            const c = Math.min(...o.filter((e) => e > 0)),
              s = Math.min(i, c);
            if (s > 0)
              for (let e = 0; e < a.length; e += 1) o[e] > 0 && rt(a[e], r * s);
            const l = i - s;
            if (!(l <= 0))
              for (const e of a) {
                const t = nt(e, r);
                t <= 0 || rt(e, r * Math.min(l, t));
              }
          },
          { passive: !1 },
        ),
        h.add(e));
    },
    at = (e) => {
      if (!(e instanceof Element || e instanceof DocumentFragment)) return;
      const t = [];
      e instanceof Element &&
        e.matches(".wetu-command-center-panel") &&
        t.push(e);
      for (const n of e.querySelectorAll(".wetu-command-center-panel"))
        t.push(n);
      for (const e of t) it(e);
    },
    ot = async (e) => {
      const t = te(e, "/"),
        n = ((e) => {
          const t = te(e, "/");
          try {
            const e = new URL(t, window.location.origin);
            return (
              re(e),
              e.searchParams.set("view", c),
              `${e.pathname || "/"}${e.search}${e.hash}`
            );
          } catch (e) {
            const n = t.includes("?") ? "&" : "?";
            return `${t}${n}view=${encodeURIComponent(c)}`;
          }
        })(t);
      if (!p.has(n)) {
        const e = (async () => {
          try {
            const e = await fetch(n, { credentials: "same-origin" });
            if (e.ok) {
              const t = await e.text();
              if ("" !== t.trim()) {
                const e = new DOMParser().parseFromString(t, "text/html"),
                  n = e.querySelector(".wetu-command-center-panel");
                if (n) return n.outerHTML;
                if (
                  !e.querySelector("#MainContent") &&
                  !e.querySelector('[id^="shopify-section-"]')
                )
                  return t;
              }
            }
          } catch (e) {}
          try {
            const e = await fetch(t, { credentials: "same-origin" });
            if (!e.ok) return "";
            const n = await e.text(),
              r = new DOMParser().parseFromString(n, "text/html"),
              i = ((e) => {
                if (!e) return "";
                const t = e.querySelector(
                  '[id^="shopify-section-template--"][id$="__main"]',
                );
                if (t?.id) return String(t.id).replace(/^shopify-section-/, "");
                const n = Array.from(
                  e.querySelectorAll('[id^="shopify-section-"]'),
                );
                for (const e of n)
                  if (
                    e.id &&
                    !String(e.className || "").includes(
                      "shopify-section-group-header-group",
                    )
                  )
                    return e.id.replace(/^shopify-section-/, "");
                return "";
              })(r);
            if (i) {
              const e = await fetch(
                ((e, t) => {
                  const n = te(e, "/");
                  try {
                    const e = new URL(n, window.location.origin);
                    return (
                      re(e),
                      e.searchParams.set("section_id", String(t || "").trim()),
                      `${e.pathname || "/"}${e.search}${e.hash}`
                    );
                  } catch (e) {
                    const r = n.includes("?") ? "&" : "?";
                    return `${n}${r}section_id=${encodeURIComponent(t)}`;
                  }
                })(t, i),
                { credentials: "same-origin" },
              );
              if (e.ok) {
                const t = await e.text(),
                  n = new DOMParser().parseFromString(t, "text/html"),
                  r = tt(n);
                if (r) return r;
              }
            }
            return tt(r);
          } catch (e) {
            return "";
          }
        })();
        p.set(n, e);
      }
      return p.get(n);
    },
    ct = async (e) => {
      const t = String(e || "").trim();
      if (!t) return null;
      if (!u.has(t)) {
        const e = ((e) => {
          try {
            const t = new URL(e, window.location.origin);
            re(t);
            const n = t.pathname.replace(/\/$/, ""),
              r = t.searchParams.toString();
            return `${n || "/products"}.js${r ? `?${r}` : ""}`;
          } catch (e) {
            return "";
          }
        })(t);
        if (e) {
          const n = fetch(e, { credentials: "same-origin" })
            .then((e) => (e.ok ? e.json() : null))
            .catch(() => null);
          u.set(t, n);
        } else u.set(t, Promise.resolve(null));
      }
      return u.get(t);
    },
    st = (e) => {
      const t = String(e || "").trim();
      return t
        ? t.startsWith("//")
          ? `https:${t}`
          : t.startsWith("http://") || t.startsWith("https://")
            ? t
            : t.startsWith("/")
              ? `${window.location.origin}${t}`
              : ""
        : "";
    },
    lt = (e, t = 2400) => {
      const n = st(e);
      if (!n) return "";
      try {
        const e = new URL(n);
        return (e.searchParams.set("width", String(t)), e.toString());
      } catch (e) {
        return n;
      }
    },
    dt = (e) => {
      const t = st(e);
      if (!t) return "";
      try {
        const e = new URL(t),
          n = e.pathname
            .replace(/_(\d+x\d+|\d+x|x\d+)(?=\.[a-z0-9]+$)/i, "")
            .toLowerCase();
        return `${e.host}${n}`;
      } catch (e) {
        return t.toLowerCase();
      }
    },
    v2MapboxStylePath = (e) => {
      const t = String(e || "").trim();
      if (!t) return "mapbox/light-v11";
      const n = t
        .replace(/^mapbox:\/\/styles\//i, "")
        .replace(/^styles\//i, "")
        .replace(/^\/+/, "");
      return n || "mapbox/light-v11";
    },
    v2GetInspectorMapCoordIndex = (e) => {
      if (!(e instanceof Element)) return new Map();
      const t = v2InspectorMapCache.get(e);
      if (t instanceof Map) return t;
      const n = new Map(),
        r = String(e.dataset.componentProductCandidates || "").trim();
      if (r)
        try {
          const e = JSON.parse(r);
          Array.isArray(e) &&
            e.forEach((e) => {
              if (!e || "object" != typeof e) return;
              const t =
                  Number.parseFloat(
                    String(
                      e.driving_longitude ?? e.longitude ?? e.lng ?? "",
                    ).trim(),
                  ),
                r = Number.parseFloat(
                  String(e.driving_latitude ?? e.latitude ?? e.lat ?? "").trim(),
                );
              if (!Number.isFinite(t) || !Number.isFinite(r)) return;
              const i = [
                A(e.pin),
                A(e.content_entity_id),
                A(e.primary_pin),
              ].filter(Boolean);
              for (const e of i) n.set(e, { lng: t, lat: r });
            });
        } catch (e) {}
      return (v2InspectorMapCache.set(e, n), n);
    },
    v2BuildInspectorStaticMapUrl = ({
      token: e,
      stylePath: t,
      points: n,
      includeLine: r = !0,
    }) => {
      const i = String(e || "").trim();
      if (!/^pk\./i.test(i)) return "";
      if (!Array.isArray(n) || 0 === n.length) return "";
      const a = [],
        o = n
          .map((e) => ({
            lng: Number.parseFloat(String(e.lng ?? "").trim()),
            lat: Number.parseFloat(String(e.lat ?? "").trim()),
          }))
          .filter((e) => Number.isFinite(e.lng) && Number.isFinite(e.lat));
      if (0 === o.length) return "";
      if (r && o.length >= 2) {
        const e = {
          type: "Feature",
          properties: { stroke: "#111111", "stroke-width": 3, "stroke-opacity": 0.85 },
          geometry: {
            type: "LineString",
            coordinates: o.map((e) => [e.lng, e.lat]),
          },
        };
        a.push(`geojson(${encodeURIComponent(JSON.stringify(e))})`);
      }
      for (let e = 0; e < o.length && e < 4; e += 1) {
        const t = String.fromCharCode(97 + e),
          n = o[e];
        a.push(`pin-s-${t}(${n.lng.toFixed(6)},${n.lat.toFixed(6)})`);
      }
      const c =
          a.length > 0 ? a.join(",") : "0,0,1",
        s = String(t || "mapbox/light-v11").replace(/^\/+/, "");
      return `https://api.mapbox.com/styles/v1/${s}/static/${c}/auto/920x520?padding=72&access_token=${encodeURIComponent(i)}`;
    },
    v2RenderInspectorMapPreview = (e, t, n) => {
      if (!(e instanceof Element) || !t || "object" != typeof t || !n)
        return;
      const r = String(t.eventTypeId || "")
          .trim()
          .toLowerCase(),
        i = new Set([
          "scheduled-flight",
          "private-transfer",
          "self-drive",
          "arrival-greeting",
          "mobile-stop",
          "mobile-check-in",
          "car-hire",
        ]);
      const a =
          n.querySelector("[data-inspector-route-map-shell]") ||
          n.querySelector("[data-inspector-travel-stop-map-shell]");
      if (!(a instanceof Element)) return;
      const o = a.querySelector("[data-command-center-inspector-static-map]");
      if (!i.has(r)) return void (o && o.remove());
      const c = String(e.dataset.mapboxToken || "").trim();
      if (
        !/^pk\./i.test(c) ||
        /your_mapbox_public_token|replace_me|example/i.test(c)
      )
        return void (o && o.remove());
      const s = v2GetInspectorMapCoordIndex(e),
        l = [t.mapPins?.startPin, t.sourceRouteStartPin, t.startPin, ""]
          .map((e) => A(e))
          .find(Boolean) || "",
        d = [t.mapPins?.endPin, t.sourceRouteEndPin, t.endPin, ""]
          .map((e) => A(e))
          .find(Boolean) || "",
        m = [
          t.mapPins?.primaryPin,
          t.entityPin,
          t.sourceContentEntityId,
          t.pin,
          t.sourceRouteEndPin,
          t.sourceRouteStartPin,
          "",
        ]
          .map((e) => A(e))
          .find(Boolean) || "",
        u = [];
      const p = (e) => {
        const t = String(e || "").trim();
        if (!t || u.some((e) => e.key === t)) return;
        const n = s.get(t);
        n &&
          Number.isFinite(n.lng) &&
          Number.isFinite(n.lat) &&
          u.push({ key: t, lng: n.lng, lat: n.lat });
      };
      (p(l), p(d), p(m));
      if (0 === u.length) return void (o && o.remove());
      const g = v2BuildInspectorStaticMapUrl({
        token: c,
        stylePath: v2MapboxStylePath(e.dataset.mapboxStyle),
        points: u,
        includeLine: u.length > 1,
      });
      if (!g) return void (o && o.remove());
      const y =
          String(t.title || t.path || "Route map preview").trim() ||
          "Route map preview",
        f =
          o instanceof HTMLElement
            ? o
            : Object.assign(document.createElement("figure"), {
                className: "itin-command-center__inspector-static-map",
              });
      (f.setAttribute("data-command-center-inspector-static-map", ""),
        (f.innerHTML = `<img src="${b(g)}" alt="${b(y)}" loading="lazy" width="920" height="520">`),
        o || a.appendChild(f));
    },
    mt = () => Boolean(S.overlay && !S.overlay.hidden),
    ut = () => {
      S.overlay &&
        (S.overlay.classList.remove("is-open"),
        S.overlay.setAttribute("aria-hidden", "true"),
        (S.overlay.hidden = !0),
        S.track && (S.track.innerHTML = ""),
        (document.documentElement.style.overflow = S.restoreHtmlOverflow || ""),
        (document.body.style.overflow = S.restoreBodyOverflow || ""),
        S.restoreScrollWrapper &&
          (S.restoreScrollWrapper.scrollTop = S.restoreScrollWrapperTop || 0),
        Number.isFinite(S.restoreWindowY) &&
          window.scrollTo({ top: S.restoreWindowY, behavior: "auto" }),
        S.previousFocus &&
          "function" == typeof S.previousFocus.focus &&
          S.previousFocus.focus({ preventScroll: !0 }),
        (S.previousFocus = null),
        (S.restoreScrollWrapper = null),
        (S.openRoot = null),
        (S.restoreScrollWrapperTop = 0));
    },
    pt = (e, t = "") => {
      const n = Array.isArray(e?.variants) ? e.variants : [];
      if (0 === n.length) return null;
      const r = String(t || "").trim();
      if (r) for (const e of n) if (String(e.id) === r) return e;
      for (const e of n) if (e && e.available) return e;
      return n[0] || null;
    },
    gt = (e) => {
      let t = 12;
      if (!e) return { minimumGuests: 1, maximumGuests: 1 };
      if (e.inventory_management && "continue" !== e.inventory_policy) {
        const n = w(e.inventory_quantity, 0);
        t = n > 0 ? Qe(n, 1, 12) : 1;
      }
      return (
        !1 === e.available && (t = 1),
        { minimumGuests: 1, maximumGuests: Math.max(1, t) }
      );
    },
    encodeCheckoutProperties = (e) => {
      if (!e || "object" != typeof e) return "";
      const t = Object.entries(e).reduce((e, [t, n]) => {
        const r = String(n ?? "").trim();
        return r && e.push([t, r]), e;
      }, []);
      if (0 === t.length) return "";
      try {
        const e = JSON.stringify(Object.fromEntries(t)),
          n = new TextEncoder().encode(e);
        let r = "";
        for (const e of n) r += String.fromCharCode(e);
        return btoa(r).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");
      } catch (e) {
        return "";
      }
    },
    formatCheckoutTravelDate = (e) => {
      const t = String(e || "").trim();
      if (!t) return "";
      const n = new Date(t);
      return Number.isNaN(n.getTime())
        ? t
        : n.toLocaleDateString("en-ZA", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          });
    },
    yt = (e, t, n = {}) => {
      const r = String(e || "").trim(),
        i = w(n.totalMinor, 0) > 0 ? 1 : Math.max(1, w(t, 1));
      if (!r) return "#";
      const a = new URL(`/cart/${r}:${i}`, window.location.origin),
        o = String(n.title || "").trim(),
        c = String(n.referenceNumber || "").trim(),
        s = String(n.partyContext || "").trim(),
        l = String(n.totalDisplay || "").trim(),
        d = String(n.currency || "").trim(),
        h = String(n.paymentSchedulePreview || "").trim(),
        m = formatCheckoutTravelDate(n.travelStartDate),
        u = formatCheckoutTravelDate(n.travelEndDate),
        p = [m, u].filter(Boolean).join(" - "),
        g = encodeCheckoutProperties({
          Journey: o,
          Reference: c,
          Party: s,
          "Travel dates": p,
          "Investment total": l,
          "Payment schedule": h,
          _itinerary_title: o,
          _itinerary_reference: c,
          _itinerary_party: s,
          _itinerary_travel_dates: p,
          _itinerary_total_display: l,
          _itinerary_total_minor: String(w(n.totalMinor, 0)),
          _itinerary_currency: d,
          _itinerary_payment_schedule: h,
        }),
        y = [
          o ? `Journey: ${o}` : "",
          c ? `Reference: ${c}` : "",
          s ? `Party: ${s}` : "",
          p ? `Travel dates: ${p}` : "",
          l ? `Contract total: ${l}` : "",
          h ? `Payment plan: ${h}` : "",
        ]
          .filter(Boolean)
          .join(" | ");
      return (
        g && a.searchParams.set("properties", g),
        y && a.searchParams.set("note", y),
        o && a.searchParams.set("attributes[itinerary_title]", o),
        c && a.searchParams.set("attributes[itinerary_reference]", c),
        l && a.searchParams.set("attributes[itinerary_total]", l),
        s && a.searchParams.set("attributes[itinerary_party]", s),
        p && a.searchParams.set("attributes[itinerary_dates]", p),
        a.searchParams.set("attributes[source_surface]", "command-center"),
        a.searchParams.set("ref", "plekify-itinerary-checkout"),
        `${a.pathname}${a.search}`
      );
    },
    buildCheckoutContext = (e = {}) => {
      const t = String(e.title || "").trim(),
        n = String(e.referenceNumber || "").trim(),
        r = String(e.partyContext || "").trim(),
        i = String(e.totalDisplay || "").trim(),
        a = String(e.currency || "").trim(),
        o = String(e.paymentSchedulePreview || "").trim(),
        c = formatCheckoutTravelDate(e.travelStartDate),
        s = formatCheckoutTravelDate(e.travelEndDate),
        l = [c, s].filter(Boolean).join(" - "),
        d = {
          Journey: t,
          Reference: n,
          Party: r,
          "Travel dates": l,
          "Investment total": i,
          "Payment schedule": o,
          _itinerary_title: t,
          _itinerary_reference: n,
          _itinerary_party: r,
          _itinerary_travel_dates: l,
          _itinerary_total_display: i,
          _itinerary_total_minor: String(w(e.totalMinor, 0)),
          _itinerary_currency: a,
          _itinerary_payment_schedule: o,
        },
        m = [
          t ? `Journey: ${t}` : "",
          n ? `Reference: ${n}` : "",
          r ? `Party: ${r}` : "",
          l ? `Travel dates: ${l}` : "",
          i ? `Contract total: ${i}` : "",
          o ? `Payment plan: ${o}` : "",
        ]
          .filter(Boolean)
          .join(" | "),
        u = {};
      t && (u.itinerary_title = t);
      n && (u.itinerary_reference = n);
      i && (u.itinerary_total = i);
      r && (u.itinerary_party = r);
      l && (u.itinerary_dates = l);
      u.source_surface = "command-center";
      return { properties: d, note: m, attributes: u };
    },
    runDirectCheckout = async ({
      bookingEl: e,
      ctaEl: t,
      variantId: n,
      quantity: r,
      checkoutContext: i,
      loadingLabel: a,
    }) => {
      const o = String(n || "").trim(),
        c = Math.max(1, w(r, 1));
      if (!o) throw new Error("No variant selected.");
      t &&
        ((t.textContent = String(a || "Adding…").trim() || "Adding…"),
        t.setAttribute("aria-disabled", "true"));
      e && St(e, !0);
      const s = {
        id: Number(o),
        quantity: c,
      };
      if (i?.properties && "object" == typeof i.properties) {
        const e = Object.entries(i.properties).reduce((e, [t, n]) => {
          const r = String(n ?? "").trim();
          return r && (e[t] = r), e;
        }, {});
        Object.keys(e).length > 0 && (s.properties = e);
      }
      const l = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(s),
      });
      if (!l.ok) {
        const e = await l.json().catch(() => ({}));
        throw new Error(e.description || e.message || "Could not add to cart");
      }
      const d = {};
      i?.note && (d.note = String(i.note).trim());
      if (i?.attributes && "object" == typeof i.attributes) {
        const e = Object.entries(i.attributes).reduce((e, [t, n]) => {
          const r = String(n ?? "").trim();
          return r && (e[t] = r), e;
        }, {});
        Object.keys(e).length > 0 && (d.attributes = e);
      }
      if (Object.keys(d).length > 0)
        await fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(d),
        }).catch(() => null);
      window.location.href = "/checkout";
    },
    ft = (e, t) => {
      const n = e.querySelector("[data-inspector-booking-status]");
      if (!n) return;
      const r = String(t || "").trim();
      ((n.textContent = r), (n.hidden = "" === r));
    },
    ht = (e, t) => {
      if (!e) return;
      const n = Boolean(t.enabled);
      (e.setAttribute("aria-disabled", n ? "false" : "true"),
        e.setAttribute("href", n ? t.href : "#"),
        n ? e.removeAttribute("tabindex") : e.setAttribute("tabindex", "-1"));
    },
    St = (e, t) => {
      const n = e.querySelectorAll(
        "[data-inspector-booking-guest-input], [data-inspector-booking-guest-decrement], [data-inspector-booking-guest-increment]",
      );
      for (const e of n) e.disabled = t;
    },
    createContractTermsInvoice = async (e, t, n) => {
      const r = e.querySelector("[data-inspector-booking-contract-cta]");
      if (!r || "true" === r.getAttribute("aria-disabled")) return;
      const i = e.closest(".itin-command-center"),
        a = String(i?.dataset.itineraryIdentifier || "").trim(),
        o = String(n.variantId || "").trim(),
        c = Math.max(1, w(n.guests, 1)),
        s =
          "true" === String(e.dataset.bookingCanonicalOnly || "").trim()
            ? 1
            : c,
        l = "/apps/plekify/api/itinerary/contract-terms",
        d =
          String(r.dataset.defaultLabel || "").trim() ||
          "Confirm on contract terms / invoice";
      if (!a || !o)
        return void ft(
          e,
          "Contract terms are unavailable for this journey right now.",
        );
      ((r.dataset.defaultLabel = d),
        (r.textContent = "Creating invoice..."),
        r.setAttribute("aria-disabled", "true"),
        St(e, !0),
        ft(e, ""));
      try {
        const n = await fetch(l, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({
              identifier: a,
              variantId: o,
              guestCount: c,
              checkoutQuantity: s,
              sourceSurface: "command-center",
            }),
          }),
          i = await n.json().catch(() => ({}));
        if (!n.ok || !i || !0 !== i.success || !i.invoiceUrl)
          throw new Error(
            i?.error ||
              i?.message ||
              "Unable to create the contract terms invoice.",
          );
        window.location.href = i.invoiceUrl;
      } catch (t) {
        (ft(
          e,
          t instanceof Error
            ? t.message
            : "Unable to create the contract terms invoice.",
        ),
          (r.textContent = d),
          r.setAttribute("aria-disabled", "false"),
          St(e, !1));
      }
    },
    bt = async (e, t, n) => {
      const r = String(
          t.url || n.dataset.bookingProductUrl || Xe(t.handle),
        ).trim(),
        i = String(t.handle || t.url || r).trim();
      if (!i) return;
      const a = `${i}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
      ((n.dataset.bookingSession = a),
        St(n, !0),
        ft(n, "Loading live pricing…"));
      const o = await ct(r);
      if (!n.isConnected || n.dataset.bookingSession !== a) return;
      const c = Array.isArray(o?.variants) ? o.variants : [];
      if (!o || 0 === c.length) {
        ft(n, "Pricing is unavailable for this linked product.");
        const e = n.querySelector("[data-inspector-booking-cta]");
        return void ht(e, { enabled: !1, href: r || "/" });
      }
      const s = g.get(i) || {};
      let l = String(
        s.variantId ||
          ((e) => {
            try {
              const t = new URL(e, window.location.origin);
              return String(t.searchParams.get("variant") || "").trim();
            } catch (e) {
              return "";
            }
          })(r),
      ).trim();
      !l &&
        t.handle &&
        t.handle === e.dataset.productHandle &&
        (l = String(e.dataset.productSelectedVariantId || "").trim());
      const d = pt(o, l);
      if (!d)
        return void ft(
          n,
          "No sellable journey options were returned for this product.",
        );
      const m = gt(d),
        u = Qe(w(t.initialGuestCount, 1), m.minimumGuests, m.maximumGuests),
        p = g.get(i) || {};
      ((p.variantId = String(p.variantId || d.id)),
        (p.guests = Qe(
          w(p.guests, w(s.guests, u)),
          m.minimumGuests,
          m.maximumGuests,
        )),
        g.set(i, p));
      const h =
          String(e.dataset.currencyCode || o.currency || "USD").trim() || "USD",
        S =
          String(
            e.dataset.localeCode || document.documentElement.lang || "en",
          ).trim() || "en",
        b = (e) =>
          ((e, t, n) => {
            const r = String(t || "USD").toUpperCase(),
              i =
                String(n || document.documentElement.lang || "en").trim() ||
                "en",
              a = (Number.isFinite(e) ? e : 0) / 100;
            try {
              return new Intl.NumberFormat(i, {
                style: "currency",
                currency: r,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(a);
            } catch (e) {
              return `${r} ${a.toFixed(2)}`;
            }
          })(e, h, S);
      ((e, t, n) => {
        const r = String(e || "").trim();
        if (!r || !t) return;
        const i = String(t.dataset.bookingKey || "").trim();
        if (i && i !== r) {
          const e = y.get(i);
          e && (e.delete(t), 0 === e.size && y.delete(i));
        }
        let a = y.get(r);
        (a || ((a = new Set()), y.set(r, a)),
          a.add(t),
          (t.dataset.bookingKey = r),
          f.set(t, { render: n }));
      })(i, n, () => {
        ((e, t, n, r, i) => {
          const a =
              String(t.url || e.dataset.bookingProductUrl || "/").trim() || "/",
            o = e.querySelector("[data-inspector-booking-guest-input]"),
            c = e.querySelector("[data-inspector-booking-guest-decrement]"),
            s = e.querySelector("[data-inspector-booking-guest-increment]"),
            l = e.querySelector("[data-inspector-booking-party-context]"),
            d = e.querySelector("[data-inspector-booking-note]"),
            m = e.querySelector("[data-inspector-booking-itinerary-title]"),
            u = e.querySelector("[data-inspector-booking-base-price]"),
            p = e.querySelector("[data-inspector-booking-total-price-line]"),
            g = e.querySelector("[data-inspector-booking-cta]"),
            y = e.querySelector("[data-inspector-booking-contract-cta]"),
            v = e.querySelector("[data-inspector-booking-customize-cta]"),
            x = e.hasAttribute("data-command-center-hero-booking"),
            f = pt(n, r.variantId),
            h = gt(f);
          if (
            ((r.variantId = f ? String(f.id) : ""),
            (r.guests = Qe(w(r.guests, 1), h.minimumGuests, h.maximumGuests)),
            o &&
              ((o.min = String(h.minimumGuests)),
              (o.max = String(h.maximumGuests)),
              (o.value = String(r.guests)),
              (o.disabled = !f)),
            c && (c.disabled = !f || r.guests <= h.minimumGuests),
            s && (s.disabled = !f || r.guests >= h.maximumGuests),
            l &&
              (l.textContent = String(
                t.partyContext ||
                  ((e) => {
                    const t = Math.max(1, w(e, 1));
                    return 1 === t
                      ? "1 guest selected"
                      : `${t} guests selected`;
                  })(r.guests),
              )),
            d)
          ) {
            const e = String(t.priceNarrative || "").trim();
            ((d.textContent = e), (d.hidden = "" === e));
          }
          m &&
            (m.textContent =
              String(t.title || "Itinerary").trim() || "Itinerary");
          const S = f ? w(f.price, 0) : 0,
            b = S * r.guests,
            C = String(t.checkoutTotalDisplay || t.totalDisplay || "").trim(),
            P = buildCheckoutContext({
              title: t.title,
              referenceNumber: t.referenceNumber,
              partyContext: t.partyContext,
              travelStartDate: t.travelStartDate,
              travelEndDate: t.travelEndDate,
              totalDisplay: t.checkoutTotalDisplay || i(b),
              totalMinor: t.checkoutTotalMinor || b,
              currency: t.checkoutCurrency,
              paymentSchedulePreview: t.checkoutPaymentSchedulePreview,
            }),
            canonicalApplied = "true" === String(e.dataset.canonicalPricingApplied || "").trim();
          if (S > 0) {
            (u && (u.textContent = x ? C || i(b) : i(S)),
              p &&
                (x
                  ? ((p.textContent = ""), (p.hidden = !0))
                  : ((p.textContent = ((e, t, n) => {
                      const r = Math.max(1, w(t, 1)),
                        i = 1 === r ? "guest" : "guests";
                      return `${n(e)} total for ${r} ${i}`;
                    })(b, r.guests, i)),
                    (p.hidden = !1))));
          } else if (!canonicalApplied) {
            (u && (u.textContent = i(0)),
              p && (x ? ((p.textContent = ""), (p.hidden = !0)) : ((p.textContent = "—"), (p.hidden = !1))));
          }
          (v &&
              v.setAttribute(
                "href",
                String(t.customizationUrl || "/pages/contact"),
              ),
            y &&
              ((y.onclick = null),
              (y.textContent = x
                ? "On account"
                : "Confirm on contract terms / invoice")),
            f && !1 !== f.available
              ? (ft(e, ""),
                (e.dataset.bookingCanonicalOnly = canonicalApplied ? "true" : "false"),
                g && (g.textContent = x ? "Book now" : "Pay now via Shopify checkout"),
                ht(g, {
                  enabled: !0,
                  href: "/checkout",
                }),
                g &&
                  (g.onclick = async (n) => {
                    if ("true" === String(g.getAttribute("aria-disabled") || "").trim())
                      return void n.preventDefault();
                    n.preventDefault();
                    try {
                      await runDirectCheckout({
                        bookingEl: e,
                        ctaEl: g,
                        variantId: f.id,
                        quantity: r.guests,
                        checkoutContext: P,
                        loadingLabel: x ? "Booking…" : "Adding…",
                      });
                    } catch (t) {
                      ft(
                        e,
                        String(
                          t?.message ||
                            "Something went wrong. Please try again.",
                        ),
                      );
                      g.textContent = x
                        ? "Book now"
                        : "Pay now via Shopify checkout";
                      g.setAttribute("aria-disabled", "false");
                      St(e, !1);
                    }
                  }),
                y &&
                  (ht(y, { enabled: !0, href: "#" }),
                  (y.onclick = (t) => {
                    (t.preventDefault(),
                      createContractTermsInvoice(e, null, r));
                  })))
              : canonicalApplied
                ? (ft(e, ""),
                  (e.dataset.bookingCanonicalOnly = "true"),
                  g && (g.textContent = x ? "Request booking" : "Request confirmation"),
                  ht(g, {
                    enabled: !0,
                    href: String(t.customizationUrl || "/pages/contact"),
                  }),
                  g && (g.onclick = null),
                  y && ht(y, { enabled: !1, href: "#" }))
          : ((e.dataset.bookingCanonicalOnly = "false"),
                  ft(e, "Selected journey is currently unavailable."),
                  ht(g, { enabled: !1, href: a }),
                  g && (g.onclick = null),
                  y && ht(y, { enabled: !1, href: "#" })));
        })(n, t, o, p, b);
      });
      const v = () => {
        (g.set(i, p),
          ((e) => {
            const t = String(e || "").trim();
            if (!t) return;
            const n = y.get(t);
            if (n && 0 !== n.size) {
              for (const e of [...n]) {
                if (!e.isConnected) {
                  (n.delete(e), f.delete(e));
                  continue;
                }
                const t = f.get(e);
                t && "function" == typeof t.render && t.render();
              }
              0 === n.size && y.delete(t);
            }
          })(i));
      };
      St(n, !1);
      const _ = n.querySelector("[data-inspector-booking-guest-input]");
      _ &&
        _.addEventListener("change", () => {
          ((p.guests = w(_.value, p.guests || 1)), v());
        });
      const guestDecrementButton = n.querySelector("[data-inspector-booking-guest-decrement]");
      guestDecrementButton &&
        guestDecrementButton.addEventListener("click", () => {
          ((p.guests -= 1), v());
        });
      const k = n.querySelector("[data-inspector-booking-guest-increment]");
      (k &&
        k.addEventListener("click", () => {
          ((p.guests += 1), v());
        }),
        ft(n, ""),
        v());
    },
    vt = () => window.matchMedia("(max-width: 900px)").matches,
    _t = (e) => {
      const t = e.querySelector("[data-command-center-mobile-picker]");
      return t
        ? "none" === window.getComputedStyle(t).display
          ? 0
          : t.offsetHeight
        : 0;
    },
    Tt = () => 0,
    wt = (e) => {
      e.style.setProperty("--itin-command-center-control-bar-height", "0px");
    },
    setOverviewTabState = (e, t = "") => {
      const n = String(t || "").trim().toLowerCase(),
        r = e.querySelectorAll(
          "[data-command-center-journey-tab], [data-command-center-hero-master-pill]",
        );
      for (const e of r) {
        if (!(e instanceof HTMLElement)) continue;
        const t = String(
            e.getAttribute("data-command-center-journey-tab") ||
              e.getAttribute("data-command-center-hero-master-pill") ||
              "",
          )
            .trim()
            .toLowerCase(),
          r = n && t === n;
        e.classList.toggle("is-active", r);
        if (e.hasAttribute("data-command-center-journey-tab")) {
          e.setAttribute("aria-selected", r ? "true" : "false");
          e.setAttribute("tabindex", r ? "0" : "-1");
        }
        e.hasAttribute("data-command-center-hero-master-pill") &&
          e.setAttribute("aria-pressed", r ? "true" : "false");
      }
    },
    kt = (e) =>
      !!e.narrativePane &&
      !(
        !vt() &&
        e.scrollPhaseController &&
        !e.scrollPhaseController.isColumnsUnlocked
      ) &&
      e.narrativePane.scrollHeight > e.narrativePane.clientHeight + 2,
    $t = (e) => e.getBoundingClientRect().top + window.scrollY,
    Ct = (e, t) => {
      const n = e.querySelectorAll("[data-command-center-card-id]");
      for (const e of n) if (e.dataset.commandCenterCardId === t) return e;
      return null;
    },
    Lt = (e, t) =>
      0 !== e.button ||
      !!(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) ||
      "_blank" === String(t.getAttribute("target") || "").toLowerCase(),
    It = (e) => {
      if (!(e instanceof Element)) return null;
      try {
        const t = new URL(e.getAttribute("href") || "", window.location.origin);
        if (t.origin !== window.location.origin) return null;
        const n = t.pathname.match(/^\/products\/([^/?#]+)/i);
        return n
          ? {
              handle: decodeURIComponent(n[1]),
              url: `${t.pathname || "/"}${t.search}${t.hash}`,
            }
          : null;
      } catch (e) {
        return null;
      }
    },
    Nt = (e, t) => {
      const n = e.querySelectorAll("[data-command-center-card-id]");
      for (const e of n) {
        const n = e.dataset.commandCenterCardId === t;
        (e.classList.toggle("is-selected", n),
          e.setAttribute("aria-pressed", n ? "true" : "false"));
      }
    },
    Pt = (e, t, n = {}) => {
      const r = t && t.template ? t.template : "default",
        i =
          e.querySelector(
            `template[data-command-center-inspector-template="${r}"]`,
          ) ||
          e.querySelector(
            'template[data-command-center-inspector-template="default"]',
          );
      if (!i) return null;
      const a = i.content.cloneNode(!0);
      const o =
        a.firstElementChild instanceof HTMLElement ? a.firstElementChild : null;
      o &&
        (o.setAttribute(
          "data-command-center-inspector-event-group",
          String(t?.eventGroup || "").trim(),
        ),
        o.setAttribute(
          "data-command-center-inspector-event-type",
          String(t?.eventTypeId || "").trim(),
        ));
      if (t && "landing" === t.type) {
        const e = a.querySelector("[data-inspector-landing-includes-section]"),
          n = a.querySelector("[data-inspector-landing-includes-list]"),
          r = Array.isArray(t.includes) ? t.includes : [];
        e &&
          n &&
          (r.length > 0
            ? ((e.hidden = !1),
              (n.innerHTML = r.map((e) => `<li>${b(e)}</li>`).join("")))
            : ((e.hidden = !0), (n.innerHTML = "")));
        const i = a.querySelector("[data-inspector-landing-consultant]"),
          o =
            t.consultant && "object" == typeof t.consultant
              ? t.consultant
              : null;
        if ((i && (i.hidden = !o), o)) {
          (Ze(
            a,
            "[data-inspector-landing-consultant-initials]",
            o.initials || we(o.name),
          ),
            Ze(
              a,
              "[data-inspector-landing-consultant-name]",
              o.name || "Journey consultant",
            ),
            Ze(
              a,
              "[data-inspector-landing-consultant-role]",
              o.role || "Journey consultant",
            ));
          const e = a.querySelector(
            "[data-inspector-landing-consultant-phone]",
          );
          if (e) {
            const t = String(o.phone || "").trim();
            ((e.hidden = "" === t),
              (e.textContent = t),
              e.setAttribute(
                "href",
                t ? `tel:${t.replace(/[^+\d]/g, "")}` : "#",
              ));
          }
          const t = a.querySelector(
            "[data-inspector-landing-consultant-email]",
          );
          if (t) {
            const e = String(o.email || "").trim();
            ((t.hidden = "" === e),
              (t.textContent = e),
              t.setAttribute("href", e ? `mailto:${e}` : "#"));
          }
        }
        const c = a.querySelector("[data-inspector-booking-cta]");
        c &&
          (c.setAttribute("href", t.url || "/"),
          c.setAttribute("aria-disabled", "false"));
        const s = a.querySelector("[data-inspector-booking-contract-cta]");
        s &&
          (s.setAttribute("href", "#"), s.setAttribute("aria-disabled", "true"));
        const l = a.querySelector("[data-inspector-booking-customize-cta]");
        l && l.setAttribute("href", t.customizationUrl || "/pages/contact");
      }
      t &&
        "chapter" === t.type &&
        renderChapterInspector(a, t);
      if (t && "product" === t.type) {
        const e = a.querySelector("[data-inspector-product-content]");
        e &&
          (async (e, t, n = {}) => {
            if (!e) return;
            const r = "function" == typeof n.onSettled ? n.onSettled : null,
              i = !1 !== n.showLoadingState,
              a = et(t, { handle: t?.handle }),
              o = e.closest(
                ".itin-command-center__inspector-detail, .itin-command-center__workspace-pane--right, .itin-command-center__mobile-sheet-body",
              ),
              c = `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
            ((e.dataset.requestToken = c),
              e.setAttribute("aria-busy", "true"),
              i
                ? (e.innerHTML =
                    '<p class="itin-command-center__inspector-product-loading">Loading product details...</p>')
                : (e.textContent = ""),
              o && (o.scrollTop = 0));
            const s = await ot(a);
            if (e.dataset.requestToken !== c) return;
            if ((e.removeAttribute("aria-busy"), !s))
              return (
                (e.innerHTML =
                  '<p class="itin-command-center__inspector-product-error">Product details could not be loaded.</p>'),
                void (r && r())
              );
            if (((e.innerHTML = s), at(e), t && t.focusOnLoad)) {
              const t = e.querySelector(".wetu-command-center-panel__title");
              t instanceof HTMLElement &&
                (t.hasAttribute("tabindex") || t.setAttribute("tabindex", "-1"),
                t.focus({ preventScroll: !0 }));
            }
            const l = e.querySelectorAll('[id^="shopify-section-"]');
            for (const e of l) {
              const t = String(e.id || "").replace(/^shopify-section-/, "");
              e.dispatchEvent(
                new CustomEvent("shopify:section:load", {
                  bubbles: !0,
                  detail: { sectionId: t },
                }),
              );
            }
            (at(e), r && r());
          })(e, t, {
            showLoadingState: !1 !== n.showProductLoadingState,
            onSettled: n.onProductContentSettled,
          });
      }
      if (t && "landing" === t.type) {
        const e = a.querySelectorAll("[data-inspector-booking]");
        for (const n of e)
          ((n.dataset.bookingProductUrl = t.url || "/"),
            (n.dataset.bookingProductHandle = t.handle || ""));
      }
      if (
        (t &&
          "route" === t.type &&
          (Ze(a, "[data-inspector-route-title]", t.title),
          Ze(
            a,
            "[data-inspector-route-meta]",
            t.meta || t.summary || "Route placeholder",
          ),
          Ze(a, "[data-inspector-route-path]", t.path || "Path: Not provided"),
          Ze(
            a,
            "[data-inspector-route-window]",
            t.window || "Time window: Not scheduled",
          ),
          Ze(
            a,
            "[data-inspector-route-duration]",
            t.duration || "Duration: Not provided",
          ),
          Ze(
            a,
            "[data-inspector-route-vehicle]",
            t.vehicle || "Vehicle: Not provided",
          ),
          Ze(
            a,
            "[data-inspector-route-agency]",
            t.agency || "Agency: Not provided",
          ),
          Ze(
            a,
            "[data-inspector-route-map-title]",
            t.mapTitle || "Route map placeholder",
          ),
          Ze(
            a,
            "[data-inspector-route-map-copy]",
            t.mapCopy ||
              "Interactive route map plotting is queued for this itinerary route.",
          )),
        t &&
          "logistics" === t.type &&
          (window.__plekifyInspectorRenderer && window.__plekifyInspectorRenderer.renderLogistics
            ? window.__plekifyInspectorRenderer.renderLogistics(a, t, e)
            : Ze(a, "[data-inspector-logistics-title]", t.title || "Logistics")),
        t &&
          "pricing" === t.type &&
          (window.__plekifyInspectorRenderer && window.__plekifyInspectorRenderer.renderPricing
            ? window.__plekifyInspectorRenderer.renderPricing(a, t, e)
            : Ze(a, "[data-inspector-pricing-title]", t.title || "Pricing")),
        t &&
          "guests" === t.type &&
          (window.__plekifyInspectorRenderer && window.__plekifyInspectorRenderer.renderGuests
            ? window.__plekifyInspectorRenderer.renderGuests(a, t, e)
            : (Ze(
                a,
                "[data-inspector-guests-title]",
                t.title || "Your Travel Party",
              ),
              Ze(a, "[data-inspector-guests-meta]", t.meta || ""))),
        t &&
          "travel-stop" === t.type &&
          (Ze(
            a,
            "[data-inspector-travel-stop-title]",
            t.title || "Travel segment",
          ),
          Ze(
            a,
            "[data-inspector-travel-stop-meta]",
            t.meta || t.mode || "Travel segment",
          ),
          Ze(
            a,
            "[data-inspector-travel-stop-path]",
            t.path || "Location: Not provided",
          ),
          Ze(
            a,
            "[data-inspector-travel-stop-window]",
            t.window || "Time window: Not scheduled",
          ),
          Ze(
            a,
            "[data-inspector-travel-stop-summary]",
            t.summary || "Detailed travel notes are pending.",
          ),
          Ze(
            a,
            "[data-inspector-travel-stop-map-title]",
            t.mapTitle || "Travel segment map placeholder",
          ),
          Ze(
            a,
            "[data-inspector-travel-stop-map-copy]",
            t.mapCopy ||
              "This panel will render plotted transport details in a follow-up map task.",
          )),
        t && "timeline" === t.type)
      ) {
        (Ze(a, "[data-inspector-timeline-label]", t.label || "Timeline detail"),
          Ze(a, "[data-inspector-timeline-title]", t.title || "Timeline event"),
          Ze(a, "[data-inspector-timeline-meta]", t.meta || ""),
          Ze(
            a,
            "[data-inspector-timeline-summary]",
            t.summary || "No timeline detail available.",
          ));
        const e = a.querySelector("[data-inspector-timeline-source]");
        if (e) {
          const n = String(t.source || "").trim();
          ((e.textContent = n ? `Source: ${n}` : ""), (e.hidden = "" === n));
        }
      }
      if (t && "context" === t.type) {
        (Ze(a, "[data-inspector-context-label]", t.label || "Context detail"),
          Ze(a, "[data-inspector-context-title]", t.title || "Context"),
          Ze(a, "[data-inspector-context-meta]", t.meta || ""),
          Ze(a, "[data-inspector-context-summary]", t.summary || ""));
        const e = a.querySelector("[data-inspector-context-body]");
        e &&
          (e.innerHTML =
            String(t.bodyHtml || "").trim() ||
            '<p class="itin-command-center__card-copy">No additional detail supplied.</p>');
        const n = a.querySelector("[data-inspector-context-source]");
        if (n) {
          const e = String(t.source || "").trim();
          ((n.textContent = e ? `Source: ${e}` : ""), (n.hidden = "" === e));
        }
      }
      (t && v2RenderInspectorMapPreview(e, t, a));
      return a;
    },
    xt = (e, t, n, r = {}) => {
      const i = t.narrativePane ? t.narrativePane.scrollTop : null,
        a = n || t.defaultInspectorPayload || null,
        o = ((e) => {
          if (!e || "object" != typeof e) return "none";
          const t = String(e.type || "unknown").trim(),
            n = String(e.template || "").trim(),
            r =
              [e.cardId, e.id, e.handle, e.url, e.title, e.meta].find(
                (e) => "" !== String(e || "").trim(),
              ) || "";
          return [t, n, String(r).trim()].join("|");
        })(a),
        c = Boolean(a && "landing" === a.type);
      if (!r.force && o === t.activeInspectorPayloadKey) return;
      let s = !1;
      const l = {
        showProductLoadingState: !1 !== r.showProductLoadingState,
        onProductContentSettled: () => {
          s ||
            ((s = !0),
            "function" == typeof r.onProductContentSettled &&
              r.onProductContentSettled());
        },
      };
      let d = null;
      const u = Boolean(
          a &&
            "product" === a.type &&
            !r.force &&
            !1 !== r.showProductLoadingState,
        ),
        m = ((e, t, n) => {
        const r = e.querySelector("[data-command-center-inspector-body]");
        if (!r) return null;
        if (n) {
          (r.classList.remove("is-overview-active"),
            r.removeAttribute("data-command-center-route-placeholder"));
          const t = e.querySelectorAll(
            '[data-command-center-journey-tab][aria-selected="true"]',
          );
          for (const e of t) {
            const t = String(
              e.getAttribute("data-command-center-journey-tab") || "",
            )
              .trim()
              .toLowerCase();
            ("overview" !== t && "route" !== t) ||
              (e.classList.remove("is-active"),
              e.setAttribute("aria-selected", "false"),
              e.setAttribute("tabindex", "-1"));
          }
        }
        let i = r.querySelector("[data-command-center-inspector-layout]"),
          a = i
            ? i.querySelector("[data-command-center-inspector-rail]")
            : null,
          o = i
            ? i.querySelector("[data-command-center-inspector-detail]")
            : null;
        return (
          (i && a && o) ||
            ((i = document.createElement("div")),
            (i.className = "itin-command-center__inspector-desktop-layout"),
            i.setAttribute("data-command-center-inspector-layout", ""),
            (a = document.createElement("section")),
            (a.className = "itin-command-center__inspector-rail"),
            a.setAttribute("data-command-center-inspector-rail", ""),
            (a.hidden = !0),
            (o = document.createElement("div")),
            (o.className = "itin-command-center__inspector-detail"),
            o.setAttribute("data-command-center-inspector-detail", ""),
            i.append(a, o),
            r.replaceChildren(i)),
          (t.desktopInspectorDetail = o),
          { body: r, railRegion: a, detailRegion: o }
        );
      })(e, t, u);
      if (m) {
        const t = Pt(e, a, l);
        (t && (m.detailRegion.replaceChildren(t), (d = m.detailRegion)),
          m.body.classList.toggle(
            "is-product-embed",
            Boolean(a && "product" === a.type),
          ),
          u &&
            (m.body.classList.remove("is-overview-active"),
            m.body.removeAttribute("data-command-center-route-placeholder")));
        if (
          a &&
          "logistics" === a.type &&
          d &&
          d.firstElementChild &&
          window.__plekifyInspectorRenderer?.renderLogistics
        ) {
          window.__plekifyInspectorRenderer.renderLogistics(
            d.firstElementChild,
            a,
            e,
          );
        }
      }
      const p = ((e, t, n, r = {}) => {
          const i = e.querySelector(n);
          if (!i) return null;
          const a = Pt(e, t, r);
          return a ? (i.replaceChildren(a), i) : null;
        })(e, a, "[data-command-center-mobile-sheet-body]", l),
        g = [p];
      if (
        a &&
        "logistics" === a.type &&
        p &&
        p.firstElementChild &&
        window.__plekifyInspectorRenderer?.renderLogistics
      ) {
        window.__plekifyInspectorRenderer.renderLogistics(
          p.firstElementChild,
          a,
          e,
        );
      }
      (d && g.push(d),
        ((e, t, n) => {
          if (t && "landing" === t.type)
            for (const r of n) {
              if (!r) continue;
              const n = r.querySelectorAll("[data-inspector-booking]");
              for (const r of n) bt(e, t, r);
            }
        })(e, a, g),
        (a && "landing" === a.type && d && !d.querySelector("[data-inline-booking-prompt]") && window.__plekifyInspectorRenderer?.renderInlineBooking?.(d, e)),
        e.classList.toggle("is-booking-view", c),
        null !== i && t.narrativePane && (t.narrativePane.scrollTop = i),
        (a && "product" === a.type) ||
          ("function" == typeof r.onInspectorRendered &&
            r.onInspectorRendered()),
        (t.activeInspectorPayload = a),
        (t.activeInspectorPayloadKey = o));
    },
    At = (e, t, n, r = {}) => {
      if (!t.mobileSheet) return;
      if (
        (t.mobileSheetCloseTimer &&
          (window.clearTimeout(t.mobileSheetCloseTimer),
          (t.mobileSheetCloseTimer = 0)),
        n)
      ) {
        const e = document.activeElement;
        return (
          (t.mobileSheetLastFocus = e instanceof HTMLElement ? e : null),
          (t.mobileSheet.hidden = !1),
          t.mobileSheet.setAttribute("aria-hidden", "false"),
          r.immediate
            ? t.mobileSheet.classList.add("is-open")
            : window.requestAnimationFrame(() => {
                t.mobileSheet.classList.add("is-open");
              }),
          (t.mobileSheetIsOpen = !0),
          void window.requestAnimationFrame(() => {
            const e = t.mobileSheet.querySelector(
              "[data-command-center-mobile-sheet-close]",
            );
            e instanceof HTMLElement && e.focus({ preventScroll: !0 });
          })
        );
      }
      (t.mobileSheet.classList.remove("is-open"),
        t.mobileSheet.setAttribute("aria-hidden", "true"),
        (t.mobileSheetIsOpen = !1));
      const i = () => {
        t.mobileSheet.classList.contains("is-open") ||
          (t.mobileSheet.hidden = !0);
      };
      if (
        (r.immediate
          ? i()
          : (t.mobileSheetCloseTimer = window.setTimeout(i, 320)),
        r.restoreFocus)
      ) {
        const n = t.mobileSheetLastFocus;
        if (n && n.isConnected) return void n.focus({ preventScroll: !0 });
        if (t.activeCard) {
          const n = Ct(e, t.activeCard);
          n && n.focus({ preventScroll: !0 });
        }
      }
    },
    qt = (e, t) => {
      t.mobileSheet && vt() && At(e, t, !0);
    },
    Et = (e, t, n = {}) => {
      t.mobileSheet &&
        ((!t.mobileSheetIsOpen && t.mobileSheet.hidden) || At(e, t, !1, n));
    },
    Ht = (e, t, n, r = {}) => {
      if (!n || !t.cardsById[n]) return;
      const i = t.cardsById[n];
      if (
        ((t.activeCard = n),
        i.dayKey &&
          ((t.activeDay = i.dayKey),
          Ve(e, t.activeDay, {
            suppressSidebarAutoScroll: Boolean(r.suppressNavAutoScroll),
          })),
        Nt(e, n),
        xt(e, t, i, r.renderOptions || {}),
        t.mobileSheet && !r.suppressMobileSheet && qt(e, t),
        r.focusSelectedCard)
      ) {
        const t = Ct(e, n);
        t && t.focus({ preventScroll: !0 });
      }
    },
    Dt = (e) =>
      e.narrativePaneHeader ? e.narrativePaneHeader.offsetHeight + 12 : 12,
    Mt = (e, t = {}) => {
      const n = Boolean(t.dayOnly),
        r = [],
        i = e.querySelectorAll("[data-command-center-anchor]");
      for (const e of i) {
        const t = String(e.dataset.commandCenterAnchor || "").trim();
        t && ((n && !ze(t)) || (Je(t) && r.push({ key: t, element: e })));
      }
      return (r.sort((e, t) => e.element.offsetTop - t.element.offsetTop), r);
    },
    jt = (e, t) => {
      if (
        (((e) => {
          (e.anchorObserver &&
            (e.anchorObserver.disconnect(), (e.anchorObserver = null)),
            (e.observedAnchorEntries = new Map()),
            (e.observedActiveDay = ""));
        })(t),
        !("IntersectionObserver" in window))
      )
        return;
      if (!Array.isArray(t.anchorEntries) || 0 === t.anchorEntries.length)
        return;
      const n = !vt() && t.narrativePane ? t.narrativePane : null,
        r = n ? Dt(t) : Tt(e) + _t(e) + 8,
        i = `-${Math.max(0, Math.round(r))}px 0px -85% 0px`;
      ((t.observedAnchorEntries = new Map()),
        (t.anchorObserver = new IntersectionObserver(
          (n) => {
            for (const e of n) {
              const n = String(
                e.target?.dataset?.commandCenterAnchor || "",
              ).trim();
              Je(n) &&
                (e.isIntersecting
                  ? t.observedAnchorEntries.set(n, {
                      top: e.boundingClientRect.top,
                      ratio: e.intersectionRatio,
                    })
                  : t.observedAnchorEntries.delete(n));
            }
            const r = ((e, t) => {
              const n =
                t.observedAnchorEntries instanceof Map
                  ? [...t.observedAnchorEntries.entries()]
                  : [];
              if (0 === n.length) return "";
              const r = kt(t) ? Dt(t) + 8 : Tt(e) + _t(e) + 8,
                i = n.filter(([, e]) => e.top <= r);
              return i.length > 0
                ? (i.sort((e, t) => t[1].top - e[1].top), i[0][0])
                : (n.sort((e, t) => e[1].top - t[1].top), n[0][0]);
            })(e, t);
            const i =
              r && r === t.overviewKey && t.firstDayKey ? t.firstDayKey : r;
            i &&
              ((t.observedActiveDay = i),
              t.isProgrammaticScroll ||
                i === t.activeDay ||
                ((t.activeDay = i),
                Ve(e, t.activeDay),
                defaultDayInspectorPayload(t, i) &&
                  ((t.activeCard = ""),
                  Nt(e, ""),
                  setOverviewTabState(e, "overview"),
                  xt(e, t, defaultDayInspectorPayload(t, i)))));
          },
          { root: n, rootMargin: i, threshold: 0 },
        )));
      for (const e of t.anchorEntries) t.anchorObserver.observe(e.element);
    },
    Rt = (e, t, n, r = {}) => {
      const i = t.legStartCardByDayKey || {},
        a = String(i[n] || "").trim();
      return !(
        !a ||
        !t.cardsById[a] ||
        ((t.activeCard !== a || r.force) &&
          (Ht(e, t, a, {
            suppressMobileSheet: !0,
            suppressNavAutoScroll: Boolean(r.suppressNavAutoScroll),
            renderOptions: r.renderOptions || {},
          }),
          0))
      );
    },
    Bt = (e, t, n, r = {}) => {
      if (!(n instanceof Element)) return !1;
      const i = n.querySelector(
          ".itin-command-center__day-leg-product [data-command-center-card-id]",
        ),
        a = n.querySelector(
          ".itin-command-center__day-activities [data-command-center-card-id]",
        ),
        o = n.querySelector(
          ".itin-command-center__day-routes [data-command-center-card-id]",
        ),
        c = i || a || o || n.querySelector("[data-command-center-card-id]");
      if (!(c instanceof HTMLElement)) return !1;
      const s = String(c.dataset.commandCenterCardId || "").trim();
      return !(
        !s ||
        !t.cardsById[s] ||
        (Ht(e, t, s, {
          suppressMobileSheet: !0,
          suppressNavAutoScroll: Boolean(r.suppressNavAutoScroll),
          renderOptions: r.renderOptions || {},
        }),
        0)
      );
    },
    Ot = (e, t) => {
      if (!t.narrativePane || t.isProgrammaticScroll) return;
      0 === t.anchorEntries.length && (t.anchorEntries = Mt(e));
      let n = "";
      if ((Je(t.observedActiveDay) && (n = t.observedActiveDay), !n)) {
        const r = kt(t)
          ? t.narrativePane.scrollTop + Dt(t)
          : window.scrollY + Tt(e) + _t(e) + 16;
        n = t.overviewKey || t.firstDayKey || t.anchorEntries[0]?.key || "";
        for (const e of t.anchorEntries)
          e.element &&
            (kt(t) ? e.element.offsetTop : $t(e.element)) <= r &&
            (n = e.key);
      }
      n !== t.activeDay && ((t.activeDay = n), Ve(e, t.activeDay));
    },
    Ut = (e, t, n, r = {}) => {
      if (!n) return;
      if (r.ensureColumnsUnlocked && t.scrollPhaseController && !vt())
        return void t.scrollPhaseController.ensureColumnsUnlocked(() => {
          Ut(e, t, n, { ...r, ensureColumnsUnlocked: !1 });
        });
      const i = window.matchMedia("(prefers-reduced-motion: reduce)").matches,
        a = i ? "auto" : "smooth",
        o = () => {
          "function" == typeof r.afterScroll && r.afterScroll();
        };
      if (!kt(t)) {
        const r = $t(n) - Tt(e) - _t(e) - 12;
        return (
          (t.isProgrammaticScroll = !0),
          window.scrollTo({ top: Math.max(0, r), behavior: a }),
          window.clearTimeout(t.navScrollTimer),
          void (t.navScrollTimer = window.setTimeout(
            () => {
              ((t.isProgrammaticScroll = !1), Ot(e, t), o());
            },
            i ? 0 : 420,
          ))
        );
      }
      const c = t.narrativePane.getBoundingClientRect(),
        s = n.getBoundingClientRect(),
        l = t.narrativePane.scrollTop + (s.top - c.top) - Dt(t);
      ((t.isProgrammaticScroll = !0),
        t.narrativePane.scrollTo({ top: Math.max(0, l), behavior: a }),
        window.clearTimeout(t.navScrollTimer),
        (t.navScrollTimer = window.setTimeout(
          () => {
            ((t.isProgrammaticScroll = !1), Ot(e, t), o());
          },
          i ? 0 : 420,
        )));
    },
    Ft = (e, t) => {
      t.scrollFrameRequest ||
        (t.scrollFrameRequest = window.requestAnimationFrame(() => {
          ((t.scrollFrameRequest = 0), Ot(e, t));
        }));
    },
    Kt = (e, t) => {
      (e.addEventListener("click", (n) => {
        const r = n.target.closest(
          "[data-command-center-mobile-sheet-dismiss], [data-command-center-mobile-sheet-close]",
        );
        if (r && e.contains(r))
          return (n.preventDefault(), void Et(e, t, { restoreFocus: !0 }));
        const i = n.target.closest(
          "[data-command-center-inspector-product-trigger]",
        );
        if (i && e.contains(i)) {
          if (i.matches("a[href]") && Lt(n, i)) return;
          n.preventDefault();
          const r = ((e) => {
            if (!(e instanceof Element)) return null;
            const t = String(
                e.dataset.commandCenterInspectorProductHandle || "",
              ).trim(),
              n = String(
                e.dataset.commandCenterInspectorProductUrl || "",
              ).trim(),
              r = String(
                e.dataset.commandCenterInspectorProductTitle || "",
              ).trim(),
              i = It(e),
              a = t || i?.handle || "",
              o = n || i?.url || (a ? Xe(a) : "");
            if (!a && !o) return null;
            const c =
                r || String(e.textContent || "").trim() || "Related product",
              s = et(
                { handle: a, url: o },
                {
                  kind: "inline",
                  title: c,
                  categoryHints: ["related product", "property collection"],
                },
              );
            return {
              type: "product",
              template: "product",
              title: c,
              meta: "Related product",
              handle: a,
              url: s,
              displayUrl: s,
              resolutionSource: "related-collection-link",
              focusOnLoad: !0,
            };
          })(i, t.entityResolver);
          if (!r) return;
          return (xt(e, t, r), void (t.mobileSheet && vt() && qt(e, t)));
        }
        const a = n.target.closest("[data-command-center-gallery-trigger]");
        if (a && e.contains(a)) {
          if (a.matches("a[href]") && Lt(n, a)) return;
          const hintEl = e.querySelector("[data-gallery-hint]"); if (hintEl) hintEl.classList.add("is-dismissed");
          return (
            n.preventDefault(),
            void (async (e, t) => {
              if (!(e instanceof Element && t instanceof Element)) return;
              const n = String(
                t.dataset.commandCenterGalleryHandle || "",
              ).trim();
              if (!n) return;
              const r = Xe(n),
                i = ((e, t = "") => {
                  const n = [],
                    r = new Set(),
                    i = String(e?.title || t || "Gallery image").trim(),
                    a = Array.isArray(e?.media) ? e.media : [];
                  for (let e = 0; e < a.length; e += 1) {
                    const t = a[e],
                      o = String(t?.media_type || t?.type || "").toLowerCase();
                    if (o && "image" !== o) continue;
                    const c =
                        t?.src ||
                        t?.image?.src ||
                        t?.preview_image?.src ||
                        t?.preview_image?.url ||
                        "",
                      s = dt(c);
                    s &&
                      !r.has(s) &&
                      (r.add(s),
                      n.push({
                        mediaId: String(t?.id || ""),
                        src: lt(c, 2400),
                        alt: String(t?.alt || t?.preview_image?.alt || i),
                        position: w(t?.position, e + 1),
                      }));
                  }
                  if ((n.sort((e, t) => e.position - t.position), n.length > 0))
                    return n;
                  const o = Array.isArray(e?.images) ? e.images : [];
                  for (const e of o) {
                    const t = dt(e);
                    t &&
                      !r.has(t) &&
                      (r.add(t),
                      n.push({
                        mediaId: "",
                        src: lt(e, 2400),
                        alt: i,
                        position: n.length + 1,
                      }));
                  }
                  return n;
                })(await ct(r), t.getAttribute("aria-label") || n);
              if (0 === i.length) {
                const e = lt(
                  t.dataset.commandCenterGalleryImageSrc || "",
                  2400,
                );
                e &&
                  i.push({
                    mediaId: String(
                      t.dataset.commandCenterGalleryMediaId || "",
                    ),
                    src: e,
                    alt: String(t.getAttribute("aria-label") || n),
                    position: 1,
                  });
              }
              if (0 === i.length) return;
              mt() && ut();
              const a = ((e) => {
                if (!(e instanceof Element)) return null;
                let t = e.querySelector(
                  ".itin-command-center__fullscreen-gallery",
                );
                return (
                  t ||
                    ((t = document.createElement("div")),
                    (t.className = "itin-command-center__fullscreen-gallery"),
                    (t.hidden = !0),
                    t.setAttribute("aria-hidden", "true"),
                    t.setAttribute("role", "dialog"),
                    t.setAttribute("aria-modal", "true"),
                    (t.innerHTML =
                      '\n          <div class="itin-command-center__fullscreen-gallery-scroll">\n            <div class="itin-command-center__fullscreen-gallery-track"></div>\n          </div>\n        '),
                    e.appendChild(t),
                    t.addEventListener("click", (e) => {
                      (e.target.closest(
                        ".itin-command-center__fullscreen-gallery-image",
                      ) ||
                        e.target === t) &&
                        ut();
                    })),
                  (S.overlay = t),
                  (S.scroller = t.querySelector(
                    ".itin-command-center__fullscreen-gallery-scroll",
                  )),
                  (S.track = t.querySelector(
                    ".itin-command-center__fullscreen-gallery-track",
                  )),
                  t
                );
              })(e);
              if (!a || !S.track || !S.scroller) return;
              const o = ((e, t) => {
                if (!Array.isArray(e) || 0 === e.length) return 0;
                if (!(t instanceof Element)) return 0;
                const n = String(
                  t.dataset.commandCenterGalleryMediaId || "",
                ).trim();
                if (n) {
                  const t = e.findIndex((e) => String(e.mediaId || "") === n);
                  if (t >= 0) return t;
                }
                const r = dt(t.dataset.commandCenterGalleryImageSrc || "");
                if (r) {
                  const t = e.findIndex((e) => dt(e.src) === r);
                  if (t >= 0) return t;
                }
                const i = w(t.dataset.commandCenterGalleryIndex, -1);
                return i >= 0 && i < e.length ? i : 0;
              })(i, t);
              ((S.track.innerHTML = i
                .map(
                  (e, t) =>
                    `\n        <figure class="itin-command-center__fullscreen-gallery-item">\n          <img\n            class="itin-command-center__fullscreen-gallery-image"\n            src="${b(e.src)}"\n            alt="${b(e.alt)}"\n            loading="${t <= 1 ? "eager" : "lazy"}"\n            data-command-center-gallery-image-index="${t}"\n          >\n        </figure>\n      `,
                )
                .join("")),
                (S.previousFocus =
                  t instanceof HTMLElement ? t : document.activeElement),
                (S.restoreScrollWrapper = e.querySelector(
                  "[data-command-center-scroll-wrapper]",
                )),
                (S.restoreScrollWrapperTop = S.restoreScrollWrapper
                  ? S.restoreScrollWrapper.scrollTop
                  : 0),
                (S.restoreWindowY = window.scrollY),
                (S.restoreHtmlOverflow =
                  document.documentElement.style.overflow),
                (S.restoreBodyOverflow = document.body.style.overflow),
                (S.openRoot = e),
                (document.documentElement.style.overflow = "hidden"),
                (document.body.style.overflow = "hidden"),
                (a.hidden = !1),
                a.setAttribute("aria-hidden", "false"),
                a.classList.add("is-open"),
                (S.scroller.scrollTop = 0),
                window.requestAnimationFrame(() => {
                  const e = S.track.querySelector(
                    `[data-command-center-gallery-image-index="${o}"]`,
                  );
                  e && e.scrollIntoView({ block: "start", behavior: "auto" });
                }));
            })(e, a)
          );
        }
        const o = n.target.closest("[data-command-center-overview-detail]");
        if (o && e.contains(o)) {
          n.preventDefault();
          const r = String(o.dataset.commandCenterOverviewDetail || "").trim();
          let i =
            t.overviewInspectorPayloads &&
            "object" == typeof t.overviewInspectorPayloads
              ? t.overviewInspectorPayloads[r]
              : null;
          "overview" === r &&
            defaultDayInspectorPayload(t, t.activeDay) &&
            (i = defaultDayInspectorPayload(t, t.activeDay));
          if (!i) return;
          setOverviewTabState(e, r);
          xt(e, t, i, { force: !0 });
          const a = String(o.dataset.commandCenterNavTarget || "").trim();
          if (a) {
            const n = e.querySelector(`[id="${a}"]`);
            n && n.scrollIntoView({ block: "start", behavior: "smooth" });
          }
          return void (t.mobileSheet && vt() && qt(e, t));
        }
        const c = n.target.closest("[data-command-center-nav-target]");
        if (c && e.contains(c)) {
          n.preventDefault();
            setOverviewTabState(e, "overview");
            const r = c.dataset.commandCenterNavTarget;
          if (!r) return;
          const i = e.querySelector(`[id="${r}"]`);
          if (!i) return;
          const a = String(
              c.dataset.commandCenterNavKey ||
                c.dataset.commandCenterPillKey ||
                t.firstDayKey ||
                "",
            ).trim(),
            o = String(c.dataset.commandCenterNavAutoload || "").trim(),
            l = String(c.dataset.commandCenterInspectorFocus || "").trim(),
            s = c.hasAttribute("data-command-center-intro-leg-index");
          if (
            (Je(a) &&
              ((t.activeDay = a),
              Ve(e, t.activeDay, { suppressSidebarAutoScroll: s })),
            ze(a))
          ) {
            let n = !1;
            if (
              ("leg-start" === o &&
                defaultDayInspectorPayload(t, a) &&
                ((t.activeCard = ""),
                Nt(e, ""),
                setOverviewTabState(e, "overview"),
                xt(e, t, defaultDayInspectorPayload(t, a), {
                  force: !0,
                  suppressNavAutoScroll: s,
                }),
                (n = !0)),
              !n &&
                defaultDayInspectorPayload(t, a) &&
                ((t.activeCard = ""),
                Nt(e, ""),
                setOverviewTabState(e, "overview"),
                xt(e, t, defaultDayInspectorPayload(t, a), { force: !0 }),
                (n = !0)),
              !n && ("day-first-card" === o || "leg-start" === o))
            ) {
              const r = ((e, t, n) => {
                if (!(t instanceof Element)) return null;
                if (t.matches(".itin-command-center__day-section")) return t;
                const r = String(
                  t.dataset.commandCenterFirstDayKey || n || "",
                ).trim();
                return ze(r)
                  ? e.querySelector(`[id="command-center-${r}"]`)
                  : null;
              })(e, i, a);
              r && (n = Bt(e, t, r, { suppressNavAutoScroll: s }));
            }
          }
          if (!s) {
            const n = ze(a) || "leg-start" === o;
            Ut(e, t, i, { ensureColumnsUnlocked: n });
          }
          if ("stay" === l || "location" === l) {
            window.requestAnimationFrame(() =>
              window.requestAnimationFrame(() => {
                const n =
                    "location" === l
                      ? [
                          "[data-inspector-chapter-secondary]:not([hidden])",
                          "[data-inspector-chapter-notes]:not([hidden])",
                        ]
                      : ["[data-inspector-chapter-primary]:not([hidden])"],
                  r = n
                    .map((t) => e.querySelector(t))
                    .find((e) => e instanceof HTMLElement);
                r instanceof HTMLElement &&
                  (r.classList.remove("is-focused-from-intro"),
                  r.offsetWidth,
                  r.classList.add("is-focused-from-intro"),
                  r.scrollIntoView({
                    block: "nearest",
                    behavior: s ? "auto" : "smooth",
                  }),
                  window.setTimeout(() => {
                    r.classList.remove("is-focused-from-intro");
                  }, 1600));
              }),
            );
          }
          return void (
            t.mobileSheetIsOpen &&
            vt() &&
            Et(e, t, { immediate: !0 })
          );
        }
        const s = n.target.closest("[data-command-center-narrative] a[href]");
        if (s && e.contains(s)) {
          if (!It(s)) return;
          if (Lt(n, s)) return;
          n.preventDefault();
          const r = ((e, t) => {
            const n = ((e, t) => {
              const n = ((e, t) => {
                const n = String(e.dataset.commandCenterInlinePin || "").trim();
                if (n) {
                  const r = Ne(n, t, {
                    kind: "inline",
                    title: String(e.textContent || "").trim(),
                    categoryHints: ["inline narrative"],
                  });
                  if (r) return r.handle;
                }
                const r = String(
                  e.dataset.commandCenterInlineProductHandle || "",
                ).trim();
                if (r) return r;
                const i = It(e);
                return i?.handle || "";
              })(e, t);
              if (!n) return null;
              const r = String(e.textContent || "").trim() || "Linked product",
                i = String(e.dataset.commandCenterInlinePin || "").trim(),
                a = i
                  ? Ne(i, t, {
                      kind: "inline",
                      title: r,
                      categoryHints: ["inline narrative"],
                    })
                  : null,
                o = et(a || { handle: n, url: Xe(n) }, {
                  kind: "inline",
                  title: r,
                  categoryHints: ["inline narrative"],
                });
              return {
                type: "product",
                template: "product",
                title: r,
                meta: "Linked from itinerary copy",
                handle: n,
                url: o,
                displayUrl: o,
                resolutionSource: a?.source || "",
              };
            })(e, t);
            if (n) return n;
            const r = It(e);
            return r
              ? {
                  type: "product",
                  template: "product",
                  title: String(e.textContent || "").trim() || "Linked product",
                  meta: "Linked from itinerary",
                  handle: r.handle,
                  url: r.url,
                  displayUrl: r.url,
                  resolutionSource: "direct-link",
                }
              : null;
          })(s, t.entityResolver);
          if (!r) return;
          const i = ((e, t) => {
            const n = String(t || "").trim();
            if (!n) return "";
            for (const [t, r] of Object.entries(e.cardsById || {}))
              if (r && "product" === r.type && r.handle === n) return t;
            return "";
          })(t, r.handle);
          return i
            ? void (setOverviewTabState(e, ""), Ht(e, t, i))
            : (setOverviewTabState(e, ""),
              xt(e, t, r),
              void (t.mobileSheet && qt(e, t)));
        }
        const l = n.target.closest("[data-command-center-action-url]");
        if (l && e.contains(l) && !l.hasAttribute("data-command-center-card-id")) {
          const r = String(l.dataset.commandCenterActionUrl || "").trim();
          if (!r) return;
          n.preventDefault();
          window.location.assign(r);
          return;
        }
        const d = n.target.closest("[data-command-center-card-id]");
        d &&
          e.contains(d) &&
          (n.target.closest("a[href]") ||
            (n.preventDefault(),
            setOverviewTabState(e, ""),
            Ht(e, t, d.dataset.commandCenterCardId)));
      }),
        e.addEventListener("keydown", (n) => {
          if ("Escape" === n.key && mt())
            return (n.preventDefault(), void ut());
          if ("Escape" === n.key && t.mobileSheetIsOpen)
            return (n.preventDefault(), void Et(e, t, { restoreFocus: !0 }));
          if ("Tab" === n.key && t.mobileSheetIsOpen && t.mobileSheet) {
            const e = t.mobileSheet.querySelectorAll(
              'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
            );
            if (e.length > 0) {
              const t = e[0],
                r = e[e.length - 1],
                i = document.activeElement;
              n.shiftKey && i === t
                ? (n.preventDefault(),
                  r instanceof HTMLElement && r.focus({ preventScroll: !0 }))
                : n.shiftKey ||
                  i !== r ||
                  (n.preventDefault(),
                  t instanceof HTMLElement && t.focus({ preventScroll: !0 }));
            }
          }
          const i = n.target.closest("[data-command-center-journey-tab]");
          if (i && e.contains(i)) {
            const t = String(n.key || "").trim();
            if (
              ["ArrowRight", "ArrowLeft", "Home", "End"].includes(t)
            ) {
              n.preventDefault();
              const r = i.closest("[data-command-center-journey-tablist]");
              if (r) {
                const a = Array.from(
                  r.querySelectorAll("[data-command-center-journey-tab]"),
                ).filter((e) => e instanceof HTMLElement);
                if (a.length > 0) {
                  const r = a.indexOf(i),
                    o =
                      "Home" === t
                        ? 0
                        : "End" === t
                          ? a.length - 1
                          : "ArrowLeft" === t
                            ? (r - 1 + a.length) % a.length
                            : (r + 1) % a.length,
                    c = a[o];
                  c instanceof HTMLElement &&
                    (c.focus({ preventScroll: !0 }), c.click());
                }
              }
            }
          }
          const r = n.target.closest("[data-command-center-card-id]");
          r &&
            e.contains(r) &&
            (("Enter" !== n.key && " " !== n.key && "Spacebar" !== n.key) ||
              (n.preventDefault(),
              Ht(e, t, r.dataset.commandCenterCardId, {
                focusSelectedCard: !0,
              })));
        }),
        t.narrativePane &&
          t.narrativePane.addEventListener(
            "scroll",
            () => {
              Ft(e, t);
            },
            { passive: !0 },
          ));
      const n = e.querySelector("[data-command-center-scroll-wrapper]");
      (n &&
        n.addEventListener(
          "scroll",
          () => {
            vt() || Ft(e, t);
          },
          { passive: !0 },
        ),
        window.addEventListener(
          "scroll",
          () => {
            kt(t) || Ft(e, t);
          },
          { passive: !0 },
        ),
        window.addEventListener("resize", () => {
          (wt(e),
            (t.anchorEntries = Mt(e)),
            jt(e, t),
            at(e),
            vt() || Et(e, t, { immediate: !0 }),
            Ot(e, t));
        }));
    },
    Gt = (e, t) => {
      const n = e.querySelector("[data-command-center-hero-booking]");
      if (n) {
        const e = n.querySelector("[data-inspector-booking-base-price]"),
          r = n.querySelector(".itin-command-center__booking-price-row span"),
          i = n.querySelector("[data-inspector-booking-total-price-line]");
        e && (e.textContent = "—");
        r && (r.textContent = "Pricing unavailable");
        i && ((i.textContent = ""), (i.hidden = !0));
      }
      const r = e.querySelector("[data-command-center-narrative-body]");
      r &&
        (r.innerHTML = ((e) => {
          const t = ["itin-command-center__card"];
          (e.editorial && t.push("itin-command-center__card--editorial"),
            e.status && t.push("itin-command-center__card--status"),
            e.selectable && t.push("itin-command-center__card--clickable"));
          const n = { "data-card-kind": e.kind, ...(e.dataset || {}) };
          e.selectable &&
            ((n["data-command-center-card-id"] = e.id),
            (n["data-command-center-card-day-key"] = e.dayKey),
            (n["data-command-center-card-day-number"] = e.dayNumber));
          const r = Be(n),
            i = e.selectable
              ? ' role="button" tabindex="0" aria-pressed="false"'
              : "",
            a = (() => {
              const t = String(e.copyHtml || "").trim();
              if (!t) return "";
              const n = ce(t);
              return !n || n.length <= 240
                ? t
                : `<p>${b(`${n.slice(0, 236).trim()}...`)}</p>`;
            })(),
            o = e.meta
              ? `<p class="itin-command-center__card-meta">${b(e.meta)}</p>`
              : "",
            c = a
              ? `<div class="itin-command-center__card-copy" data-pin-links>${a}</div>`
              : "";
          return `\n        <article class="${t.join(" ")}"${r}${i}>\n          <div class="itin-command-center__card-body">\n            <p class="itin-command-center__ui-label">${b(e.label)}</p>\n            <h3 class="itin-command-center__card-title">${b(e.title)}</h3>\n            ${o}\n            ${c}\n          </div>\n        </article>\n      `;
        })({
          kind: "status",
          label: "Command center status",
          title: "Canonical timeline unavailable",
          copyHtml: `<p>${b(t)}</p>`,
          status: !0,
        }));
      const i = e.querySelector("[data-command-center-sidebar-body]");
      i &&
        (i.innerHTML = `\n          <div class="itin-command-center__nav-group">\n            <p class="itin-command-center__ui-label">Command center</p>\n            <p class="itin-command-center__card-copy">${b(t)}</p>\n          </div>\n        `);
      const a = e.querySelector("[data-command-center-inspector-body]");
      a &&
        (a.innerHTML = `\n          <article class="itin-command-center__card itin-command-center__card--status">\n            <p class="itin-command-center__ui-label">Inspector status</p>\n            <h3 class="itin-command-center__day-title">Details unavailable</h3>\n            <p class="itin-command-center__card-copy">${b(t)}</p>\n          </article>\n        `);
      const o = e.querySelector("[data-command-center-mobile-sheet-body]");
      o &&
        (o.innerHTML = `\n          <article class="itin-command-center__card itin-command-center__card--status">\n            <p class="itin-command-center__ui-label">Inspector status</p>\n            <h3 class="itin-command-center__day-title">Details unavailable</h3>\n            <p class="itin-command-center__card-copy">${b(t)}</p>\n          </article>\n        `);
    },
    Wt = async (n) => {
      (((t) => {
        const n = t.querySelector("[data-command-center-theme-toggle]");
        if (!n) return;
        const r = localStorage.getItem(e) || "light";
        (Se(t, r),
          n.addEventListener("click", () => {
            const n =
                "dark" == ("dark" === t.dataset.theme ? "dark" : "light")
                  ? "light"
                  : "dark",
              r = t.querySelector("[data-command-center-mode-flash]");
            (r &&
              (r.classList.add("is-active"),
              window.setTimeout(() => {
                r.classList.remove("is-active");
              }, 140)),
              localStorage.setItem(e, n),
              Se(t, n));
          }));
      })(n),
        ((e) => {
          const t = e.querySelector("[data-command-center-hero]"),
            n = e.querySelector("[data-command-center-workspace]"),
            r = e.querySelector("[data-command-center-scroll-wrapper]"),
            i = t ? t.querySelector(".itin-command-center__hero-video") : null,
            a = window.matchMedia("(prefers-reduced-motion: reduce)"),
            o = {
              heroHeight: 0,
              isColumnsUnlocked: !1,
              lockToColumns: () => {},
              unlockToHero: () => {},
              ensureColumnsUnlocked: (e) => {
                "function" == typeof e && e();
              },
            };
          e.commandCenterScrollPhaseController = o;
          const c = () => Boolean(t && n && r) && !vt(),
            s = (t) => {
              (e.classList.toggle("is-workspace-scroll-unlocked", t),
                e.classList.toggle("is-workspace-scroll-locked", !t),
                (o.isColumnsUnlocked = t));
            },
            l = () => (
              (o.heroHeight = t
                ? Math.max(0, Math.round(t.getBoundingClientRect().height))
                : 0),
              o.heroHeight
            ),
            d = () => {
              if (!t) return void e.classList.remove("is-hero-condensed");
              const n = Math.max(44, 0.24 * l()),
                i = r ? r.scrollTop : 0,
                a = window.scrollY || document.documentElement.scrollTop || 0,
                o = c() ? i : a;
              e.classList.toggle("is-hero-condensed", o >= n);
            },
            m = () => {
              if (!i) return;
              if (a.matches) return void i.pause();
              const e = i.play();
              e && "function" == typeof e.catch && e.catch(() => {});
            };
          ((o.lockToColumns = () => {
            if (!c())
              return (s(!0), void (r && (r.style.overflowY = "visible")));
            const e = l();
            (s(!0), (r.style.overflowY = "hidden"), (r.scrollTop = e));
          }),
            (o.unlockToHero = () => {
              if (!c())
                return (s(!0), void (r && (r.style.overflowY = "visible")));
              (s(!1), (r.style.overflowY = "auto"));
            }),
            (o.ensureColumnsUnlocked = (e) => {
              if (!c() || o.isColumnsUnlocked)
                return void ("function" == typeof e && e());
              o.lockToColumns();
              const t = window.matchMedia(
                "(prefers-reduced-motion: reduce)",
              ).matches;
              window.setTimeout(
                () => {
                  "function" == typeof e && e();
                },
                t ? 0 : 320,
              );
            }));
          const u = () => {
            if (!t || !n || !r) return (s(!0), void d());
            if (!c()) return ((r.style.overflowY = "visible"), s(!0), void d());
            const e = l();
            (o.isColumnsUnlocked
              ? ((r.style.overflowY = "hidden"),
                r.scrollTop !== e && (r.scrollTop = e))
              : ((r.style.overflowY = "auto"),
                r.scrollTop >= e ? o.lockToColumns() : s(!1)),
              d());
          };
          (m(),
            u(),
            r && r.addEventListener("scroll", u, { passive: !0 }),
            n &&
              n.addEventListener(
                "wheel",
                (t) => {
                  if (!r || !c() || t.ctrlKey) return;
                  const n =
                    t.target instanceof Element
                      ? t.target.closest(
                          ".itin-command-center__workspace-pane, [data-command-center-inspector-detail]",
                        )
                      : null;
                  if (!(n instanceof HTMLElement && e.contains(n))) return;
                  const i = Number(t.deltaY);
                  return !Number.isFinite(i) || Math.abs(i) < 0.01
                    ? void 0
                    : o.isColumnsUnlocked
                      ? void (
                          i < 0 &&
                          n.scrollTop <= 0 &&
                          (t.preventDefault(),
                          o.unlockToHero(),
                          r.scrollBy({ top: i, behavior: "auto" }),
                          u())
                        )
                      : (t.preventDefault(),
                        r.scrollBy({ top: i, behavior: "auto" }),
                        void u());
                },
                { passive: !1 },
              ),
            window.addEventListener("scroll", d, { passive: !0 }),
            window.addEventListener("resize", u),
            "function" == typeof a.addEventListener
              ? a.addEventListener("change", m)
              : "function" == typeof a.addListener && a.addListener(m));
        })(n));
      const r = String(n.dataset.canonicalJsonUrl || "").trim(),
        i = String(n.dataset.fallbackJsonUrl || "").trim(),
        a = String(n.dataset.itineraryIdentifier || "").trim(),
        o = ee(n.dataset.pinMap, {}),
        c = ee(n.dataset.componentProductCandidates, []),
        s = ((e) => {
          const t = {},
            n = {};
          for (const [r, i] of Object.entries(e || {})) {
            const e = String(r || "").trim();
            if (!e) continue;
            if ("string" == typeof i) {
              t[e] = i;
              continue;
            }
            if (!i || "object" != typeof i) continue;
            "string" == typeof i.status && (t[e] = i.status);
            const a = [
              i.handle,
              i.product_handle,
              i.productHandle,
              i.resolved_handle,
              i.resolvedHandle,
              i.slug,
            ].find((e) => "string" == typeof e && "" !== e.trim());
            a && (n[e] = String(a).trim());
          }
          return { statusByPin: t, handleByPin: n };
        })(ee(n.dataset.linkManifest, {})),
        l = Ie({
          rootProductHandle: String(n.dataset.productHandle || "").trim(),
          pinMap: o,
          componentCandidates: c,
          manifest: s,
        });
      // Fetch itinerary data directly from database via app proxy
      // CDN URLs are no longer used (PII privacy - itinerary data stored in database only)
      let d = await (async (e) => {
        const t = String(e || "").trim();
        if (!t) return null;
        try {
          const e = new URL(
            "/apps/plekify/api/itinerary",
            window.location.origin,
          );
          e.searchParams.set("identifier", t);
          e.searchParams.set("v", String(Date.now()));
          const n = await fetch(e.toString(), {
            cache: "no-store",
            credentials: "omit",
          });
          if (!n.ok) return null;
          const r = await n.json();
          // App proxy returns { success: true, data: { itinerary: {...} } }
          return r?.success && r?.data?.itinerary ? r.data.itinerary : null;
        } catch (e) {
          return null;
        }
      })(a);
      if (!d)
        return void Gt(
          n,
          "Canonical and fallback itinerary feeds could not be loaded.",
        );
      const m = Ue(d, l);
      if (!m || 0 === m.days.length)
        return void Gt(
          n,
          "Itinerary feed loaded, but no day records were available to render.",
        );
      (n.commandCenterState || (n.commandCenterState = {}),
        (n.commandCenterState.entityResolver = l),
        ((e, t) => {
          const n = e.querySelector("[data-command-center-sidebar-body]");
          if (!n) return;
          let r = "";
          for (const e of t.legs) {
            const n = t.days.filter((t) => t.legIndex === e.index);
            if (0 === n.length) continue;
            const { destinationLine: i, detailLine: a, nightsLabel: sideNightsLabel } = Fe(e, n),
              o = `command-center-leg-days-${e.index}`;
            ((r += `<div class="itin-command-center__nav-group" data-command-center-nav-leg-index="${e.index}" data-command-center-leg-group>`),
              (r += `\n          <div class="itin-command-center__nav-leg-line">\n            <span class="itin-command-center__nav-leg-destination-label">${b(i)} \u00B7 ${b(sideNightsLabel)}</span>\n          </div>\n          <div class="itin-command-center__nav-leg-days" id="${o}" data-command-center-leg-days>\n        `));
            for (const e of n) {
              const t = String(e.weekdayShort || "DAY").trim() || "DAY",
                n =
                  String(e.dayOfMonth || "").trim() ||
                  String(e.dayNumber).padStart(2, "0"),
                i = String(e.monthShort || "").trim() || "TBD",
                a = String(e.year || "").trim(),
                o =
                  w(e.dayNumber, 0) ||
                  w(String(e.dayLabel || "").replace(/[^\d]/g, ""), 0),
                c = o > 0 ? `DAY ${String(o).padStart(2, "0")}` : "DAY --",
                s = $(e.sourceDayTitle || e.title) || e.dayLabel,
                l = String(
                  e.accommodationName || e.destinationName || "",
                ).trim(),
                d = `${c} · ${`${t} ${n} ${i}${a ? ` ${a}` : ""}`.trim()}`,
                m = l
                  ? `<span class="itin-command-center__nav-card-property-line">${b(l)}</span>`
                  : "";
              r += `\n            <button\n              type="button"\n              class="itin-command-center__nav-card"\n              data-command-center-nav-target="command-center-${e.dayKey}"\n              data-command-center-nav-key="${e.dayKey}"\n              data-command-center-nav-autoload="day-first-card"\n            >\n              <span class="itin-command-center__nav-card-date">${d}</span>\n              <span class="itin-command-center__nav-card-title">${b(s)}</span>\n              ${m}\n            </button>\n          `;
            }
            r += "</div></div>";
          }
          n.innerHTML = r;
        })(n, m),
        ((e, n) => {
          const r = e.querySelector("[data-command-center-narrative-body]");
          if (!r) return;
          let i = ((e) => {
            const m = e?.itinerary?.journeyDna || {},
              cfsData = e?.itinerary?.clientFacingSummary || {},
              badgesSrc = (cfsData.journeyDnaBadges && cfsData.journeyDnaBadges.length > 0)
                ? cfsData.journeyDnaBadges
                : (m.badges && m.badges.length > 0 ? m.badges : []),
              threadNames = (() => {
                const e = [],
                  t = new Set(),
                  n = []
                    .concat(
                      Array.isArray(badgesSrc)
                        ? badgesSrc.map((e) => Y(e?.name || "")).filter(Boolean)
                        : [],
                    )
                    .concat(
                      Array.isArray(m.priorities)
                        ? m.priorities.map((e) => Y(e?.label || "")).filter(Boolean)
                        : [],
                    );
                for (const r of n) {
                  const n = r.toLowerCase();
                  if (t.has(n)) continue;
                  t.add(n);
                  e.push(r);
                  if (e.length >= 5) break;
                }
                return e;
              })(),
              badgesHtml = threadNames.length > 0 ? `
        <p class="itin-command-center__journey-badges" aria-label="Journey themes">
          ${threadNames.map((e) => `
            <span class="itin-command-center__journey-badge">
              <span class="itin-command-center__journey-badge-name">${b(e)}</span>
            </span>
          `).join("")}
        </p>
      ` : "",
              noteGroups = [
                Array.isArray(m.priorities) && m.priorities.length > 0
                  ? {
                      label: "Journey priorities",
                      value: m.priorities
                        .map((e) => Y(e?.label || ""))
                        .filter(Boolean)
                        .slice(0, 3)
                        .join(" · "),
                    }
                  : null,
                Array.isArray(m.standards) && m.standards.length > 0
                  ? {
                      label: "Travel design",
                      value: m.standards
                        .map((e) => Y(e?.label || ""))
                        .filter(Boolean)
                        .slice(0, 2)
                        .join(" · "),
                    }
                  : null,
              ].filter((e) => e && e.value),
              notesHtml = noteGroups.length > 0
                ? `
        <div class="itin-command-center__intro-pill-groups">
          ${noteGroups.map((e) => `
            <div class="itin-command-center__intro-pill-group">
              <span class="itin-command-center__intro-pill-group-label">${b(e.label)}:</span>
              <span class="itin-command-center__intro-pill-inline">${b(e.value)}</span>
            </div>
          `).join("")}
        </div>
      `
                : "",
              u = `${badgesHtml}${notesHtml}`,
              p = [];
            for (const t of e.legs || []) {
              const n = (e.days || []).filter((e) => e.legIndex === t.index);
              if (0 === n.length) continue;
              const {
                  firstDay: r,
                  destinationLine: i,
                  nightsLabel: a,
                } = Fe(t, n),
                o = [a, Ge(n)].filter(Boolean).join(" · "),
                c = Y(t.tagline || "").trim();
              r?.dayKey &&
                (() => {
                  const d = String(e?.dayToDestinationCardId?.[r.dayKey] || "").trim(),
                    u = String(e?.dayToPropertyCardId?.[r.dayKey] || "").trim(),
                    h = String(e?.dayToLocationCardId?.[r.dayKey] || "").trim(),
                    g2 = e?.dayToPropertyPayload?.[r.dayKey] || null,
                    y2 = e?.dayToLocationPayload?.[r.dayKey] || null,
                    g = String(t.accommodationName || "").trim(),
                    y = String(g2?.title || g || "Property").trim() || "Property",
                    v = String(t.destinationName || i || y2?.title || "Location").trim() || "Location",
                    m2 = String(t.type || "").trim().toLowerCase(),
                    C2 = "departure" === m2,
                    P2 = y2 && _e(String(y2.title || "").trim()) !== _e(y) ? String(y2.title || "").trim() : "",
                    k2 = (() => {
                      if (!C2) return v;
                      const e = v.replace(/\bInternational(?:\s+Airport)?\b/gi, "").replace(/\bAirport\b/gi, "").replace(/\s{2,}/g, " ").trim();
                      return e || v;
                    })(),
                    S2 = C2 && _e(k2) !== _e(v) ? v : "",
                    b2 = String(g2?.featuredImage || t.propertyProductImage || "").trim(),
                    x2 = [o, c].filter(Boolean).join(" · "),
                    m = `data-command-center-nav-target="command-center-leg-${t.index + 1}"\n                    data-command-center-nav-key="${r.dayKey}"\n                    data-command-center-nav-autoload="leg-start"`,
                    C = !C2 && (Boolean(g) || Boolean(u) || Boolean(y)),
                    P = Boolean(k2) && (C2 || _e(k2) !== _e(y) || Boolean(h) || Boolean(d) || !C),
                    k = [
                      C
                        ? `
                  <button
                    type="button"
                    class="itin-command-center__intro-leg-action itin-command-center__intro-leg-action--stay"
                    ${m}
                    data-command-center-inspector-focus="stay"
                  >
                    ${b2 ? `<span class="itin-command-center__intro-leg-action-media"><img src="${b(b2)}" alt="${b(y)}" loading="lazy" width="112" height="63"></span>` : ""}
                    <span class="itin-command-center__intro-leg-action-copy">
                      <span class="itin-command-center__intro-leg-action-label">Property</span>
                      <span class="itin-command-center__intro-leg-action-title">${b(y)}</span>
                    </span>
                  </button>
                `
                        : "",
                      P
                        ? `
                  <button
                    type="button"
                    class="itin-command-center__intro-leg-action itin-command-center__intro-leg-action--destination${C ? "" : " itin-command-center__intro-leg-action--solo"}"
                    ${m}
                    ${h || d ? 'data-command-center-inspector-focus="location"' : ""}
                  >
                    <span class="itin-command-center__intro-leg-action-copy">
                      <span class="itin-command-center__intro-leg-action-label">${C2 ? "Departure" : "Location"}</span>
                      <span class="itin-command-center__intro-leg-action-title">${b(k2)}</span>
                      ${(P2 || S2) ? `<span class="itin-command-center__intro-leg-action-meta">${b(P2 || S2)}</span>` : ""}
                    </span>
                    <span class="itin-command-center__intro-leg-action-glyph" aria-hidden="true">${C2 ? "↗" : "⌁"}</span>
                  </button>
                `
                        : "",
                    ]
                      .filter(Boolean)
                      .join("");
                  p.push(
                    `\n          <div\n            class="itin-command-center__intro-leg-wrapper${0 === t.index ? " is-active-leg" : ""}"\n            data-command-center-intro-leg-index="${t.index}"\n            data-command-center-intro-leg-key="${r.dayKey}"\n            aria-current="${0 === t.index ? "true" : "false"}"\n          >\n            <div class="itin-command-center__intro-leg-meta">\n              <span class="itin-command-center__intro-leg-number">Leg ${t.index + 1}</span>\n              ${x2 ? `<span class="itin-command-center__intro-leg-detail">${b(x2)}</span>` : ""}\n            </div>\n            ${k ? `<div class="itin-command-center__intro-leg-actions">${k}</div>` : ""}\n          </div>\n        `,
                  );
                })();
            }
            const g =
              p.length > 0
                ? `<div class="itin-command-center__intro-leg-list">${p.join("")}</div>`
                : '<p class="itin-command-center__intro-empty">Leg overview is unavailable for this itinerary.</p>';
            const itinName = b(e?.itinerary?.name || "Your Journey");
            const clientName = b(e?.itinerary?.quickReference?.client || "");
            const introHtml = e?.itinerary?.introductionHtml || e?.itinerary?.summaryHtml || "";
            const dayCount = w(e?.itinerary?.days, e?.days?.length || 0);
            const legCount = w(e?.itinerary?.legs, e?.legs?.length || 0);
            const routeCount = w(e?.itinerary?.routes, 0);
            const stopCount = w(
              e?.itinerary?.selectableStops,
              Object.keys(e?.cardsById || {}).length,
            );
            const introMeta = [String(e?.locationLine || "").trim(), String(e?.dayCountLine || "").trim()]
              .filter(Boolean)
              .join(" · ");
            const introStats = [
                dayCount > 0 ? `${dayCount} days` : "",
                legCount > 0 ? `${legCount} legs` : "",
                routeCount > 0 ? `${routeCount} routes` : "",
                stopCount > 0 ? `${stopCount} stops` : "",
              ]
                .filter(Boolean)
                .join(" · ");
            const welcomeSection = `
        <div class="itin-command-center__welcome">
          <p class="itin-command-center__intro-kicker">${itinName}</p>
          <h2 class="itin-command-center__welcome-heading">${clientName ? `Welcome, ${clientName}` : "Welcome to Your Journey"}</h2>
          ${introMeta ? `<p class="itin-command-center__intro-meta-line">${b(introMeta)}</p>` : ""}
          ${introHtml ? `<div class="itin-command-center__welcome-intro">${introHtml}</div>` : ""}
        </div>
      `;
            return `\n        <section\n          class="itin-command-center__intro"\n          id="command-center-overview"\n          data-command-center-intro\n          data-command-center-anchor="${t}"\n        >\n          ${welcomeSection}\n          ${introStats ? `<p class="itin-command-center__intro-summary-line" aria-label="Journey summary">${b(introStats)}</p>` : ""}\n          ${u}\n          ${g}\n        </section>\n      `;
          })(n);
          for (const e of n.days) {
            const t = n.legs[e.legIndex] || null,
              r = Boolean(t && w(t.startDay, 0) === e.dayNumber),
              a = Oe(e),
              o = ["itin-command-center__day-section"];
            r && o.push("itin-command-center__day-section--leg-start");
            let c = "";
            r &&
              t &&
              (c = `\n            <span\n              class="itin-command-center__leg-anchor"\n              id="command-center-leg-${t.index + 1}"\n              data-command-center-first-day-key="${e.dayKey}"\n            ></span>\n          `);
            const s = "",
            l = [b(e.dayLabel), String(e.dateLabel || "").trim()]
              .filter(Boolean)
              .join(" · "),
            d = String(e.title || e.destinationName || e.dayLabel).trim(),
            dayNum = String(e.dayNumber || "").padStart(2, "0"),
            dayHeadingText = d && _e(d) !== _e(e.dayLabel)
              ? `Day ${dayNum} \u00B7 ${d}`
              : `Day ${dayNum}`,
            m = `<h3 class="itin-command-center__day-section-title">${b(dayHeadingText)}</h3>`,
            rawNarrative = String(e.narrativeDisplayHtml || "").trim(),
            narrativeFallback = !rawNarrative ? String(e.notesHtml || "").trim() : "",
            narrativeContent = rawNarrative || narrativeFallback,
            narrativeSanitized = le(narrativeContent),
            narrativeClean = narrativeSanitized.replace(/<[^>]+>/g, '').trim(),
            isTemplateStub = narrativeClean.length < 200 && /cadence\s+centered\s+on/i.test(narrativeClean),
            finalNarrative = isTemplateStub ? '' : narrativeSanitized,
            p = finalNarrative
              ? `<div class="itin-command-center__day-narrative" data-pin-links>${finalNarrative}</div>`
              : "",
              fmtBasis = (v) => {
                const s = String(v || "").trim();
                if (!s || "None" === s || "NotProvided" === s) return "";
                return s.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/And/g, "&").replace(/\b\w/g, c => c.toUpperCase());
              },
              basisParts = [fmtBasis(e.roomBasis), fmtBasis(e.drinksBasis)].filter(Boolean),
              basisLine = basisParts.length > 0
                ? `<p class="itin-command-center__day-basis">${b(basisParts.join(" · "))}</p>`
                : "",
              inclText = ce(String(e.includedHtml || "")).trim(),
              inclLine = inclText
                ? `<p class="itin-command-center__day-included"><span class="itin-command-center__day-included-label">Includes:</span> ${b(inclText)}</p>`
                : "",
              exclText = ce(String(e.excludedHtml || "")).trim(),
              exclLine = exclText
                ? `<p class="itin-command-center__day-excluded"><span class="itin-command-center__day-excluded-label">Excludes:</span> ${b(exclText)}</p>`
                : "",
              dayMeta = [basisLine, inclLine, exclLine].filter(Boolean).join(""),
              dayMetaBlock = dayMeta
                ? `<div class="itin-command-center__day-period-meta">${dayMeta}</div>`
                : "";
            i += `\n          ${c}\n          <section class="${o.join(" ")}" id="command-center-${e.dayKey}" data-command-center-anchor="${e.dayKey}" data-command-center-leg-index="${e.legIndex}">\n            <header class="itin-command-center__day-header">\n              <p class="itin-command-center__day-meta-line">${b(l)}</p>\n              ${m}\n            </header>\n            ${p}\n            ${dayMetaBlock}\n            ${a}\n            ${s}\n          </section>\n        `;
          }
          r.innerHTML = i;
        })(n, m),
        ((e, t) => {
          const n = e.querySelector("[data-command-center-mobile-track]");
          if (!n) return;
          let r = "";
          for (let e = 0; e < t.days.length; e += 1) {
            const n = t.days[e];
            r += `\n          <button\n            type="button"\n            class="itin-command-center__mobile-pill${0 === e ? " is-active" : ""}"\n            data-command-center-nav-target="command-center-${n.dayKey}"\n            data-command-center-pill-key="${n.dayKey}"\n            data-command-center-nav-autoload="day-first-card"\n          >\n            ${b(n.dayLabel)}\n          </button>\n        `;
          }
          n.innerHTML = r;
        })(n, m),
        ((e, t) => {
          const n = e.querySelector("[data-command-center-hero-locations]"),
            r = e.querySelector("[data-command-center-hero-days]");
          if (!n || !r) return;
          const i = String(t?.locationLine || "").trim(),
            a = String(t?.dayCountLine || "").trim();
          ((n.textContent = i || "--"), (r.textContent = a || "-- days"));
        })(n, m.hero));
      const u = String(n.dataset.productHandle || "").trim(),
        p = Xe(u),
        g = {
          type: "landing",
          template: "default-detail",
          title: m.itinerary.name || "Reservation control panel",
          ...(m.defaultInspectorPayload || {}),
          handle: u,
          url: p,
          displayUrl: p,
        },
        y = ((e, t) => ({ overview: t, participants: We(e), pricing: Ye(e) }))(m, g);
      (((e, t, n) => {
        const r = e.querySelector("[data-command-center-hero-booking]");
        if (!r) return;
        const m = t?.itinerary?.participants || {},
          p = t?.itinerary?.pricing || {},
          priceEl = r.querySelector("[data-inspector-booking-base-price]"),
          contextEl = r.querySelector(".itin-command-center__booking-price-row span"),
          totalEl = r.querySelector("[data-inspector-booking-total-price-line]"),
          partyTotal = w(m.total, 0) > 0 ? w(m.total, 1) : 1,
          cur = p.currency || "USD",
          fmtBookingPrice = (v) => J(v, cur);
        if (priceEl) {
          priceEl.textContent =
            z(p.totalInvestment, 0) > 0
              ? fmtBookingPrice(z(p.totalInvestment, 0))
              : "—";
        }
        if (contextEl) {
          contextEl.textContent =
            z(p.totalInvestment, 0) > 0
              ? partyTotal > 1
                ? `for ${partyTotal} guests`
                : "journey investment"
              : "pricing on request";
        }
        if (totalEl) {
          totalEl.textContent = "";
          totalEl.hidden = !0;
        }
      })(n, m, g),
        wt(n));
      const f = String(m.days[0]?.dayKey || "").trim(),
        h = Mt(n),
        S = h.some((e) => e.key === t),
        v = {
          activeDay: f || (S ? t : ""),
          activeCard: "",
          activeInspectorPayload: null,
          activeInspectorPayloadKey: "",
          defaultInspectorPayload: g,
          overviewInspectorPayloads: y,
          overviewKey: t,
          firstDayKey: f,
          entityResolver: l,
          itineraryDays: m.days || [],
          itineraryLegs: m.legs || [],
          cardsById: m.cardsById || {},
          mapboxToken: String(n.dataset.mapboxToken || "").trim(),
          mapboxStyle: String(n.dataset.mapboxStyle || "").trim(),
          componentMapCoordIndex: v2GetInspectorMapCoordIndex(n),
          legStartCardByDayKey: m.legStartCardByDayKey || {},
          dayToLegIndex: m.days.reduce(
            (e, t) => ((e[t.dayKey] = t.legIndex), e),
            {},
          ),
          anchorEntries: h,
          anchorObserver: null,
          observedAnchorEntries: new Map(),
          observedActiveDay: "",
          sidebarPane: n.querySelector("[data-command-center-sidebar]"),
          narrativePane: n.querySelector("[data-command-center-narrative]"),
          narrativePaneHeader: n.querySelector(
            "[data-command-center-narrative] .itin-command-center__pane-header",
          ),
          mobileSheet: n.querySelector("[data-command-center-mobile-sheet]"),
          navScrollTimer: 0,
          scrollFrameRequest: 0,
          mobileSheetCloseTimer: 0,
          mobileSheetIsOpen: !1,
          mobileSheetLastFocus: null,
          isProgrammaticScroll: !1,
          desktopInspectorDetail: null,
          controlBarResizeObserver: null,
          scrollPhaseController: n.commandCenterScrollPhaseController || null,
        };
      ((n.commandCenterState = v),
        buildDayInspectorMappings(v),
        ((e) => {
          const t = e.querySelector("[data-command-center-inspector-body]");
          if (!(t instanceof HTMLElement) || !t.id) return;
          const n = Array.from(
            e.querySelectorAll("[data-command-center-journey-tab]"),
          );
          n.forEach((e, n) => {
            if (!(e instanceof HTMLElement)) return;
            e.id || (e.id = `command-center-journey-tab-${n + 1}`);
            e.setAttribute("aria-controls", t.id);
          });
        })(n),
        ((e, t) => {
          if (!t) return;
          t.controlBarResizeObserver &&
            (t.controlBarResizeObserver.disconnect(),
            (t.controlBarResizeObserver = null));
          const n = e.querySelector("[data-command-center-hero-panel]");
          if (!n || !("ResizeObserver" in window)) return;
          const r = new ResizeObserver(() => {
            (wt(e), (t.anchorEntries = Mt(e)), jt(e, t), Ft(e, t));
          });
          (r.observe(n), (t.controlBarResizeObserver = r));
        })(n, v),
        ((e, t) => {
          if (!t || "landing" !== t.type) return;
          const n = e.querySelector("[data-command-center-hero-booking]");
          n && bt(e, t, n);
        })(n, v.defaultInspectorPayload));
      const _ = n.querySelector("[data-command-center-inspector-body]"),
        initialRenderOptions = {};
      if (_) {
        let e = !1;
        const t = () => {
          e ||
            ((e = !0),
            n.classList.remove("is-initial-inspector-hydrating"),
            _.removeAttribute("aria-busy"));
        };
        (_.setAttribute("aria-busy", "true"),
          n.classList.add("is-initial-inspector-hydrating"),
          (initialRenderOptions.showProductLoadingState = !1),
          (initialRenderOptions.onInspectorRendered = t),
          (initialRenderOptions.onProductContentSettled = t));
      }
      (Nt(n, ""), Kt(n, v), jt(n, v), Ve(n, v.activeDay), Ot(n, v));
      const initialOverviewPayload =
        defaultDayInspectorPayload(v, v.activeDay) ||
        (v.overviewInspectorPayloads && v.overviewInspectorPayloads.overview) ||
        v.defaultInspectorPayload;
      if (initialOverviewPayload) {
        xt(n, v, initialOverviewPayload, { force: !0, ...initialRenderOptions });
        setOverviewTabState(n, "overview");
      } else {
        xt(n, v, v.defaultInspectorPayload, {
          force: !0,
          ...initialRenderOptions,
        });
      }
      const collapsedStrip = n.querySelector("[data-command-center-inspector-collapsed-strip]");
      if (collapsedStrip) {
        collapsedStrip.addEventListener("click", () => {
          const pane = collapsedStrip.closest(".itin-command-center__workspace-pane--right");
          if (pane) {
            pane.classList.remove("is-inspector-collapsed");
            const pp = defaultDayInspectorPayload(v, v.activeDay);
            if (pp) {
              setOverviewTabState(n, "overview");
              xt(n, v, pp, { force: !0 });
            }
          }
        });
      }
    },
    Yt = (e) => {
      const t = [];
      e instanceof Element &&
        e.matches(".itin-command-center[data-section-id]") &&
        t.push(e);
      const n = e.querySelectorAll(".itin-command-center[data-section-id]");
      for (const e of n) t.push(e);
      for (const e of t)
        "true" !== e.dataset.commandCenterReady &&
          ((e.dataset.commandCenterReady = "true"), Wt(e));
    };
  (!0 === window.__WETU_COMMAND_CENTER_TEST_MODE__ &&
    (window.__WETU_COMMAND_CENTER_TEST_API__ = {
      createPinLinkRegistry: q,
      createPinLinkContext: H,
      replacePinTokens: ae,
      formatRichText: oe,
      normalizeCardTaglineText: R,
      stripSelfReferentialAnchors: j,
      buildEntityResolver: Ie,
      normalizeCommandCenterModel: Ue,
      renderDayActivityTimeline: Oe,
    }),
    document.addEventListener("DOMContentLoaded", () => {
      Yt(document);
    }),
    document.addEventListener("shopify:section:load", (e) => {
      const t = e.target instanceof Element ? e.target : document;
      Yt(t);
    }));
})();
